/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AbsenceFinalItem = {
  __typename?: 'AbsenceFinalItem';
  absenceId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  createdBy?: Maybe<UserReference>;
  description?: Maybe<Scalars['String']['output']>;
  documentTitle?: Maybe<Scalars['String']['output']>;
  employeeDocumentId?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
  timestamps?: Maybe<TimestampsItem>;
  updateStatusToEndAbsent?: Maybe<Scalars['Boolean']['output']>;
  updatedBy?: Maybe<UserReference>;
  user?: Maybe<UserReference>;
  workCenter?: Maybe<WorkCenter>;
};

export type AccessToken = {
  __typename?: 'AccessToken';
  _id: Scalars['String']['output'];
  accessToken?: Maybe<ApiAccessToken>;
  companyIds: Array<Maybe<Scalars['String']['output']>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  origin: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<TokenPermissions>>>;
  timestamps?: Maybe<TimeStampObj>;
};

export type ActionNotAllowed = {
  __typename?: 'ActionNotAllowed';
  message?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['String']['output']>;
};

export type AddAccessTokenInput = {
  companyIds: Array<InputMaybe<Scalars['String']['input']>>;
  contactEmail: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  origin: Scalars['String']['input'];
  permissions: Array<InputMaybe<PermissionInput>>;
};

export type AddAccessTokenResult = ApiAccessToken | CompanyNotFound | ExternalApiAlreadyExists;

export type AddEmployeesToGroupInput = {
  employeeIds: Array<InputMaybe<Scalars['String']['input']>>;
  groupName: Scalars['String']['input'];
  workCenterId?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AddEmployeesToGroupResult = AddEmployeesToGroupSuccess | ResourceNotFound;

export type AddEmployeesToGroupSuccess = {
  __typename?: 'AddEmployeesToGroupSuccess';
  employeesUpdated?: Maybe<Scalars['Int']['output']>;
};

export type AddEmployeesToRecordChecklistInput = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employeeIdsToExclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  recordChecklistId: Scalars['String']['input'];
  unassignedEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AddEmployeesToRecordChecklistResult = AddEmployeesToRecordChecklistSuccess | ResourceNotFound;

export type AddEmployeesToRecordChecklistSuccess = {
  __typename?: 'AddEmployeesToRecordChecklistSuccess';
  employeesAdded?: Maybe<Scalars['Int']['output']>;
};

export type AddVideoAgreementToDocumentInput = {
  documentId: Scalars['String']['input'];
};

export type AddressData = {
  __typename?: 'AddressData';
  address?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  federalEntity?: Maybe<FederalEntity>;
  internalNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

export type AddressDataInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  colony?: InputMaybe<Scalars['String']['input']>;
  externalNumber?: InputMaybe<Scalars['String']['input']>;
  federalEntity?: InputMaybe<FederalEntityInput>;
  internalNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type AdminDashboardChart = {
  __typename?: 'AdminDashboardChart';
  signed?: Maybe<Scalars['Int']['output']>;
  timestamps?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AdminGenerateEmployeesInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  numOfCartaEmployees: Scalars['Int']['input'];
  numOfCartaEmployeesWOContact: Scalars['Int']['input'];
  numOfSifeEmployees: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  workCenterCode: Scalars['String']['input'];
};

export type AdminGenerateEmployeesResult = {
  __typename?: 'AdminGenerateEmployeesResult';
  file: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type AdminGenerateWcInput = {
  adminOptions?: InputMaybe<AdminOptionsInput>;
  workBookOptions?: InputMaybe<WorkbookOptionsInput>;
};

export type AdminGenerateWcResult = {
  __typename?: 'AdminGenerateWCResult';
  file: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type AdminIncorrectInfo = {
  __typename?: 'AdminIncorrectInfo';
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminItem = {
  __typename?: 'AdminItem';
  _id?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserAndWorkSpaceReferenceTypeDefs>;
};

export type AdminOptionsInput = {
  adminPerCt?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AdminRhAlreadyExists = ErrorMessage & {
  __typename?: 'AdminRhAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminRhPermissions = {
  __typename?: 'AdminRhPermissions';
  rhPodPermissions: AdminRhRhPodPermissions;
};

export type AdminRhPermissionsInput = {
  rhPodPermissions: AdminRhRhPodPermissionsInput;
};

export type AdminRhRhPodPermissions = {
  __typename?: 'AdminRhRhPodPermissions';
  approveDocsFromEmployees: CompanyPermission;
  authorizeTemplates: CompanyPermission;
  companyGroupReports: CompanyPermission;
  dashboard: CompanyPermission;
  documents: CompanyPermission;
  employees: CompanyPermission;
  employeesStatus: CompanyPermission;
  groups: CompanyPermission;
  holidays: CompanyPermission;
  hrAdmins: CompanyPermission;
  legalRepresentative: CompanyPermission;
  publishTemplates: CompanyPermission;
  receipts: CompanyPermission;
  recordChecklist: CompanyPermission;
  requestDocsToEmployees: CompanyPermission;
  signDocuments: CompanyPermission;
  templates: CompanyPermission;
  videoAgreementAuthorizer: CompanyPermission;
  videoAgreementTemplates: CompanyPermission;
  workCenters: CompanyPermission;
  workTitles: CompanyPermission;
};

export type AdminRhRhPodPermissionsInput = {
  approveDocsFromEmployees: CompanyPermissionInput;
  authorizeTemplates: CompanyPermissionInput;
  companyGroupReports: CompanyPermissionInput;
  dashboard: CompanyPermissionInput;
  documents: CompanyPermissionInput;
  employees: CompanyPermissionInput;
  employeesStatus: CompanyPermissionInput;
  groups: CompanyPermissionInput;
  holidays: CompanyPermissionInput;
  hrAdmins: CompanyPermissionInput;
  legalRepresentative: CompanyPermissionInput;
  publishTemplates: CompanyPermissionInput;
  receipts: CompanyPermissionInput;
  recordChecklist: CompanyPermissionInput;
  requestDocsToEmployees: CompanyPermissionInput;
  signDocuments: CompanyPermissionInput;
  templates: CompanyPermissionInput;
  videoAgreementAuthorizer: CompanyPermissionInput;
  videoAgreementTemplates: CompanyPermissionInput;
  workCenters: CompanyPermissionInput;
  workTitles: CompanyPermissionInput;
};

export type AdminRhRhPodUserPermissions = {
  __typename?: 'AdminRhRhPodUserPermissions';
  approveDocsFromEmployees: CompanyUserPermission;
  authorizeTemplates: CompanyUserPermission;
  companyGroupReports: CompanyUserPermission;
  dashboard: CompanyUserPermission;
  documents: CompanyUserPermission;
  employees: CompanyUserPermission;
  employeesStatus: CompanyUserPermission;
  groups: CompanyUserPermission;
  holidays: CompanyUserPermission;
  hrAdmins: CompanyUserPermission;
  legalRepresentative: CompanyUserPermission;
  publishTemplates: CompanyUserPermission;
  receipts: CompanyUserPermission;
  recordChecklist: CompanyUserPermission;
  requestDocsToEmployees: CompanyUserPermission;
  signDocuments: CompanyUserPermission;
  templates: CompanyUserPermission;
  videoAgreementAuthorizer: CompanyUserPermission;
  videoAgreementTemplates: CompanyUserPermission;
  workCenters: CompanyUserPermission;
  workTitles: CompanyUserPermission;
};

export type AdminRhRhPodUserPermissionsInput = {
  approveDocsFromEmployees: CompanyUserPermissionInput;
  authorizeTemplates: CompanyUserPermissionInput;
  companyGroupReports: CompanyUserPermissionInput;
  dashboard: CompanyUserPermissionInput;
  documents: CompanyUserPermissionInput;
  employees: CompanyUserPermissionInput;
  employeesStatus: CompanyUserPermissionInput;
  groups: CompanyUserPermissionInput;
  holidays: CompanyUserPermissionInput;
  hrAdmins: CompanyUserPermissionInput;
  legalRepresentative: CompanyUserPermissionInput;
  publishTemplates: CompanyUserPermissionInput;
  receipts: CompanyUserPermissionInput;
  recordChecklist: CompanyUserPermissionInput;
  requestDocsToEmployees: CompanyUserPermissionInput;
  signDocuments: CompanyUserPermissionInput;
  templates: CompanyUserPermissionInput;
  videoAgreementAuthorizer: CompanyUserPermissionInput;
  videoAgreementTemplates: CompanyUserPermissionInput;
  workCenters: CompanyUserPermissionInput;
  workTitles: CompanyUserPermissionInput;
};

export type AdminRhRoles = {
  __typename?: 'AdminRhRoles';
  permissions: AdminRhPermissions;
};

export type AdminRhRolesInput = {
  permissions: AdminRhPermissionsInput;
};

export type AdminRhUserPermissions = {
  __typename?: 'AdminRhUserPermissions';
  rhPodPermissions: AdminRhRhPodUserPermissions;
};

export type AdminRhUserPermissionsInput = {
  rhPodPermissions: AdminRhRhPodUserPermissionsInput;
};

export enum AdminType {
  MasterAdmin = 'masterAdmin',
  RhAdmin = 'rhAdmin',
  WcAdmin = 'wcAdmin'
}

export type AdminWcPermissions = {
  __typename?: 'AdminWCPermissions';
  rhPodPermissions: AdminWcRhPodPermissions;
};

export type AdminWcPermissionsInput = {
  rhPodPermissions: AdminWcRhPodUserPermissionsInput;
};

export type AdminWcRhPodPermissions = {
  __typename?: 'AdminWCRhPodPermissions';
  approveDocsFromEmployees: CompanyPermission;
  authorizeTemplates: CompanyPermission;
  ctAdmins: CompanyPermission;
  dashboard: CompanyPermission;
  documents: CompanyPermission;
  employees: CompanyPermission;
  employeesStatus: CompanyPermission;
  groups: CompanyPermission;
  holidays: CompanyPermission;
  publishTemplates: CompanyPermission;
  receipts: CompanyPermission;
  recordChecklist: CompanyPermission;
  requestDocsToEmployees: CompanyPermission;
  signDocuments: CompanyPermission;
  templates: CompanyPermission;
  videoAgreementAuthorizer: CompanyPermission;
  videoAgreementTemplates: CompanyPermission;
  workCenters: CompanyPermission;
  workTitles: CompanyPermission;
};

export type AdminWcRhPodPermissionsInput = {
  ctAdmins: CompanyPermissionInput;
  dashboard: CompanyPermissionInput;
  documents: CompanyPermissionInput;
  employees: CompanyPermissionInput;
  employeesStatus: CompanyPermissionInput;
  receipts: CompanyPermissionInput;
  workCenters: CompanyPermissionInput;
};

export type AdminWcRhPodUserPermissions = {
  __typename?: 'AdminWCRhPodUserPermissions';
  approveDocsFromEmployees: CompanyUserPermission;
  authorizeTemplates: CompanyUserPermission;
  ctAdmins: CompanyUserPermission;
  dashboard: CompanyUserPermission;
  documents: CompanyUserPermission;
  employees: CompanyUserPermission;
  employeesStatus: CompanyUserPermission;
  groups: CompanyUserPermission;
  holidays: CompanyUserPermission;
  publishTemplates: CompanyUserPermission;
  receipts: CompanyUserPermission;
  recordChecklist: CompanyUserPermission;
  requestDocsToEmployees: CompanyUserPermission;
  signDocuments: CompanyUserPermission;
  templates: CompanyUserPermission;
  videoAgreementAuthorizer: CompanyUserPermission;
  videoAgreementTemplates: CompanyUserPermission;
  workCenters: CompanyUserPermission;
  workTitles: CompanyUserPermission;
};

export type AdminWcRhPodUserPermissionsInput = {
  approveDocsFromEmployees: CompanyUserPermissionInput;
  authorizeTemplates: CompanyUserPermissionInput;
  ctAdmins: CompanyUserPermissionInput;
  dashboard: CompanyUserPermissionInput;
  documents: CompanyUserPermissionInput;
  employees: CompanyUserPermissionInput;
  employeesStatus: CompanyUserPermissionInput;
  groups: CompanyUserPermissionInput;
  holidays: CompanyUserPermissionInput;
  publishTemplates: CompanyUserPermissionInput;
  receipts: CompanyUserPermissionInput;
  recordChecklist: CompanyUserPermissionInput;
  requestDocsToEmployees: CompanyUserPermissionInput;
  signDocuments: CompanyUserPermissionInput;
  templates: CompanyUserPermissionInput;
  videoAgreementAuthorizer: CompanyUserPermissionInput;
  videoAgreementTemplates: CompanyUserPermissionInput;
  workCenters: CompanyUserPermissionInput;
  workTitles: CompanyUserPermissionInput;
};

export type AdminWcRoles = {
  __typename?: 'AdminWCRoles';
  permissions: AdminWcPermissions;
};

export type AdminWcRolesInput = {
  permissions: AdminWcPermissionsInput;
};

export type AdminWcUserPermissions = {
  __typename?: 'AdminWCUserPermissions';
  rhPodPermissions: AdminWcRhPodUserPermissions;
};

export type AdminWcUserPermissionsInput = {
  rhPodPermissions: AdminWcRhPodUserPermissionsInput;
};

export type AdvancedFilter = {
  alta?: InputMaybe<Array<InputMaybe<AltaEnum>>>;
  dateType?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Period>;
  status?: InputMaybe<Array<InputMaybe<WorkSpaceStatusEnum>>>;
  workCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AdvancedFilters = {
  alta?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateType?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<DateFilter>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AiModuleConfiguration = {
  active: Scalars['Boolean']['input'];
  getImssCertificateData: Scalars['Boolean']['input'];
  getTaxCertificateData: Scalars['Boolean']['input'];
};

export type AiResponseUploadDocType = {
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AiSoraModule = {
  __typename?: 'AiSoraModule';
  active: Scalars['Boolean']['output'];
  getImssCertificateData: Scalars['Boolean']['output'];
  getTaxCertificateData: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedBy: SoraModuleUpdater;
};

export type AllCompanyGroupsFilter = {
  excludeEmployeesData?: InputMaybe<Scalars['Boolean']['input']>;
  excludeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  groupNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AllCompanyGroupsResult = CompanyGroupsResult;

export type AllCompanyWorkTitlesFilter = {
  excludeEmployeesData?: InputMaybe<Scalars['Boolean']['input']>;
  excludeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AllCompanyWorkTitlesResult = CompanyWorkTitlesResult;

export type AllCredits = {
  __typename?: 'AllCredits';
  credits?: Maybe<Array<Maybe<Credit>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AllCreditsFilter = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDateCreated?: InputMaybe<Scalars['Date']['input']>;
  endPaymentDate?: InputMaybe<Scalars['Date']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDateCreated?: InputMaybe<Scalars['Date']['input']>;
  startPaymentDate?: InputMaybe<Scalars['Date']['input']>;
};

export type AllCreditsResult = AllCredits;

export enum AllDocumentsSortFieldEnum {
  Category = 'CATEGORY',
  Date = 'DATE',
  Employeename = 'EMPLOYEENAME',
  Rfc = 'RFC',
  Title = 'TITLE'
}

export type AllEmployeesByCompanyIdsFinalResult = EmployeesByCompanyIdsResult;

export type AllEmployeesResult = EmployeesResult;

export type AllReceiptsByCompanyIdsFinalResult = ReceiptsByCompanyIdsResult;

export enum AllReceiptsSortFieldEnum {
  Creationdate = 'CREATIONDATE',
  Date = 'DATE',
  Employeename = 'EMPLOYEENAME',
  Rfc = 'RFC',
  Title = 'TITLE'
}

export type AllReceiptsSupport = {
  __typename?: 'AllReceiptsSupport';
  _id?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AllRecordChecklistResultResult = RecordChecklistResult;

export type AllTemplatesCountersResult = TemplatesCountersResult;

export type AllTemplatesResult = TemplatesResult;

export enum AllUsersSortFieldEnum {
  Alta = 'ALTA',
  Date = 'DATE',
  Employeename = 'EMPLOYEENAME',
  Rfc = 'RFC',
  Worktitle = 'WORKTITLE'
}

export type AllWorkCentersResult = WorkCentersResult;

export type AllWorkSpaces = {
  __typename?: 'AllWorkSpaces';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  alta?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isMaster?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Status>;
  userId?: Maybe<Scalars['String']['output']>;
  workCenterData?: Maybe<Array<Maybe<WorkCenterDataSupport>>>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export enum AltaEnum {
  Carta = 'CARTA',
  Sife = 'SIFE',
  VideoAgreement = 'VIDEO_AGREEMENT'
}

export type AnalyticsClientCommercialType = {
  __typename?: 'AnalyticsClientCommercialType';
  activeEmployees?: Maybe<Scalars['Int']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  blockBajaEmployeesCounter?: Maybe<Scalars['Int']['output']>;
  blockNewReceiptsCounter?: Maybe<Scalars['Int']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  eFirmaSignatureCounter?: Maybe<Scalars['Int']['output']>;
  inactiveEmployees?: Maybe<Scalars['Int']['output']>;
  preregisteredEmployees?: Maybe<Scalars['Int']['output']>;
  sifeSignatureCounter?: Maybe<Scalars['Int']['output']>;
  subCompanies?: Maybe<Array<Maybe<AnalyticsCommercialSubCompanyType>>>;
  totalAdmins?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalLoginCount?: Maybe<Scalars['Int']['output']>;
  totalRegistrations?: Maybe<Scalars['Int']['output']>;
  totalSignedDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignedDocumentsPercentage?: Maybe<Scalars['Float']['output']>;
  totalSignedReceipts?: Maybe<Scalars['Int']['output']>;
  totalSignedReceiptsPercentage?: Maybe<Scalars['Float']['output']>;
  totalUploadedDocuments?: Maybe<Scalars['Int']['output']>;
  totalUploadedReceipts?: Maybe<Scalars['Int']['output']>;
  uniqueLoginCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsCommercialSingleCompType = {
  __typename?: 'AnalyticsCommercialSingleCompType';
  activeEmployees?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  inactiveEmployees?: Maybe<Scalars['Int']['output']>;
  preregisteredEmployees?: Maybe<Scalars['Int']['output']>;
  timestamps?: Maybe<Scalars['Date']['output']>;
  totalAdmins?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalLoginCount?: Maybe<Scalars['Int']['output']>;
  totalRegistrations?: Maybe<Scalars['Int']['output']>;
  totalSignedDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignedDocumentsPercentage?: Maybe<Scalars['Float']['output']>;
  totalSignedReceipts?: Maybe<Scalars['Int']['output']>;
  totalSignedReceiptsPercentage?: Maybe<Scalars['Float']['output']>;
  totalUploadedDocuments?: Maybe<Scalars['Int']['output']>;
  totalUploadedReceipts?: Maybe<Scalars['Int']['output']>;
  uniqueLoginCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsCommercialSoraType = {
  __typename?: 'AnalyticsCommercialSoraType';
  activeEmployees?: Maybe<Scalars['Int']['output']>;
  blockBajaEmployeesCounter?: Maybe<Scalars['Int']['output']>;
  blockNewReceiptsCounter?: Maybe<Scalars['Int']['output']>;
  eFirmaSignatureCounter?: Maybe<Scalars['Int']['output']>;
  inactiveEmployees?: Maybe<Scalars['Int']['output']>;
  preregisteredEmployees?: Maybe<Scalars['Int']['output']>;
  sifeSignatureCounter?: Maybe<Scalars['Int']['output']>;
  timestamps?: Maybe<Scalars['Date']['output']>;
  totalAdmins?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalLoginCount?: Maybe<Scalars['Int']['output']>;
  totalRegistrations?: Maybe<Scalars['Int']['output']>;
  totalSignedDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignedDocumentsPercentage?: Maybe<Scalars['Float']['output']>;
  totalSignedReceipts?: Maybe<Scalars['Int']['output']>;
  totalSignedReceiptsPercentage?: Maybe<Scalars['Float']['output']>;
  totalUploadedDocuments?: Maybe<Scalars['Int']['output']>;
  totalUploadedReceipts?: Maybe<Scalars['Int']['output']>;
  uniqueLoginCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsCommercialSubCompanyType = {
  __typename?: 'AnalyticsCommercialSubCompanyType';
  activeEmployees?: Maybe<Scalars['Int']['output']>;
  blockBajaEmployees?: Maybe<Scalars['Boolean']['output']>;
  blockNewReceipts?: Maybe<Scalars['Boolean']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  inactiveEmployees?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameToInvoice?: Maybe<Scalars['String']['output']>;
  preregisteredEmployees?: Maybe<Scalars['Int']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  signatureType?: Maybe<Scalars['String']['output']>;
  totalAdmins?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalLoginCount?: Maybe<Scalars['Int']['output']>;
  totalRegistrations?: Maybe<Scalars['Int']['output']>;
  totalSignedDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignedDocumentsPercentage?: Maybe<Scalars['Float']['output']>;
  totalSignedReceipts?: Maybe<Scalars['Int']['output']>;
  totalSignedReceiptsPercentage?: Maybe<Scalars['Float']['output']>;
  totalUploadedDocuments?: Maybe<Scalars['Int']['output']>;
  totalUploadedReceipts?: Maybe<Scalars['Int']['output']>;
  uniqueLoginCount?: Maybe<Scalars['Int']['output']>;
};

export type ApiAccessToken = {
  __typename?: 'ApiAccessToken';
  exp?: Maybe<Scalars['Date']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ApproveDocumentFromEmployeeInput = {
  _id: Scalars['String']['input'];
};

export type ApproveDocumentVideoAgreementInput = {
  documentId: Scalars['String']['input'];
};

export type ApproveTemplateInput = {
  templateId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ApproveTemplateResult = ErrorToApproveTemplate | TemplateApproved;

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  comments?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimestampsAuthorizers>;
  user?: Maybe<UserAndWorkspaceAuthorizer>;
};

export type AuthorizerTeamItem = {
  __typename?: 'AuthorizerTeamItem';
  _id: Scalars['String']['output'];
  authorizers: Array<Maybe<UserReferenceWithProfilePicture>>;
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  employeesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  signInOrder: Scalars['Boolean']['output'];
};

export type AuthorizersTeamAlreadyExists = {
  __typename?: 'AuthorizersTeamAlreadyExists';
  groupName?: Maybe<Scalars['String']['output']>;
};

export type BelongToManyUsers = {
  __typename?: 'BelongToManyUsers';
  message?: Maybe<Scalars['String']['output']>;
};

export type BeneficiariesConfigEntity = {
  __typename?: 'BeneficiariesConfigEntity';
  beneficiaries?: Maybe<Array<Maybe<BeneficiaryEntity>>>;
  timestamps?: Maybe<TimeStampObj>;
};

export type BeneficiariesErrorPercentage = ErrorMessage & {
  __typename?: 'BeneficiariesErrorPercentage';
  message?: Maybe<Scalars['String']['output']>;
};

export type BeneficiariesNotifications = {
  __typename?: 'BeneficiariesNotifications';
  receivedBeneficiaryNotifications?: Maybe<Scalars['Date']['output']>;
  sentBeneficiaryNotifications?: Maybe<Scalars['Date']['output']>;
};

export type Beneficiary = {
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP: Scalars['String']['input'];
  names: Scalars['String']['input'];
  percentage: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type BeneficiaryEntity = {
  __typename?: 'BeneficiaryEntity';
  _id?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  email?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  updatedBy?: Maybe<User>;
};

export type BillingData = {
  __typename?: 'BillingData';
  period?: Maybe<PeriodType>;
  users?: Maybe<UsersBillingType>;
};

export type BillingDataInput = {
  period?: InputMaybe<BillingPeriodInput>;
  users?: InputMaybe<BillingUsersInput>;
};

export type BillingInfo = {
  __typename?: 'BillingInfo';
  base?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  monthValue?: Maybe<Scalars['Float']['output']>;
};

export type BillingInfoResult = {
  __typename?: 'BillingInfoResult';
  billingInfo?: Maybe<Array<Maybe<BillingInfo>>>;
};

export type BillingPeriodInput = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type BillingUsersInput = {
  base?: InputMaybe<Scalars['String']['input']>;
  costByUser?: InputMaybe<Scalars['String']['input']>;
};

export type BlockCompanyUserSupportResult = GeneralError | Success;

export enum BulkDocumentSendTo {
  All = 'ALL',
  Filename = 'FILENAME',
  Filenametokens = 'FILENAMETOKENS',
  List = 'LIST'
}

export type CancelHolidayRequestInput = {
  holidayId: Scalars['String']['input'];
};

export enum CartasDownloadType {
  All = 'ALL',
  List = 'LIST'
}

export type CategoriesInput = {
  category: Scalars['String']['input'];
  subcategory: Scalars['String']['input'];
};

export type CategoriesResult = {
  __typename?: 'CategoriesResult';
  category: Scalars['String']['output'];
  subcategory: Scalars['String']['output'];
};

export type CategoryAndSubcategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryItem = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySummary = {
  __typename?: 'CategorySummary';
  category?: Maybe<Scalars['String']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  unsigned?: Maybe<Scalars['Int']['output']>;
};

export type ChangeEmployeeLegalStatusInput = {
  employeeId: Scalars['String']['input'];
};

export type ChangeEmployeeLegalStatusResult = {
  __typename?: 'ChangeEmployeeLegalStatusResult';
  message: Scalars['String']['output'];
  newLegalStatus?: Maybe<LegalStatusType>;
  oldLegalStatus?: Maybe<LegalStatusType>;
  success: Scalars['Boolean']['output'];
};

export type ChangeOtpResult = CompleteContactInfo | NewPasswordMustBeDifferent | OtpNotFound | PasswordChanged | UserNotFound;

export type ChangePasswordResult = InvalidToken | NewPasswordMustBeDifferent | PasswordChanged | RegistrationNotAllowed | TokenExpired | UserAlreadyExists | UserIncompleteRegistration | UserNotFound;

export type ChangeWorkCenterEmployeeSupportInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  newWorkCenterId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeWorkCenterEmployeeSupportResult = ErrorToChangeWorkCenterEmployeeSupport | FinalResponseChangeWorkCenterEmployeeSupport;

export type CheckListProgressDashboardResult = {
  __typename?: 'CheckListProgressDashboardResult';
  total?: Maybe<Scalars['Int']['output']>;
};

export type ColorInput = {
  primary?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
};

export type ColorResult = {
  __typename?: 'ColorResult';
  primary?: Maybe<Scalars['String']['output']>;
  secondary?: Maybe<Scalars['String']['output']>;
};

export type CompSignerToSendNotification = {
  documentsSent: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type CompaniesInfoSupport = {
  __typename?: 'CompaniesInfoSupport';
  _id?: Maybe<Scalars['String']['output']>;
  activeUsers?: Maybe<Scalars['Int']['output']>;
  activeUsersPercentage?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  bajaUsers?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  deletedUsers?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inactiveUsers?: Maybe<Scalars['Int']['output']>;
  logoKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameToInvoice?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  signedDocuments?: Maybe<Scalars['Int']['output']>;
  signedDocumentsPercentage?: Maybe<Scalars['String']['output']>;
  signedReceipts?: Maybe<Scalars['Int']['output']>;
  signedReceiptsPercentage?: Maybe<Scalars['String']['output']>;
  totalDocuments?: Maybe<Scalars['Int']['output']>;
  totalReceipts?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  unsignedDocuments?: Maybe<Scalars['Int']['output']>;
  unsignedReceipts?: Maybe<Scalars['Int']['output']>;
};

export type Company = {
  __typename?: 'Company';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  billingData?: Maybe<BillingData>;
  clientName?: Maybe<Scalars['String']['output']>;
  configs?: Maybe<CompanyConfigs>;
  employees?: Maybe<Scalars['String']['output']>;
  federalEntity?: Maybe<FederalEntity>;
  id?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isItAMexicanCompany?: Maybe<Scalars['Boolean']['output']>;
  isItASubsidiaryCompany?: Maybe<Scalars['Boolean']['output']>;
  largeLogoUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  masterUsers?: Maybe<Array<Maybe<CompanyMasterUser>>>;
  modules?: Maybe<CompanyModules>;
  name?: Maybe<Scalars['String']['output']>;
  nameToInvoice?: Maybe<Scalars['String']['output']>;
  plants?: Maybe<Scalars['Int']['output']>;
  previousId?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CompanyStatus>;
  subtractPerceptions?: Maybe<Array<Maybe<SubtractPerception>>>;
  timestamps?: Maybe<TimeStampObj>;
  web?: Maybe<Scalars['String']['output']>;
  workCenters?: Maybe<Array<Maybe<CompanyWorkCenter>>>;
  workSpaceRoles?: Maybe<Array<Maybe<WorkSpaceRolesType>>>;
};

export type CompanyAdminRhAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP: Scalars['String']['input'];
  names: Scalars['String']['input'];
  permissions: AdminRhUserPermissionsInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc: Scalars['String']['input'];
};

export type CompanyConfig = {
  __typename?: 'CompanyConfig';
  active?: Maybe<Scalars['Boolean']['output']>;
  timestamps?: Maybe<TimeStampObj>;
};

export type CompanyConfigOption = {
  blockAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  blockBajaUsers?: InputMaybe<Scalars['Boolean']['input']>;
  blockNewReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  companyStatus?: InputMaybe<CompanyStatus>;
  completeBeneficiaries?: InputMaybe<CompleteBeneficiariesInput>;
  hideCreditsAndSavings?: InputMaybe<Scalars['Boolean']['input']>;
  idTypesForVerification?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestVerificationAtSign?: InputMaybe<Scalars['Boolean']['input']>;
  showCompanyLogoInReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  signatureType?: InputMaybe<Scalars['String']['input']>;
  skipGeolocationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  userInfoCompletion?: InputMaybe<UserInfoCompletionInput>;
};

export type CompanyConfigs = {
  __typename?: 'CompanyConfigs';
  absenceReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  blockAllUsers?: Maybe<CompanyConfig>;
  blockBajaEmployees?: Maybe<CompanyConfig>;
  blockNewReceipts?: Maybe<CompanyConfig>;
  completeBeneficiaries?: Maybe<CompleteBeneficiariesConfig>;
  employeeRecordsTags?: Maybe<Array<Maybe<EmployeeRecordsTags>>>;
  hideCompanyFromSelector?: Maybe<CompanyConfig>;
  hideCreditsAndSavings?: Maybe<CompanyConfig>;
  idTypesForVerification?: Maybe<CompanyIdTypesForVerificationConfig>;
  notifications?: Maybe<CompanyNotifications>;
  requestVerificationAtSign?: Maybe<CompanyConfig>;
  showClientName?: Maybe<CompanyConfig>;
  showCompanyLogoInReceipt?: Maybe<CompanyConfig>;
  showNotifications?: Maybe<CompanyConfig>;
  showRegisteredSalary?: Maybe<CompanyConfig>;
  showSalaryType?: Maybe<CompanyConfig>;
  showTotalPayment?: Maybe<CompanyConfig>;
  showWorkCenter?: Maybe<CompanyConfig>;
  showXMLSalary?: Maybe<CompanyConfig>;
  signatureType?: Maybe<CompanySignatureType>;
  skipGeolocationRequest?: Maybe<CompanyConfig>;
  userInfoCompletion?: Maybe<UserInfoCompletionConfig>;
};

export type CompanyDefaultRoles = {
  __typename?: 'CompanyDefaultRoles';
  adminRh: AdminRhRoles;
  adminWC: AdminWcRoles;
  superAdmin: SuperAdminRoles;
};

export type CompanyDocument = {
  __typename?: 'CompanyDocument';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  company?: Maybe<DocumentCompany>;
  constantType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  employeeSignature?: Maybe<Array<Maybe<DocumentEmployeeSignature>>>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  hideAfterSigning?: Maybe<Scalars['Boolean']['output']>;
  history?: Maybe<Array<Maybe<DocumentHistory>>>;
  isAbsenceDocument?: Maybe<Scalars['Boolean']['output']>;
  lastSignatureAt?: Maybe<Scalars['Date']['output']>;
  linkedToChecklist?: Maybe<Scalars['Boolean']['output']>;
  onlyStorage?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  queueStatus?: Maybe<Scalars['String']['output']>;
  scheduledFor?: Maybe<Scalars['Date']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  signers?: Maybe<Array<Maybe<Signers>>>;
  signersConfig?: Maybe<SignersConfig>;
  subcategory?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uploadedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  validity?: Maybe<Scalars['Date']['output']>;
  videoAgreement?: Maybe<VideoAgreement>;
  videoAgreementRequired?: Maybe<Scalars['Boolean']['output']>;
  workCenter?: Maybe<DocumentWorkCenter>;
};

export type CompanyDocumentsCountersResult = CompanyDocumentsCountersSuccess | ResourceNotFound;

export type CompanyDocumentsCountersSuccess = {
  __typename?: 'CompanyDocumentsCountersSuccess';
  ALL?: Maybe<Scalars['Int']['output']>;
  PENDING_REVIEW?: Maybe<Scalars['Int']['output']>;
  REJECTED?: Maybe<Scalars['Int']['output']>;
  SCHEDULED?: Maybe<Scalars['Int']['output']>;
  SIGNED?: Maybe<Scalars['Int']['output']>;
  UNSIGNABLE?: Maybe<Scalars['Int']['output']>;
  UNSIGNED?: Maybe<Scalars['Int']['output']>;
  WAITING_MY_SIGNATURE?: Maybe<Scalars['Int']['output']>;
};

export type CompanyDocumentsResult = CompanyDocumentsSuccess | ResourceNotFound;

export type CompanyDocumentsSuccess = {
  __typename?: 'CompanyDocumentsSuccess';
  documents?: Maybe<Array<Maybe<CompanyDocument>>>;
};

export type CompanyEmployee = {
  __typename?: 'CompanyEmployee';
  _id?: Maybe<Scalars['String']['output']>;
  alta?: Maybe<Scalars['String']['output']>;
  bajaDate?: Maybe<Scalars['Date']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  currentAbsence?: Maybe<CurrentAbsenceStatus>;
  currentLegalStatus?: Maybe<LegalStatusType>;
  currentStatus?: Maybe<WorkSpaceStatus>;
  documentCounts?: Maybe<EmployeeDocumentCounts>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  receiptCounts?: Maybe<EmployeeReceiptCounts>;
  rfc?: Maybe<Scalars['String']['output']>;
  sentOnboardingNotification?: Maybe<Scalars['Date']['output']>;
  signedFilesPercent?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  workCenter?: Maybe<CompanyEmployeeWorkCenter>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type CompanyEmployeeWorkCenter = {
  __typename?: 'CompanyEmployeeWorkCenter';
  _id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyGroup = {
  __typename?: 'CompanyGroup';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalActiveEmployees?: Maybe<Scalars['Int']['output']>;
  totalBajaEmployees?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalInactiveEmployees?: Maybe<Scalars['Int']['output']>;
};

export type CompanyGroupItem = {
  __typename?: 'CompanyGroupItem';
  clientName?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyGroupsResult = {
  __typename?: 'CompanyGroupsResult';
  groups?: Maybe<Array<Maybe<CompanyGroup>>>;
};

export type CompanyIdTypesForVerificationConfig = {
  __typename?: 'CompanyIdTypesForVerificationConfig';
  timestamps?: Maybe<TimeStampObj>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CompanyMasterUser = {
  __typename?: 'CompanyMasterUser';
  active?: Maybe<Scalars['Boolean']['output']>;
  masterUserId?: Maybe<Scalars['String']['output']>;
};

export type CompanyModules = {
  __typename?: 'CompanyModules';
  ai?: Maybe<AiSoraModule>;
  documents?: Maybe<SoraModule>;
  holidays?: Maybe<SoraModule>;
  rest?: Maybe<SoraModule>;
};

export type CompanyModulesResult = {
  __typename?: 'CompanyModulesResult';
  employeeRecordTags?: Maybe<Array<Maybe<GetEmployeeRecordsTagsResult>>>;
  modules?: Maybe<CompanyModules>;
};

export type CompanyNotFound = ErrorMessage & {
  __typename?: 'CompanyNotFound';
  message?: Maybe<Scalars['String']['output']>;
};

export type CompanyNotifications = {
  __typename?: 'CompanyNotifications';
  active: Scalars['Boolean']['output'];
  periodicity?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  weekDay?: Maybe<Scalars['Int']['output']>;
};

export type CompanyPeriods = {
  __typename?: 'CompanyPeriods';
  period?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type CompanyPermission = {
  __typename?: 'CompanyPermission';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  create?: Maybe<Scalars['Boolean']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyPermissionInput = {
  active: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyRolesInput = {
  adminRh?: InputMaybe<AdminRhRolesInput>;
  adminWC?: InputMaybe<AdminWcRolesInput>;
  superAdmin?: InputMaybe<SuperAdminRolesInput>;
};

export type CompanySignatureType = {
  __typename?: 'CompanySignatureType';
  timestamps?: Maybe<TimeStampObj>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum CompanyStatus {
  Active = 'ACTIVE',
  Baja = 'BAJA'
}

export type CompanyUserPermission = {
  __typename?: 'CompanyUserPermission';
  code: Scalars['String']['output'];
  create?: Maybe<Scalars['Boolean']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyUserPermissionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyWorkCenter = {
  __typename?: 'CompanyWorkCenter';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workCenterId?: Maybe<Scalars['String']['output']>;
};

export type CompanyWorkCenterAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP: Scalars['String']['input'];
  names: Scalars['String']['input'];
  permissions: AdminWcUserPermissionsInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc: Scalars['String']['input'];
  workCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CompanyWorkTitle = {
  __typename?: 'CompanyWorkTitle';
  color?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalActiveEmployees?: Maybe<Scalars['Int']['output']>;
  totalBajaEmployees?: Maybe<Scalars['Int']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  totalInactiveEmployees?: Maybe<Scalars['Int']['output']>;
};

export type CompanyWorkTitleItem = {
  __typename?: 'CompanyWorkTitleItem';
  clientName?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyWorkTitlesResult = {
  __typename?: 'CompanyWorkTitlesResult';
  workTitles?: Maybe<Array<Maybe<CompanyWorkTitle>>>;
};

export type CompleteBeneficiariesConfig = {
  __typename?: 'CompleteBeneficiariesConfig';
  active?: Maybe<Scalars['Boolean']['output']>;
  requestToEmployees?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type CompleteBeneficiariesInput = {
  active: Scalars['Boolean']['input'];
  requestToEmployees: Scalars['Boolean']['input'];
  required: Scalars['Boolean']['input'];
};

export type CompleteBeneficiariesStep = {
  __typename?: 'CompleteBeneficiariesStep';
  completed: Scalars['Boolean']['output'];
};

export type CompleteContactInfo = {
  __typename?: 'CompleteContactInfo';
  message?: Maybe<Scalars['String']['output']>;
};

export type CompleteRequestedInformationStep = {
  __typename?: 'CompleteRequestedInformationStep';
  completed: Scalars['Boolean']['output'];
  fields: Array<Scalars['String']['output']>;
};

export type CompleteUserInfoRequestedInput = {
  address?: InputMaybe<UserAddressInput>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  skippedFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteUserInfoRequestedResult = {
  __typename?: 'CompleteUserInfoRequestedResult';
  _id?: Maybe<Scalars['String']['output']>;
  address?: Maybe<UserAddress>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
};

export type CompletedDocumentByRecordChecklist = {
  __typename?: 'CompletedDocumentByRecordChecklist';
  _id: Scalars['String']['output'];
  canBeSeen: Scalars['Boolean']['output'];
  canBeSigned: Scalars['Boolean']['output'];
  completedAt: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  lastNameM: Scalars['String']['output'];
  lastNameP: Scalars['String']['output'];
  names: Scalars['String']['output'];
  onlyStorage: Scalars['Boolean']['output'];
  profilePicture: Scalars['String']['output'];
  rfc: Scalars['String']['output'];
  seen: Scalars['Boolean']['output'];
  signed: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export enum ConceptType {
  Other = 'OTHER',
  Perception = 'PERCEPTION'
}

export type ConfirmDeleteUserSpport = {
  __typename?: 'ConfirmDeleteUserSpport';
  hasDocumentsSigned?: Maybe<Scalars['Boolean']['output']>;
  hasReceiptsSigned?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfirmReceiptImportResponse = {
  __typename?: 'ConfirmReceiptImportResponse';
  csvFileUrl?: Maybe<Scalars['String']['output']>;
  failed?: Maybe<Array<Maybe<FailedImportedReceipts>>>;
  uploaded?: Maybe<Array<Maybe<Receipt>>>;
};

export enum ContactMethods {
  Email = 'email',
  Phone = 'phone'
}

export type ContactVerificationMethod = {
  __typename?: 'ContactVerificationMethod';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type Counters = {
  __typename?: 'Counters';
  all: Scalars['Int']['output'];
  finished: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  incoming: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export type CountryResult = {
  __typename?: 'CountryResult';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Counts = {
  __typename?: 'Counts';
  cantBeSigned?: Maybe<Scalars['Int']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  unsigned?: Maybe<Scalars['Int']['output']>;
};

export type CreateAuthorizersTeamInput = {
  authorizersIds: Array<InputMaybe<Scalars['String']['input']>>;
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  sendToAllEmployees: Scalars['Boolean']['input'];
  signInOrder: Scalars['Boolean']['input'];
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateAuthorizersTeamResult = AuthorizersTeamAlreadyExists | Error | Success;

export type CreateBeneficiariesDocumentEntityInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBeneficiariesDocumentFinalResult = CreateBeneficiariesDocumentResult | ErrorToCreateBeneficiariesDocument;

export type CreateBeneficiariesDocumentInput = {
  beneficiaries?: InputMaybe<Array<InputMaybe<CreateBeneficiariesDocumentEntityInput>>>;
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateBeneficiariesDocumentResult = {
  __typename?: 'CreateBeneficiariesDocumentResult';
  documentId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateByDocumentItem = {
  __typename?: 'CreateByDocumentItem';
  _id?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
};

export type CreateCategoryInput = {
  category: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCategoryResult = ErrorCreateCategory | Success;

export type CreateCreditPaymentInput = {
  concept: Scalars['String']['input'];
  currentBalance: Scalars['Float']['input'];
  folioNumber: Scalars['String']['input'];
  paymentAmount: Scalars['Float']['input'];
  paymentDate: Scalars['Date']['input'];
  paymentWeek: Scalars['String']['input'];
  previousBalance: Scalars['Float']['input'];
  rfc: Scalars['String']['input'];
  type: CreditTypeEnum;
};

export type CreateCreditPaymentsResult = CreditPaymentsCreated | NoCreditPaymentsCreated;

export type CreateDocumentInput = {
  canBeSigned: Scalars['Boolean']['input'];
  categories?: InputMaybe<CategoriesInput>;
  compSigners?: InputMaybe<Array<InputMaybe<UserDoc>>>;
  documentHtml: Scalars['String']['input'];
  employees?: InputMaybe<Array<InputMaybe<UserDoc>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideAfterSign: Scalars['Boolean']['input'];
  priority: DocumentPriority;
  scheduleFor?: InputMaybe<Scalars['Date']['input']>;
  sendTo: DocumentSendTo;
  title: Scalars['String']['input'];
  validity?: InputMaybe<Scalars['Date']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateElectronicSignatureStep = {
  __typename?: 'CreateElectronicSignatureStep';
  completed: Scalars['Boolean']['output'];
  verificationToken: Scalars['String']['output'];
  verificationTokenRequired: Scalars['Boolean']['output'];
  verificationTypeRequired?: Maybe<VerificationTypeEnum>;
};

export type CreateEmployeeAbsenceFinalResult = CreateEmployeeAbsenceResult | ErrorToCreateEmployeeAbsence;

export type CreateEmployeeAbsenceInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  updateStatusToEndAbsent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEmployeeAbsenceResult = {
  __typename?: 'CreateEmployeeAbsenceResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateGroupInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
};

export type CreateGroupResult = GroupAlreadyExists | GroupCreated;

export type CreateHolidayInput = {
  color: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type CreateHolidayRequestResult = Error | Success;

export type CreateHolidayResult = HolidayAlreadyExists | Success;

export type CreateHolidaySchemeInput = {
  approveTemplateId: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  employeesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidayTakenTemplateId?: InputMaybe<Scalars['String']['input']>;
  scheme: Array<InputMaybe<HolidaySchemeInput>>;
  title: Scalars['String']['input'];
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateHolidaySchemeResult = Error | Success;

export type CreateMasterAdminInput = {
  companyId: Scalars['String']['input'];
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMasterAdminResult = CompanyNotFound | MasterAdminAlreadyExists | MasterAdminIncorrectInfo | User;

export type CreateNewAccountResult = User | UserAlreadyExists | ValidationError;

export type CreateRecordChecklistInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  documentTags?: InputMaybe<Array<InputMaybe<RecordChecklistDocumentTagInput>>>;
  name: Scalars['String']['input'];
};

export type CreateRecordChecklistResult = RecordChecklist | RecordChecklistAlreadyExists;

export type CreateScheduledDocumentInput = {
  canBeSigned: Scalars['Boolean']['input'];
  categories?: InputMaybe<ScheduledDocumentCategoriesInput>;
  compSigners?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentHtml: Scalars['String']['input'];
  employees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedEmployees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideAfterSign: Scalars['Boolean']['input'];
  priority: ScheduledDocumentPriority;
  scheduledFor?: InputMaybe<Scalars['Date']['input']>;
  selectedVariables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sendToAllEmployees: Scalars['Boolean']['input'];
  signersConfig?: InputMaybe<SignersConfigInput>;
  title: Scalars['String']['input'];
  validity?: InputMaybe<Scalars['Date']['input']>;
  videoAgreementText?: InputMaybe<Scalars['String']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateScheduledDocumentResponse = {
  __typename?: 'CreateScheduledDocumentResponse';
  documentsCreated?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateScheduledDocumentResult = CreateScheduledDocumentResponse | ErrorToCreateScheduleDocument | Success | UserNotFound;

export type CreateSubcategoryInput = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  subcategory: Scalars['String']['input'];
};

export type CreateSubcategoryResult = ErrorCreateSubcategory | Success;

export type CreateTemplateInput = {
  authorizeInOrder?: InputMaybe<Scalars['Boolean']['input']>;
  authorizers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<CategoriesInput>;
  color: ColorInput;
  companyId: Scalars['String']['input'];
  creatorId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateTemplateResult = ErrorToCreateTemplate | TemplateCreated;

export type CreateUserForCompanyFromSupportInput = {
  alta?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  employmentStartDate?: InputMaybe<Scalars['Date']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  payrollId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc: Scalars['String']['input'];
  userType: Scalars['String']['input'];
  workCenterId?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserForCompanyFromSupportResult = AdminRhAlreadyExists | CompanyNotFound | MasterAdminAlreadyExists | Success | User | UserAlreadyExists | UserNotFound | ValidationError | WorkCenterAlreadyExists | WorkCenterNotFound;

export type CreateUserInput = {
  address?: InputMaybe<UserAddressInput>;
  alta: AltaEnum;
  beneficiaries?: InputMaybe<Array<InputMaybe<Beneficiary>>>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentStartDate?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP: Scalars['String']['input'];
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  names: Scalars['String']['input'];
  payrollId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  recordChecklistName?: InputMaybe<Scalars['String']['input']>;
  rfc: Scalars['String']['input'];
  salary?: InputMaybe<Scalars['Float']['input']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
  typeOfCreation?: InputMaybe<Scalars['String']['input']>;
  workCenterId: Scalars['String']['input'];
  workDayType?: InputMaybe<Scalars['String']['input']>;
  workTitle: Scalars['String']['input'];
};

export type CreateUserResult = BeneficiariesErrorPercentage | ErrorToCreateUserSupport | FinalResponseCreateUserSupport | InvalidWorkCenter | User | UserAlreadyExists | ValidationError;

export type CreateUserSupportInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVideoAgreementTemplateInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateVideoAgreementTemplateResult = VideoAgreementTemplate | VideoAgreementTemplateAlreadyExists;

export type CreateWorkCenterAdminInput = {
  adminId: Scalars['String']['input'];
  functionalities: FunctionalitiesInput;
  typeOfCreation?: InputMaybe<Scalars['String']['input']>;
  workCenterId: Scalars['String']['input'];
};

export type CreateWorkCentersErrors = {
  __typename?: 'CreateWorkCentersErrors';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreateWorkCentersInput = {
  workCenterAdmins?: InputMaybe<Array<InputMaybe<WorkCenterAdminInput>>>;
  workCenters?: InputMaybe<Array<InputMaybe<WorkCenterInput>>>;
};

export type CreateWorkCentersResult = CreateWorkCentersErrors | Success | UserNotFound | WorkCentersCodeAlreadyExists;

export type CreateWorkTitleInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
};

export type CreateWorkTitleResult = WorkTitleAlreadyExists | WorkTitleCreated;

export type CreatedByType = {
  __typename?: 'CreatedByType';
  _id: Scalars['String']['output'];
  curp?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP: Scalars['String']['output'];
  names: Scalars['String']['output'];
  rfc?: Maybe<Scalars['String']['output']>;
};

export type CreatorUser = {
  __typename?: 'CreatorUser';
  _id?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
};

export type Credit = {
  __typename?: 'Credit';
  _id?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  concept?: Maybe<Scalars['String']['output']>;
  creditPayments?: Maybe<Array<Maybe<CreditPayment>>>;
  employeeFullName?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeRfc?: Maybe<Scalars['String']['output']>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  finished?: Maybe<Scalars['Boolean']['output']>;
  folioNumber?: Maybe<Scalars['String']['output']>;
  initialAmount?: Maybe<Scalars['Float']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  type?: Maybe<CreditTypeEnum>;
};

export type CreditListMetadata = {
  __typename?: 'CreditListMetadata';
  total: Scalars['Int']['output'];
};

export type CreditPayment = {
  __typename?: 'CreditPayment';
  _id?: Maybe<Scalars['String']['output']>;
  creditId?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentWeek?: Maybe<Scalars['String']['output']>;
  previousBalance?: Maybe<Scalars['Float']['output']>;
  timestamps?: Maybe<TimeStampObj>;
};

export type CreditPaymentValidation = {
  __typename?: 'CreditPaymentValidation';
  concept?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['String']['output']>;
  folioNumber?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentWeek?: Maybe<Scalars['String']['output']>;
  previousBalance?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  validationResult?: Maybe<CreditPaymentValidationResult>;
};

export type CreditPaymentValidationResult = {
  __typename?: 'CreditPaymentValidationResult';
  concept?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['String']['output']>;
  folioNumber?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentWeek?: Maybe<Scalars['String']['output']>;
  previousBalance?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CreditPaymentValidations = {
  __typename?: 'CreditPaymentValidations';
  creditPayments?: Maybe<Array<Maybe<CreditPaymentValidation>>>;
};

export type CreditPaymentsCreated = {
  __typename?: 'CreditPaymentsCreated';
  message?: Maybe<Scalars['String']['output']>;
  totalCreated?: Maybe<Scalars['Int']['output']>;
};

export type CreditPaymentsDeleted = {
  __typename?: 'CreditPaymentsDeleted';
  message?: Maybe<Scalars['String']['output']>;
  totalDeleted?: Maybe<Scalars['Int']['output']>;
};

export enum CreditTypeEnum {
  Credit = 'CREDIT',
  Saving = 'SAVING'
}

export type CreditsDeleted = {
  __typename?: 'CreditsDeleted';
  message?: Maybe<Scalars['String']['output']>;
  totalDeleted?: Maybe<Scalars['Int']['output']>;
};

export type CreditsNotFound = {
  __typename?: 'CreditsNotFound';
  message: Scalars['String']['output'];
};

export type CryptoSignature = {
  __typename?: 'CryptoSignature';
  active?: Maybe<Scalars['Boolean']['output']>;
  encryptedKey?: Maybe<Scalars['String']['output']>;
  publicKeyEncoded?: Maybe<Scalars['String']['output']>;
  reqVerification?: Maybe<Scalars['Boolean']['output']>;
  verificationConcluded?: Maybe<Scalars['Boolean']['output']>;
};

export type CurpRequiredForVideoAgreementRegistrationType = ErrorMessage & {
  __typename?: 'CurpRequiredForVideoAgreementRegistrationType';
  message?: Maybe<Scalars['String']['output']>;
};

export type CurrentAbsenceStatus = {
  __typename?: 'CurrentAbsenceStatus';
  absenceId?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type CustomChartCommercialType = {
  __typename?: 'CustomChartCommercialType';
  activeEmployees?: Maybe<Scalars['Int']['output']>;
  timestamps?: Maybe<Scalars['Date']['output']>;
};

export type CustomerBilling = {
  __typename?: 'CustomerBilling';
  alias?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  subCompanies?: Maybe<Array<Maybe<SubCompany>>>;
};

export type CustomersBillingResult = {
  __typename?: 'CustomersBillingResult';
  companies?: Maybe<Array<Maybe<CustomerBilling>>>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  documentCount?: Maybe<DocumentCounts>;
  receiptCount?: Maybe<ReceiptCounts>;
  userCount?: Maybe<UserCounts>;
};

export type DashboardFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
  userTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum DataCompletionStatusEnum {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type DateFilter = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DaysEarned = {
  __typename?: 'DaysEarned';
  days?: Maybe<Scalars['Int']['output']>;
  daysPerMonth?: Maybe<Array<Maybe<DaysEarnedByMonthItem>>>;
  year: Scalars['Int']['output'];
};

export type DaysEarnedByMonth = {
  __typename?: 'DaysEarnedByMonth';
  days: Array<Maybe<DaysEarnedByMonthItem>>;
  year: Scalars['Int']['output'];
};

export type DaysEarnedByMonthItem = {
  __typename?: 'DaysEarnedByMonthItem';
  days: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
};

export type DaysEarnedByYear = {
  __typename?: 'DaysEarnedByYear';
  days: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DaysPerMonthInput = {
  days: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
};

export type Deduction = {
  __typename?: 'Deduction';
  concept?: Maybe<Scalars['String']['output']>;
  extraHours?: Maybe<Scalars['Int']['output']>;
  extraHoursCode?: Maybe<Scalars['String']['output']>;
  import?: Maybe<Scalars['Float']['output']>;
  perceptionType?: Maybe<Scalars['String']['output']>;
};

export type DeleteAuthorizersTeamEmployeesResult = Error | ResourceNotFound | Success;

export type DeleteBeneficiariesDocumentFinalResult = DeleteBeneficiariesDocumentResult | ErrorToDeleteBeneficiariesDocument;

export type DeleteBeneficiariesDocumentInput = {
  employeeDocumentId: Scalars['String']['input'];
};

export type DeleteBeneficiariesDocumentResult = {
  __typename?: 'DeleteBeneficiariesDocumentResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCategoryInput = {
  categoryIdToDelete: Scalars['String']['input'];
  categoryIdToPush?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCategoryResult = ErrorDeleteCategory | Success;

export type DeleteCompanyAdminsInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  shouldDeleteEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCompanyAdminsResult = ErrorToDeleteCompanyAdmins | FinalResponseDeleteCompanyAdmins;

export type DeleteCreditPaymentsInput = {
  id: Scalars['String']['input'];
};

export type DeleteCreditPaymentsResult = CreditPaymentsDeleted | NoCreditPaymentsDeleted;

export type DeleteCreditsInput = {
  creditId: Scalars['String']['input'];
};

export type DeleteCreditsResult = CreditsDeleted | NoCreditsDeleted;

export type DeleteDocumentResult = DocumentDeleted | ResourceNotFound;

export type DeleteDocumentsInput = {
  actionType: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  docType: Scalars['String']['input'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useSoraCompanyId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteDocumentsResult = {
  __typename?: 'DeleteDocumentsResult';
  data?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteEmployeeRecordsInput = {
  documentId: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
};

export type DeleteEmployeeRecordsResult = {
  __typename?: 'DeleteEmployeeRecordsResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteEmployeesFromGroupInput = {
  employeeIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employeeIdsToExclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupName: Scalars['String']['input'];
};

export type DeleteEmployeesFromGroupResult = DeleteEmployeesFromGroupSuccess | ResourceNotFound;

export type DeleteEmployeesFromGroupSuccess = {
  __typename?: 'DeleteEmployeesFromGroupSuccess';
  employeesDeleted?: Maybe<Scalars['Int']['output']>;
};

export type DeleteEmployeesFromHolidaySchemeResult = Error | ResourceNotFound | Success;

export type DeleteEmployeesFromRecordChecklistInput = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employeeIdsToExclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recordChecklistId: Scalars['String']['input'];
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeleteEmployeesFromRecordChecklistResult = DeleteEmployeesFromRecordChecklistSuccess;

export type DeleteEmployeesFromRecordChecklistSuccess = {
  __typename?: 'DeleteEmployeesFromRecordChecklistSuccess';
  employeesDeleted?: Maybe<Scalars['Int']['output']>;
};

export type DeleteGroupResult = GroupDeleted | ResourceNotFound;

export type DeleteHolidayInput = {
  holidayId: Scalars['String']['input'];
};

export type DeleteHolidayResult = Error | Success;

export type DeleteMultipleEmployeeAbsencesFinalResult = DeleteMultipleEmployeeAbsencesResult | ErrorToDeleteMultipleEmployeeAbsences;

export type DeleteMultipleEmployeeAbsencesInput = {
  absenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteMultipleEmployeeAbsencesResult = {
  __typename?: 'DeleteMultipleEmployeeAbsencesResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRecordChecklistResult = RecordChecklistDeleted;

export type DeleteSingleEmployeeAbsenceFinalResult = DeleteSingleEmployeeAbsenceResult | ErrorToDeleteSingleEmployeeAbsence;

export type DeleteSingleEmployeeAbsenceInput = {
  absenceId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteSingleEmployeeAbsenceResult = {
  __typename?: 'DeleteSingleEmployeeAbsenceResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSubcategoryInput = {
  categoryIdToUpdate: Scalars['String']['input'];
  newCategoryId?: InputMaybe<Scalars['String']['input']>;
  newSubcategoryId?: InputMaybe<Scalars['String']['input']>;
  subcategoryIdToDelete: Scalars['String']['input'];
};

export type DeleteSubcategoryResult = ErrorDeleteSubcategory | NewSubcategoryRequiredForDocuments | NewSubcategoryRequiredForRecordChecklist | Success;

export type DeleteTemplateResult = ResourceNotFound | TemplateDeleted;

export type DeleteUserResult = ConfirmDeleteUserSpport | ErrorInDeleteSupport | FinalResponseDelete;

export type DeleteVideoAgreementTemplateInput = {
  _id: Scalars['String']['input'];
};

export type DeleteVideoAgreementTemplateResult = {
  __typename?: 'DeleteVideoAgreementTemplateResult';
  deletedCount: Scalars['Int']['output'];
};

export type DeleteWorkTitleResult = ActionNotAllowed | ResourceNotFound | WorkTitleDeleted;

export type Disability = {
  __typename?: 'Disability';
  disabilityDays?: Maybe<Scalars['Int']['output']>;
  disabilityType?: Maybe<Scalars['String']['output']>;
  monetaryImport?: Maybe<Scalars['Float']['output']>;
};

export type DisableCompanySignerNotifications = {
  __typename?: 'DisableCompanySignerNotifications';
  active?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type DisableCompanySignerNotificationsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Document = {
  __typename?: 'Document';
  _id?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  company?: Maybe<DocumentCompany>;
  companyId?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  constantType?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  documentId?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeSignature?: Maybe<EmployeeSignature>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  firstImage?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hideAfterSigning?: Maybe<Scalars['Boolean']['output']>;
  history?: Maybe<Array<Maybe<DocumentHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  isAbsenceDocument?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  previousId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  queueStatus?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  secondImage?: Maybe<Scalars['String']['output']>;
  seen?: Maybe<Scalars['Date']['output']>;
  signDate?: Maybe<Scalars['Date']['output']>;
  signatureType?: Maybe<Scalars['String']['output']>;
  signatures?: Maybe<Array<Maybe<Signatures>>>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  signers?: Maybe<Array<Maybe<Signers>>>;
  signersConfig?: Maybe<SignersConfig>;
  subcategory?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<DocumentUser>;
  videoAgreement?: Maybe<VideoAgreement>;
  videoAgreementRequired?: Maybe<Scalars['Boolean']['output']>;
  workCenter?: Maybe<DocumentWorkCenter>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
};

export type DocumentAi = {
  __typename?: 'DocumentAi';
  imss?: Maybe<ImssEntity>;
  message?: Maybe<Scalars['String']['output']>;
  sat?: Maybe<SatAiEntity>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DocumentAndReceiptItemType {
  Document = 'DOCUMENT',
  Receipt = 'RECEIPT'
}

export type DocumentAndReceiptTimestamps = {
  __typename?: 'DocumentAndReceiptTimestamps';
  createdAt?: Maybe<Scalars['Date']['output']>;
};

export type DocumentBulkUploadData = {
  canBeHidden: Scalars['Boolean']['input'];
  canBeSigned: Scalars['Boolean']['input'];
  categories?: InputMaybe<CategoriesInput>;
  compSigners?: InputMaybe<Array<InputMaybe<UserDocUpload>>>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Array<InputMaybe<UserDocUpload>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority: Scalars['String']['input'];
  scheduledFor?: InputMaybe<Scalars['Date']['input']>;
  sendAllEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  sendTo: BulkDocumentSendTo;
  separatorToken?: InputMaybe<Scalars['String']['input']>;
  signersConfig?: InputMaybe<SignersConfigInput>;
  validity?: InputMaybe<Scalars['Date']['input']>;
  videoAgreementText?: InputMaybe<Scalars['String']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DocumentCompany = {
  __typename?: 'DocumentCompany';
  _id?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DocumentCounts = {
  __typename?: 'DocumentCounts';
  signed?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DocumentDeleted = {
  __typename?: 'DocumentDeleted';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentEmployeeSignature = {
  __typename?: 'DocumentEmployeeSignature';
  company?: Maybe<DocumentCompany>;
  docHash?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  signAt?: Maybe<Scalars['Date']['output']>;
  signBy?: Maybe<Scalars['String']['output']>;
  signUrl?: Maybe<Scalars['String']['output']>;
  signatureHash?: Maybe<Scalars['String']['output']>;
  signatureType?: Maybe<Scalars['String']['output']>;
  signedIn?: Maybe<Scalars['String']['output']>;
};

export type DocumentFilter = {
  canBeSigned?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoriesAndSubcategories?: InputMaybe<Array<InputMaybe<CategoryAndSubcategoryInput>>>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shouldShowTreatmentLetter?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DocumentHistory = {
  __typename?: 'DocumentHistory';
  action: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: UserReference;
};

export enum DocumentHistoryStatusEnum {
  Approved = 'APPROVED',
  NotUploaded = 'NOT_UPLOADED',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED'
}

export type DocumentItem = {
  __typename?: 'DocumentItem';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<CreateByDocumentItem>;
  documentId?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signers?: Maybe<Array<Maybe<SignerItem>>>;
  signersConfig?: Maybe<SignersConfigItem>;
  subcategory?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserDocumentItem>;
  workCenter?: Maybe<WorkCenterDocumentItem>;
};

export type DocumentListMetadata = {
  __typename?: 'DocumentListMetadata';
  all?: Maybe<Scalars['Int']['output']>;
  onboarding?: Maybe<Scalars['Int']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  signedByMe?: Maybe<Scalars['Int']['output']>;
  unsignable?: Maybe<Scalars['Int']['output']>;
  unsigned?: Maybe<Scalars['Int']['output']>;
  waitingCompSigners?: Maybe<Scalars['Int']['output']>;
  waitingEmployees?: Maybe<Scalars['Int']['output']>;
  waitingMySignature?: Maybe<Scalars['Int']['output']>;
};

export type DocumentNotCompletelySigned = {
  __typename?: 'DocumentNotCompletelySigned';
  message?: Maybe<Scalars['String']['output']>;
};

export enum DocumentPriority {
  High = 'HIGH',
  None = 'NONE'
}

export type DocumentResponse = {
  __typename?: 'DocumentResponse';
  documents?: Maybe<Array<Maybe<Document>>>;
  metadata?: Maybe<DocumentListMetadata>;
};

export enum DocumentSendTo {
  All = 'ALL',
  Filename = 'FILENAME',
  Filenametokens = 'FILENAMETOKENS',
  List = 'LIST'
}

export type DocumentTagPercentage = {
  __typename?: 'DocumentTagPercentage';
  category: Scalars['String']['output'];
  categoryColor: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  subcategory: Scalars['String']['output'];
};

export type DocumentType = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentTypeUnchangeable = {
  __typename?: 'DocumentTypeUnchangeable';
  message?: Maybe<Scalars['String']['output']>;
};

export type DocumentUploadData = {
  canBeHidden: Scalars['Boolean']['input'];
  canBeSigned: Scalars['Boolean']['input'];
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority: Scalars['String']['input'];
  sendTo: DocumentSendTo;
  signersConfig?: InputMaybe<SignersConfigInput>;
};

export type DocumentUser = {
  __typename?: 'DocumentUser';
  _id?: Maybe<Scalars['String']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type DocumentWorkCenter = {
  __typename?: 'DocumentWorkCenter';
  _id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DocumentsByCompanyIdsFilterInput = {
  categories?: InputMaybe<Array<InputMaybe<CategoryItem>>>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employees?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  groups?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
  period?: InputMaybe<DocumentsDateFilter>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shouldGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSearchByAllGroups?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workCenters?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  workTitles?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
};

export type DocumentsByCompanyIdsFinalResult = DocumentsByCompanyIdsResult;

export type DocumentsByCompanyIdsResult = {
  __typename?: 'DocumentsByCompanyIdsResult';
  documents?: Maybe<Array<Maybe<DocumentItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DocumentsCount = {
  __typename?: 'DocumentsCount';
  pending?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DocumentsCountByCompanyIdsFinalResult = DocumentsCountByCompanyIdsResult;

export type DocumentsCountByCompanyIdsResult = {
  __typename?: 'DocumentsCountByCompanyIdsResult';
  data?: Maybe<Array<Maybe<ItemChartData>>>;
  documentsCount?: Maybe<DocumentsCount>;
};

export type DocumentsDateFilter = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentsTableColumnsOptions = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  employeeRecordTags?: InputMaybe<Scalars['Boolean']['input']>;
  lastSignatureAt?: InputMaybe<Scalars['Boolean']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  signers?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentsTableCountersFilters = {
  employeeRecordTags?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validity: ValidityFilter;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DocumentsTableFilters = {
  employeeRecordTags?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validity: ValidityFilter;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DocumentsTableSortingAndPaging = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export enum DownloadAdminFileEnum {
  Adminuploadform = 'ADMINUPLOADFORM',
  AuthorizersForm = 'AUTHORIZERS_FORM',
  Credituploadform = 'CREDITUPLOADFORM',
  Groupsupdateform = 'GROUPSUPDATEFORM',
  Salaryuploadform = 'SALARYUPLOADFORM',
  Useruploadform = 'USERUPLOADFORM',
  Workcenteruploadform = 'WORKCENTERUPLOADFORM'
}

export type DownloadDocumentXmlResult = DocumentNotCompletelySigned | InvalidXmlFormat | ResourceNotFound | SignatureValidationFailed | SignedDocumentXmlFormatResult | UnknowError | UnsupportedDocumentXmlValidation;

export type DownloadEmployeeRecordsResult = EmployeeHasntEmployeeRecords | PresignedUrl | AdminHasNotPermission;

export type DownloadExtApiFileInput = {
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadExtApiResult = ExtApiNotFound | FinalResponseDownloadApiFile;

export type DownloadMyFileResult = DownloadUserFileException | FilePresignedUrl;

export type DownloadMyFilesInput = {
  documents: Scalars['Boolean']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  receipts: Scalars['Boolean']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DownloadReceiptResult = ErrorToGetReceipt | FinalResponseGetReceipt;

export enum DownloadRequestTypeEnum {
  Carta = 'CARTA',
  Document = 'DOCUMENT',
  EmployeeRecord = 'EMPLOYEE_RECORD',
  Receipt = 'RECEIPT',
  Xmlreceipt = 'XMLRECEIPT'
}

export type DownloadSignedReceiptXmlFormatResult = InvalidXmlFormat | ReceiptNotCompletelySigned | ResourceNotFound | SignatureValidationFailed | SignedReceiptXmlFormatResult | UnknowError | UnsupportedReciptXmlValidation;

export type DownloadUserCartas = {
  downloadType: CartasDownloadType;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DownloadUserDocumentSupportInput = {
  asAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  docType?: InputMaybe<Scalars['String']['input']>;
  employeeDocId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadUserFileException = {
  __typename?: 'DownloadUserFileException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DownloadUserReceiptSupportInput = {
  asAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  docType?: InputMaybe<Scalars['String']['input']>;
  receiptId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadVerifyEmployeeDataFinalResult = DownloadVerifyEmployeeDataResult | ErrorToDownloadVerifyEmployeeData;

export type DownloadVerifyEmployeeDataInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<ErrorUserType>>>;
};

export type DownloadVerifyEmployeeDataResult = {
  __typename?: 'DownloadVerifyEmployeeDataResult';
  links?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DuplicateRecordChecklistResult = RecordChecklist | ResourceNotFound;

export type DuplicatedCodeProvided = {
  __typename?: 'DuplicatedCodeProvided';
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type EditExtApiInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<TokenPermissionsInput>>>;
  timestamps?: InputMaybe<TimeStampObjInput>;
};

export type EditExtApiResult = AccessToken | CompanyNotFound | ExtApiNotFound;

export type EditUserResult = ErrorToEditUserSupport | FinalResponseToEditUserSupport;

export type EmailAlreadyInUse = {
  __typename?: 'EmailAlreadyInUse';
  esMessage?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type EmployeeAndWorkCenterItem = {
  _id?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeAssigned = {
  __typename?: 'EmployeeAssigned';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  workCenterName: Scalars['String']['output'];
};

export type EmployeeAssignedToScheme = {
  __typename?: 'EmployeeAssignedToScheme';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  workCenterName: Scalars['String']['output'];
};

export type EmployeeContactMethods = {
  _id: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeCounters = {
  __typename?: 'EmployeeCounters';
  absent?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Int']['output']>;
  baja?: Maybe<Scalars['Int']['output']>;
  inactive?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  sued?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeDashboard = {
  __typename?: 'EmployeeDashboard';
  pendingTasks?: Maybe<Array<Maybe<PendingTask>>>;
};

export type EmployeeData = {
  _id?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<UserAddressInput>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeDocumentCounter = {
  __typename?: 'EmployeeDocumentCounter';
  signedDocumentsPercent?: Maybe<Scalars['Float']['output']>;
  totalDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignableDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignedDocuments?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeDocumentCounts = {
  __typename?: 'EmployeeDocumentCounts';
  completedDocumentsPercent?: Maybe<Scalars['Float']['output']>;
  seenDocumentsPercent?: Maybe<Scalars['Float']['output']>;
  signedDocumentsPercent?: Maybe<Scalars['Float']['output']>;
  totalDocuments?: Maybe<Scalars['Int']['output']>;
  totalPendingSeenRequiredDocuments?: Maybe<Scalars['Int']['output']>;
  totalPendingSignableDocuments?: Maybe<Scalars['Int']['output']>;
  totalSeenDocuments?: Maybe<Scalars['Int']['output']>;
  totalSeenRequiredDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignableDocuments?: Maybe<Scalars['Int']['output']>;
  totalSignedDocuments?: Maybe<Scalars['Int']['output']>;
  totalUploadOnlyDocuments?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeDocumentCountsResult = EmployeeDocumentCounts | ResourceNotFound;

export type EmployeeHasntEmployeeRecords = {
  __typename?: 'EmployeeHasntEmployeeRecords';
  message?: Maybe<Scalars['String']['output']>;
};

export type EmployeeInfo = {
  __typename?: 'EmployeeInfo';
  _id: Scalars['String']['output'];
  address?: Maybe<UserAddress>;
  alta: Scalars['String']['output'];
  bajaDate?: Maybe<Scalars['String']['output']>;
  beneficiariesConfig?: Maybe<BeneficiariesConfigEntity>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  curp: Scalars['String']['output'];
  currentAbsence?: Maybe<CurrentAbsenceStatus>;
  currentLegalStatus: LegalStatusType;
  currentStatus: WorkSpaceStatus;
  email?: Maybe<Scalars['String']['output']>;
  employeeInfoRequired?: Maybe<Array<Maybe<EmployeeInfoRequired>>>;
  employmentStartDate?: Maybe<Scalars['Date']['output']>;
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasEverBeenActive?: Maybe<Scalars['Boolean']['output']>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  lastNameM: Scalars['String']['output'];
  lastNameP: Scalars['String']['output'];
  maritalStatus?: Maybe<Scalars['String']['output']>;
  names: Scalars['String']['output'];
  payrollId: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc: Scalars['String']['output'];
  salary?: Maybe<Scalars['Float']['output']>;
  sentOnboardingNotification?: Maybe<SentOnboardingNotification>;
  signedPercentage?: Maybe<Scalars['Int']['output']>;
  socialSecurityNumber?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  workCenterId: Scalars['String']['output'];
  workCenterName?: Maybe<Scalars['String']['output']>;
  workDayType?: Maybe<Scalars['String']['output']>;
  workTitle: Scalars['String']['output'];
};

export type EmployeeInfoRequired = {
  __typename?: 'EmployeeInfoRequired';
  completedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EmployeeNominaData = {
  _id?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  employmentStartDate?: InputMaybe<Scalars['Date']['input']>;
  oldWorkCenterId?: InputMaybe<Scalars['String']['input']>;
  payrollId?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
  workDayType?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeReceiptCounts = {
  __typename?: 'EmployeeReceiptCounts';
  signedReceiptsPercent?: Maybe<Scalars['Float']['output']>;
  totalPendingSignReceipts?: Maybe<Scalars['Int']['output']>;
  totalReceipts?: Maybe<Scalars['Int']['output']>;
  totalSignedReceipts?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeReceiptCountsResult = EmployeeReceiptCounts | ResourceNotFound;

export type EmployeeRecordsTagSubcategory = {
  __typename?: 'EmployeeRecordsTagSubcategory';
  _id: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isAiEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSoraSubcategory?: Maybe<Scalars['Boolean']['output']>;
  subcategory: Scalars['String']['output'];
};

export type EmployeeRecordsTags = {
  __typename?: 'EmployeeRecordsTags';
  _id?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  subcategories?: Maybe<Array<Maybe<Subcategory>>>;
};

export type EmployeeResult = EmployeeInfo | UserNotFound;

export type EmployeeSignature = {
  __typename?: 'EmployeeSignature';
  employeeId?: Maybe<Scalars['String']['output']>;
};

export type EmployeeWithoutRecordChecklist = {
  __typename?: 'EmployeeWithoutRecordChecklist';
  _id?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type EmployeeWithoutRecordChecklistDocument = {
  __typename?: 'EmployeeWithoutRecordChecklistDocument';
  fullName: Scalars['String']['output'];
  lastNameM: Scalars['String']['output'];
  lastNameP: Scalars['String']['output'];
  names: Scalars['String']['output'];
  profilePicture: Scalars['String']['output'];
  rfc: Scalars['String']['output'];
};

export type EmployeeWorkSpaceItem = {
  __typename?: 'EmployeeWorkSpaceItem';
  _id?: Maybe<Scalars['String']['output']>;
  alta?: Maybe<Scalars['String']['output']>;
  bajaDate?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  documentCounts?: Maybe<EmployeeDocumentCounter>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  legalStatusName?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WorkSpaceStatusEnum>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type EmployeesByCompanyIdsFilterInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employees?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  groups?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
  period?: InputMaybe<EmployeesDateFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchCounterDocsByEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  shouldGroupEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSearchByAllGroups?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workCenters?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  workTitles?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
};

export type EmployeesByCompanyIdsResult = {
  __typename?: 'EmployeesByCompanyIdsResult';
  employees?: Maybe<Array<Maybe<EmployeeWorkSpaceItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesChartItem = {
  __typename?: 'EmployeesChartItem';
  active?: Maybe<Scalars['Int']['output']>;
  inactive?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  timestamps?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesCounterByCompanyIdsFinalResult = EmployeesCounterByCompanyIdsResult;

export type EmployeesCounterByCompanyIdsResult = {
  __typename?: 'EmployeesCounterByCompanyIdsResult';
  data?: Maybe<Array<Maybe<EmployeesChartItem>>>;
  employeeCounters?: Maybe<EmployeeCounters>;
};

export type EmployeesDateFilter = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeesResult = {
  __typename?: 'EmployeesResult';
  employees?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalCompanyEmployeesCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeesValidationError = {
  __typename?: 'EmployeesValidationError';
  _id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type EmployeesValidationFinalResult = EmployeesValidationResult | ErrorToValdateEmployeesInfo;

export type EmployeesValidationInput = {
  employeesToValidate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmployeesValidationResult = {
  __typename?: 'EmployeesValidationResult';
  employees?: Maybe<Array<Maybe<User>>>;
  errors?: Maybe<Array<Maybe<EmployeesValidationError>>>;
};

export type EmptyCreditPaymentsTemplate = {
  __typename?: 'EmptyCreditPaymentsTemplate';
  message?: Maybe<Scalars['String']['output']>;
};

export type EmptyExcelTemplate = {
  __typename?: 'EmptyExcelTemplate';
  sheetName?: Maybe<Scalars['String']['output']>;
};

export type EndRegistrationToken = {
  __typename?: 'EndRegistrationToken';
  token?: Maybe<Scalars['String']['output']>;
};

export type Error = {
  __typename?: 'Error';
  filename?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userError?: Maybe<User>;
};

export type ErrorCreateCategory = ErrorMessage & {
  __typename?: 'ErrorCreateCategory';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorCreateSubcategory = ErrorMessage & {
  __typename?: 'ErrorCreateSubcategory';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorData = {
  __typename?: 'ErrorData';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
  userVerified?: Maybe<UserReferenceVerifyEmployeeData>;
};

export type ErrorDeleteCategory = ErrorMessage & {
  __typename?: 'ErrorDeleteCategory';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorDeleteSubcategory = ErrorMessage & {
  __typename?: 'ErrorDeleteSubcategory';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorInDeleteSupport = ErrorMessage & {
  __typename?: 'ErrorInDeleteSupport';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorInDocument = ErrorMessage & {
  __typename?: 'ErrorInDocument';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorMessage = {
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToApproveTemplate = ErrorMessage & {
  __typename?: 'ErrorToApproveTemplate';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToChangeWorkCenterEmployeeSupport = ErrorMessage & {
  __typename?: 'ErrorToChangeWorkCenterEmployeeSupport';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ErrorToCreateBeneficiariesDocument = ErrorMessage & {
  __typename?: 'ErrorToCreateBeneficiariesDocument';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToCreateEmployeeAbsence = ErrorMessage & {
  __typename?: 'ErrorToCreateEmployeeAbsence';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToCreateScheduleDocument = ErrorMessage & {
  __typename?: 'ErrorToCreateScheduleDocument';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToCreateTemplate = ErrorMessage & {
  __typename?: 'ErrorToCreateTemplate';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToCreateUserSupport = ErrorMessage & {
  __typename?: 'ErrorToCreateUserSupport';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToDeleteBeneficiariesDocument = ErrorMessage & {
  __typename?: 'ErrorToDeleteBeneficiariesDocument';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToDeleteCompanyAdmins = ErrorMessage & {
  __typename?: 'ErrorToDeleteCompanyAdmins';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToDeleteMultipleEmployeeAbsences = ErrorMessage & {
  __typename?: 'ErrorToDeleteMultipleEmployeeAbsences';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToDeleteSingleEmployeeAbsence = ErrorMessage & {
  __typename?: 'ErrorToDeleteSingleEmployeeAbsence';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToDownloadVerifyEmployeeData = ErrorMessage & {
  __typename?: 'ErrorToDownloadVerifyEmployeeData';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToEditUserSupport = ErrorMessage & {
  __typename?: 'ErrorToEditUserSupport';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToExportCompanies = ErrorMessage & {
  __typename?: 'ErrorToExportCompanies';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToExportDashboard = ErrorMessage & {
  __typename?: 'ErrorToExportDashboard';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToExportEmployeeAbsences = ErrorMessage & {
  __typename?: 'ErrorToExportEmployeeAbsences';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToExportGlobalDashboard = ErrorMessage & {
  __typename?: 'ErrorToExportGlobalDashboard';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToFinishEmployeeAbsence = ErrorMessage & {
  __typename?: 'ErrorToFinishEmployeeAbsence';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToFinishEmployeeAbsences = ErrorMessage & {
  __typename?: 'ErrorToFinishEmployeeAbsences';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGenerateLetter = ErrorMessage & {
  __typename?: 'ErrorToGenerateLetter';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetBeneficiaries = ErrorMessage & {
  __typename?: 'ErrorToGetBeneficiaries';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetClientDashboardCommercial = ErrorMessage & {
  __typename?: 'ErrorToGetClientDashboardCommercial';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetClientsReportCommercial = ErrorMessage & {
  __typename?: 'ErrorToGetClientsReportCommercial';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetCompaniesInfo = ErrorMessage & {
  __typename?: 'ErrorToGetCompaniesInfo';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetCompaniesReport = ErrorMessage & {
  __typename?: 'ErrorToGetCompaniesReport';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetCompanyModules = ErrorMessage & {
  __typename?: 'ErrorToGetCompanyModules';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetCustomChartCommercial = ErrorMessage & {
  __typename?: 'ErrorToGetCustomChartCommercial';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetDocument = ErrorMessage & {
  __typename?: 'ErrorToGetDocument';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetEmployeeAbsenceCountersByCriteria = ErrorMessage & {
  __typename?: 'ErrorToGetEmployeeAbsenceCountersByCriteria';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetEmployeeAbsencesByCriteria = ErrorMessage & {
  __typename?: 'ErrorToGetEmployeeAbsencesByCriteria';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetEmployeesCountToSendOnboardNotif = ErrorMessage & {
  __typename?: 'ErrorToGetEmployeesCountToSendOnboardNotif';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetInfoRequestedByCompany = ErrorMessage & {
  __typename?: 'ErrorToGetInfoRequestedByCompany';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetOnboardingDocs = ErrorMessage & {
  __typename?: 'ErrorToGetOnboardingDocs';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetPrivacyPolicyByUser = ErrorMessage & {
  __typename?: 'ErrorToGetPrivacyPolicyByUser';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetReceipt = ErrorMessage & {
  __typename?: 'ErrorToGetReceipt';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetSingleCompanyCommercial = ErrorMessage & {
  __typename?: 'ErrorToGetSingleCompanyCommercial';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetSoraDashboardCommercial = ErrorMessage & {
  __typename?: 'ErrorToGetSoraDashboardCommercial';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToGetUserWorkspace = ErrorMessage & {
  __typename?: 'ErrorToGetUserWorkspace';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToPublishTemplate = ErrorMessage & {
  __typename?: 'ErrorToPublishTemplate';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToRejectTemplate = ErrorMessage & {
  __typename?: 'ErrorToRejectTemplate';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToRequestBeneficiariesToEmployee = ErrorMessage & {
  __typename?: 'ErrorToRequestBeneficiariesToEmployee';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToSendMassiveOnboardingNotification = ErrorMessage & {
  __typename?: 'ErrorToSendMassiveOnboardingNotification';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToSendRecoveryUserSupport = ErrorMessage & {
  __typename?: 'ErrorToSendRecoveryUserSupport';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToSendVerificationData = ErrorMessage & {
  __typename?: 'ErrorToSendVerificationData';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToUpdateEmployeeAbsence = ErrorMessage & {
  __typename?: 'ErrorToUpdateEmployeeAbsence';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToUpdateEmployeeInfoRequired = ErrorMessage & {
  __typename?: 'ErrorToUpdateEmployeeInfoRequired';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToUpdateInfoRequestedByCompany = ErrorMessage & {
  __typename?: 'ErrorToUpdateInfoRequestedByCompany';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToUpdateTemplate = ErrorMessage & {
  __typename?: 'ErrorToUpdateTemplate';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToValdateEmployeesInfo = ErrorMessage & {
  __typename?: 'ErrorToValdateEmployeesInfo';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToValidateUserInfo = ErrorMessage & {
  __typename?: 'ErrorToValidateUserInfo';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToVerifyEmployeeData = ErrorMessage & {
  __typename?: 'ErrorToVerifyEmployeeData';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorToVerifyPendingDocumentWithAi = ErrorMessage & {
  __typename?: 'ErrorToVerifyPendingDocumentWithAi';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorUpdateCategory = ErrorMessage & {
  __typename?: 'ErrorUpdateCategory';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorUpdateCompanyActiveModules = ErrorMessage & {
  __typename?: 'ErrorUpdateCompanyActiveModules';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorUpdateSubcategory = ErrorMessage & {
  __typename?: 'ErrorUpdateSubcategory';
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorUserType = {
  _id?: InputMaybe<Scalars['String']['input']>;
  errors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExportBillingFilter = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type ExportBillingFinalResult = ExportBillingResult;

export type ExportBillingResult = {
  __typename?: 'ExportBillingResult';
  link?: Maybe<Scalars['String']['output']>;
};

export type ExportCompanyDocumentsInput = {
  documentsTableEnabledColumns?: InputMaybe<DocumentsTableColumnsOptions>;
  documentsTableFilters?: InputMaybe<DocumentsTableFilters>;
};

export type ExportCompanyDocumentsResult = Error | ExportCompanyDocumentsSuccess;

export type ExportCompanyDocumentsSuccess = {
  __typename?: 'ExportCompanyDocumentsSuccess';
  link?: Maybe<Scalars['String']['output']>;
};

export type ExportCreditsInput = {
  filter?: InputMaybe<AllCreditsFilter>;
};

export type ExportCreditsResult = CreditsNotFound | ExportLink;

export type ExportCustomersBillingFinalResult = ExportCustomersBillingResult;

export type ExportCustomersBillingInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExportCustomersBillingResult = {
  __typename?: 'ExportCustomersBillingResult';
  link?: Maybe<Scalars['String']['output']>;
};

export type ExportDashboardConfig = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alta?: InputMaybe<Scalars['Boolean']['input']>;
  cantBeSignedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameM?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameP?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Scalars['Boolean']['input']>;
  payrollId?: InputMaybe<Scalars['Boolean']['input']>;
  rfc?: InputMaybe<Scalars['Boolean']['input']>;
  signedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  signedReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  totalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  totalReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  unsignedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  unsignedReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  workCenterName?: InputMaybe<Scalars['Boolean']['input']>;
  workTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportDashboardInput = {
  configs?: InputMaybe<ExportDashboardConfig>;
  filter?: InputMaybe<DashboardFilter>;
};

export type ExportDashboardPeriod = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type ExportDashboardResult = ErrorToExportDashboard | FinalResponseExportDashboard;

export type ExportDocumentConfig = {
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  fullName: Scalars['Boolean']['input'];
  payrollId: Scalars['Boolean']['input'];
  priority: Scalars['Boolean']['input'];
  rfc: Scalars['Boolean']['input'];
  showSigners?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['Boolean']['input'];
  type: Scalars['Boolean']['input'];
  version: Scalars['Boolean']['input'];
  workCenterName: Scalars['Boolean']['input'];
};

export type ExportDocumentsInput = {
  configs?: InputMaybe<ExportDocumentConfig>;
  filter?: InputMaybe<DocumentFilter>;
};

export type ExportDocumentsResult = ExportLink | ExportMaxCountError;

export type ExportEmployeeAbsencesFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ExportEmployeeAbsencesFinalResult = ErrorToExportEmployeeAbsences | ExportEmployeeAbsencesResult;

export type ExportEmployeeAbsencesResult = {
  __typename?: 'ExportEmployeeAbsencesResult';
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportGlobalDashboardFilterInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  period?: InputMaybe<ExportDashboardPeriod>;
  shouldSearchByAllGroups?: InputMaybe<Scalars['Boolean']['input']>;
  workCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExportGlobalDashboardFinalResult = ErrorToExportGlobalDashboard | ExportGlobalDashboardResult;

export type ExportGlobalDashboardResult = {
  __typename?: 'ExportGlobalDashboardResult';
  link?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportLink = {
  __typename?: 'ExportLink';
  link: Scalars['String']['output'];
};

export type ExportMaxCountError = {
  __typename?: 'ExportMaxCountError';
  link: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ExportNewDashboardFinalResult = ExportNewDashboardResult;

export type ExportNewDashboardResult = {
  __typename?: 'ExportNewDashboardResult';
  link?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportReceiptConfig = {
  createdAt: Scalars['Boolean']['input'];
  curp: Scalars['Boolean']['input'];
  fullName: Scalars['Boolean']['input'];
  lastNameM: Scalars['Boolean']['input'];
  lastNameP: Scalars['Boolean']['input'];
  names: Scalars['Boolean']['input'];
  payrollId: Scalars['Boolean']['input'];
  period: Scalars['Boolean']['input'];
  receiptInvoice: Scalars['Boolean']['input'];
  rfc: Scalars['Boolean']['input'];
  stampDate: Scalars['Boolean']['input'];
  totalPaidDays: Scalars['Boolean']['input'];
  workCenterName: Scalars['Boolean']['input'];
};

export type ExportReceiptResult = ExportLink | ExportMaxCountError;

export type ExportReceiptsByStatusInput = {
  exportConfig: ExportReceiptConfig;
  queryInput: GetReceiptsByStatusInput;
};

export type ExportReceiptsInput = {
  configs?: InputMaybe<ExportReceiptConfig>;
  filter?: InputMaybe<ReceiptFilter>;
};

export type ExportReportByCompanyInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ExportReportByCompanyResult = ErrorToExportCompanies | FinalResponseToExportCompanies;

export type ExportUsersBillingFilter = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ExportUsersBillingFinalResult = ExportUsersBillingResult;

export type ExportUsersBillingResult = {
  __typename?: 'ExportUsersBillingResult';
  link?: Maybe<Scalars['String']['output']>;
};

export type ExportUsersConfig = {
  active: Scalars['Boolean']['input'];
  alta: Scalars['Boolean']['input'];
  bajaDate?: InputMaybe<Scalars['Boolean']['input']>;
  cantBeSignedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  cantBeSignedReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  curp: Scalars['Boolean']['input'];
  email: Scalars['Boolean']['input'];
  employmentStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  fullName: Scalars['Boolean']['input'];
  lastNameM: Scalars['Boolean']['input'];
  lastNameP: Scalars['Boolean']['input'];
  names: Scalars['Boolean']['input'];
  payrollId?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['Boolean']['input'];
  rfc: Scalars['Boolean']['input'];
  signedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  signedReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  unsignedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  unsignedReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  workCenterName: Scalars['Boolean']['input'];
  workTitle: Scalars['Boolean']['input'];
};

export type ExportUsersInput = {
  configs?: InputMaybe<ExportUsersConfig>;
  filter?: InputMaybe<UserFilter>;
};

export type ExportUsersResult = ExportLink | ExportMaxCountError;

export type ExtApiNotFound = ErrorMessage & {
  __typename?: 'ExtApiNotFound';
  message?: Maybe<Scalars['String']['output']>;
};

export type ExternalApiAlreadyExists = ErrorMessage & {
  __typename?: 'ExternalApiAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type FailUser = {
  __typename?: 'FailUser';
  message?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
};

export type FailUsersResult = {
  __typename?: 'FailUsersResult';
  failUsers?: Maybe<Array<Maybe<FailUser>>>;
  newUsers?: Maybe<Array<Maybe<User>>>;
};

export type FailedImportedReceipts = {
  __typename?: 'FailedImportedReceipts';
  employeeRfc: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  stampUUID: Scalars['String']['output'];
};

export type FailedNotification = {
  __typename?: 'FailedNotification';
  errorMessage: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type FederalEntity = {
  __typename?: 'FederalEntity';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type FederalEntityCountry = {
  __typename?: 'FederalEntityCountry';
  countryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<FederalEntityState>>>;
};

export type FederalEntityFilter = {
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isoCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type FederalEntityInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type FederalEntityState = {
  __typename?: 'FederalEntityState';
  cities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type File = {
  __typename?: 'File';
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  mimetype: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type FileData = {
  __typename?: 'FileData';
  companyName?: Maybe<Scalars['String']['output']>;
  companyRfc?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  employeeDocumentTitle?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  signDate?: Maybe<Scalars['Date']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  stampUUID?: Maybe<Scalars['String']['output']>;
  userRfc?: Maybe<Scalars['String']['output']>;
};

export type FileNotFound = {
  __typename?: 'FileNotFound';
  fileId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FileNotPublic = {
  __typename?: 'FileNotPublic';
  fileId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FilePresignedUrl = {
  __typename?: 'FilePresignedUrl';
  key?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Filter = {
  companyId: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userFullName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
  userRfc?: InputMaybe<Scalars['String']['input']>;
  userStatus: UserStatus;
  validationStatus: IdentityValidationStatus;
};

export type FilterInput = {
  excludeAdminsAsEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  excludeBajaUsers?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FilterInputWorkCenterFinder = {
  excludeBajaUsers?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FilteredCount = {
  __typename?: 'FilteredCount';
  absentUsers?: Maybe<Scalars['Int']['output']>;
  activeUsers?: Maybe<Scalars['Int']['output']>;
  bajaUsers?: Maybe<Scalars['Int']['output']>;
  inactiveUsers?: Maybe<Scalars['Int']['output']>;
  suingUsers?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FinalDocumentResponse = {
  __typename?: 'FinalDocumentResponse';
  compSignersToMarkAsSeen?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  compSignersToSign?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  documents?: Maybe<Array<Maybe<Document>>>;
  errors?: Maybe<Array<Maybe<Error>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FinalResponseChangeWorkCenterEmployeeSupport = {
  __typename?: 'FinalResponseChangeWorkCenterEmployeeSupport';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinalResponseCreateUserSupport = {
  __typename?: 'FinalResponseCreateUserSupport';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinalResponseDelete = {
  __typename?: 'FinalResponseDelete';
  id?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseDeleteCompanyAdmins = {
  __typename?: 'FinalResponseDeleteCompanyAdmins';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinalResponseDownloadApiFile = {
  __typename?: 'FinalResponseDownloadApiFile';
  file?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseExportDashboard = {
  __typename?: 'FinalResponseExportDashboard';
  message?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseGenerateLetter = {
  __typename?: 'FinalResponseGenerateLetter';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinalResponseGetClientDashboardCommercial = {
  __typename?: 'FinalResponseGetClientDashboardCommercial';
  companies?: Maybe<Array<Maybe<AnalyticsClientCommercialType>>>;
};

export type FinalResponseGetClientsReportCommercial = {
  __typename?: 'FinalResponseGetClientsReportCommercial';
  file?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseGetCompaniesInfo = {
  __typename?: 'FinalResponseGetCompaniesInfo';
  allCompanies?: Maybe<Array<Maybe<CompaniesInfoSupport>>>;
};

export type FinalResponseGetCompaniesReport = {
  __typename?: 'FinalResponseGetCompaniesReport';
  file?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseGetCustomChartCommercial = {
  __typename?: 'FinalResponseGetCustomChartCommercial';
  globalResults?: Maybe<Array<Maybe<CustomChartCommercialType>>>;
};

export type FinalResponseGetDocument = {
  __typename?: 'FinalResponseGetDocument';
  documentUrl?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseGetOnboardingDocs = {
  __typename?: 'FinalResponseGetOnboardingDocs';
  allDocuments?: Maybe<Array<Maybe<OnBoardingDocsSupport>>>;
  allReceipts?: Maybe<Array<Maybe<AllReceiptsSupport>>>;
  allUsersOnBoarding?: Maybe<Array<Maybe<OnboardingDocsUser>>>;
};

export type FinalResponseGetPrivacyPolicyByUser = {
  __typename?: 'FinalResponseGetPrivacyPolicyByUser';
  message?: Maybe<Scalars['String']['output']>;
  privacyPolicy?: Maybe<PrivacyPolicyByUser>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinalResponseGetReceipt = {
  __typename?: 'FinalResponseGetReceipt';
  documentUrl?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseGetSingleCompanyCommercial = {
  __typename?: 'FinalResponseGetSingleCompanyCommercial';
  globalResults?: Maybe<Array<Maybe<AnalyticsCommercialSingleCompType>>>;
};

export type FinalResponseGetSoraDashboardCommercial = {
  __typename?: 'FinalResponseGetSoraDashboardCommercial';
  globalResults?: Maybe<Array<Maybe<AnalyticsCommercialSoraType>>>;
};

export type FinalResponseGetUsersSupport = {
  __typename?: 'FinalResponseGetUsersSupport';
  allUsers?: Maybe<Array<Maybe<UserSupport>>>;
};

export type FinalResponsePrivacyPolicyAccepted = {
  __typename?: 'FinalResponsePrivacyPolicyAccepted';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FinalResponseSendRecoveryUserSupport = {
  __typename?: 'FinalResponseSendRecoveryUserSupport';
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinalResponseToEditUserSupport = {
  __typename?: 'FinalResponseToEditUserSupport';
  email?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseToExportCompanies = {
  __typename?: 'FinalResponseToExportCompanies';
  excelUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FinalResponseValidateUserInfo = {
  __typename?: 'FinalResponseValidateUserInfo';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type FinishEmployeeAbsenceFinalResult = ErrorToFinishEmployeeAbsence | FinishEmployeeAbsenceResult;

export type FinishEmployeeAbsenceInput = {
  absenceId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
};

export type FinishEmployeeAbsenceResult = {
  __typename?: 'FinishEmployeeAbsenceResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FinishEmployeeAbsencesFinalResult = ErrorToFinishEmployeeAbsences | FinishEmployeeAbsencesResult;

export type FinishEmployeeAbsencesInput = {
  absenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
};

export type FinishEmployeeAbsencesResult = {
  __typename?: 'FinishEmployeeAbsencesResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FiscalDetails = {
  __typename?: 'FiscalDetails';
  cfdiUse?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  dailyBaseSalary?: Maybe<Scalars['Float']['output']>;
  dailyIntegratedSalary?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  daysPaidNumber?: Maybe<Scalars['String']['output']>;
  employerRegistration?: Maybe<Scalars['String']['output']>;
  employmentStartDate?: Maybe<Scalars['Date']['output']>;
  expeditionLocation?: Maybe<Scalars['String']['output']>;
  fiscalRegime?: Maybe<Scalars['String']['output']>;
  paymentPeriodicity?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  regimeType?: Maybe<Scalars['String']['output']>;
  satQr?: Maybe<Scalars['String']['output']>;
  satStamp?: Maybe<Scalars['String']['output']>;
  satStampCert?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  stampCFD?: Maybe<Scalars['String']['output']>;
  stampDate?: Maybe<Scalars['Date']['output']>;
  voucherType?: Maybe<Scalars['String']['output']>;
  workingDayType?: Maybe<Scalars['String']['output']>;
};

export type ForbiddenCompanyError = ErrorMessage & {
  __typename?: 'ForbiddenCompanyError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FunctionalitiesInput = {
  document: FunctionalityInput;
  employee: FunctionalityInput;
  receipt: FunctionalityInput;
  workCenter: FunctionalityInput;
};

export type Functionality = {
  __typename?: 'Functionality';
  create?: Maybe<Scalars['Boolean']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type FunctionalityInput = {
  create: Scalars['Boolean']['input'];
  delete: Scalars['Boolean']['input'];
  read: Scalars['Boolean']['input'];
  update: Scalars['Boolean']['input'];
};

export type FunctionalityObj = {
  __typename?: 'FunctionalityObj';
  document?: Maybe<Functionality>;
  employee?: Maybe<Functionality>;
  receipt?: Maybe<Functionality>;
  timestamps?: Maybe<TimeStampObj>;
  workCenter?: Maybe<Functionality>;
};

export type GeneralError = {
  __typename?: 'GeneralError';
  message?: Maybe<Scalars['String']['output']>;
};

export type GenerateLetterSupportInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  constantType?: InputMaybe<Scalars['String']['input']>;
  employeeDocId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateLetterSupportResult = ErrorToGenerateLetter | FinalResponseGenerateLetter;

export type GenerateTemporalPasswordError = {
  __typename?: 'GenerateTemporalPasswordError';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateTemporalPasswordInput = {
  password: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type GenerateTemporalPasswordResult = GenerateTemporalPasswordError | GenerateTemporalPasswordSuccess;

export type GenerateTemporalPasswordSuccess = {
  __typename?: 'GenerateTemporalPasswordSuccess';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  temporalPassword?: Maybe<Scalars['String']['output']>;
};

export type GetAdminDashboardFilter = {
  categories?: InputMaybe<Array<InputMaybe<CategoryItem>>>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employees?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  groups?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
  initialChartPeriod?: InputMaybe<DateFilter>;
  period?: InputMaybe<DateFilter>;
  shouldSearchByAllGroups?: InputMaybe<Scalars['Boolean']['input']>;
  workCenters?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  workTitles?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
};

export type GetAdminDashboardFinalResult = {
  __typename?: 'GetAdminDashboardFinalResult';
  checkListProgressDashboard?: Maybe<GetRecordChecklistGeneralPercentageResult>;
  counterEmployeeStatusDashboard?: Maybe<EmployeesCounterByCompanyIdsResult>;
  documentProgressDashboard?: Maybe<DocumentsCountByCompanyIdsResult>;
  onboardingProgressDashboard?: Maybe<EmployeesCounterByCompanyIdsResult>;
  receiptProgressDashboard?: Maybe<ReceiptsCounterByCompanyIdsResult>;
  receiptsSentDashboard?: Maybe<TotalRececeiptsSentDashboardResult>;
};

export type GetAllEmployeesByCriteriaFilterInput = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employeeIdsToExclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludeBajaUsers?: InputMaybe<Scalars['Boolean']['input']>;
  groupNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recordChecklistId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetAllEmployeesByCriteriaResult = GetAllEmployeesByCriteriaSuccess;

export type GetAllEmployeesByCriteriaSuccess = {
  __typename?: 'GetAllEmployeesByCriteriaSuccess';
  employees?: Maybe<Array<Maybe<User>>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetAllTemplatesCountersInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllTemplatesInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllVideoAgreementTemplatesResult = {
  __typename?: 'GetAllVideoAgreementTemplatesResult';
  videoAgreementTemplates?: Maybe<Array<Maybe<VideoAgreementTemplate>>>;
};

export type GetBeneficiariesFinalResult = ErrorToGetBeneficiaries | GetBeneficiariesResult;

export type GetBeneficiariesInput = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GetBeneficiariesResult = {
  __typename?: 'GetBeneficiariesResult';
  beneficiariesConfig?: Maybe<BeneficiariesConfigEntity>;
  beneficiariesNotifications?: Maybe<BeneficiariesNotifications>;
  documentId?: Maybe<Scalars['String']['output']>;
  isPending?: Maybe<Scalars['Boolean']['output']>;
};

export type GetBillingInfoFilter = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetBillingInfoFinalResult = BillingInfoResult;

export type GetClientDashboardCommercialInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GetClientDashboardCommercialResult = ErrorToGetClientDashboardCommercial | FinalResponseGetClientDashboardCommercial;

export type GetClientsReportCommercialInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type GetClientsReportCommercialResult = ErrorToGetClientsReportCommercial | FinalResponseGetClientsReportCommercial;

export type GetCompaniesInfoInput = {
  bajaUsers?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetCompaniesInfoSupportResult = ErrorToGetCompaniesInfo | FinalResponseGetCompaniesInfo;

export type GetCompaniesReportInput = {
  bajaUsers?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetCompaniesReportSupportResult = ErrorToGetCompaniesReport | FinalResponseGetCompaniesReport;

export type GetCompanyAdminsFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  paginationIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetCompanyAdminsFinalResult = GetCompanyAdminsResult;

export type GetCompanyAdminsResult = {
  __typename?: 'GetCompanyAdminsResult';
  admins?: Maybe<Array<Maybe<AdminItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetCompanyDocumentsCountersInput = {
  documentsTableFilters?: InputMaybe<DocumentsTableCountersFilters>;
};

export type GetCompanyDocumentsInput = {
  documentsTableFilters?: InputMaybe<DocumentsTableFilters>;
  documentsTableSortingAndPaging?: InputMaybe<DocumentsTableSortingAndPaging>;
};

export type GetCompanyDocumentsResult = {
  __typename?: 'GetCompanyDocumentsResult';
  companyDocuments?: Maybe<CompanyDocumentsResult>;
  companyDocumentsCounters?: Maybe<CompanyDocumentsCountersResult>;
};

export type GetCompanyEmployeesInput = {
  advancedFilters?: InputMaybe<AdvancedFilters>;
  legalStatus?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortingAndPaging?: InputMaybe<SortingAndPaging>;
  status?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};

export type GetCompanyEmployeesResult = GetCompanyEmployeesSuccess;

export type GetCompanyEmployeesSuccess = {
  __typename?: 'GetCompanyEmployeesSuccess';
  companyEmployees?: Maybe<Array<Maybe<CompanyEmployee>>>;
};

export type GetCompanyEmployeesSupportInput = {
  advancedFilters?: InputMaybe<AdvancedFilters>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  legalStatus?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortingAndPaging?: InputMaybe<SortingAndPaging>;
  status?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};

export type GetCompanyFilter = {
  companyId: Scalars['String']['input'];
};

export type GetCompanyFinalResult = GetCompanyResult;

export type GetCompanyHolidaysInput = {
  includeOfficialHolidays: Scalars['Boolean']['input'];
};

export type GetCompanyHolidaysResult = Error | HolidaysResult;

export type GetCompanyModulesFilterInput = {
  companyId: Scalars['String']['input'];
};

export type GetCompanyModulesFinalResult = CompanyModulesResult | ErrorToGetCompanyModules;

export type GetCompanyResult = {
  __typename?: 'GetCompanyResult';
  companyData?: Maybe<Company>;
};

export type GetCompanySchemesResult = {
  __typename?: 'GetCompanySchemesResult';
  schemes: Array<Maybe<HolidayScheme>>;
};

export type GetCompanySignerNotificationsConfigResult = {
  __typename?: 'GetCompanySignerNotificationsConfigResult';
  disableCompanySignerNotifications?: Maybe<DisableCompanySignerNotifications>;
  groupCompanySignerNotifications?: Maybe<GroupCompanySignerNotifications>;
};

export type GetCompletedDocumentsByRecordChecklistFilterInput = {
  category: Scalars['String']['input'];
  recordChecklistId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  subcategory: Scalars['String']['input'];
};

export type GetCompletedDocumentsByRecordChecklistResult = {
  __typename?: 'GetCompletedDocumentsByRecordChecklistResult';
  documents: Array<Maybe<CompletedDocumentByRecordChecklist>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetCustomChartCommercialInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  isSoraCompany?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomChartCommercialResult = ErrorToGetCustomChartCommercial | FinalResponseGetCustomChartCommercial;

export type GetCustomersBillingFilter = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetCustomersBillingFinalResult = CustomersBillingResult;

export type GetDocumentCountsByEmployeeInput = {
  advancedFilters?: InputMaybe<AdvancedFilters>;
  legalStatus?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortingAndPaging?: InputMaybe<SortingAndPaging>;
  status?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDocumentCountsByEmployeeResult = {
  __typename?: 'GetDocumentCountsByEmployeeResult';
  employeeDocumentCounts?: Maybe<EmployeeDocumentCountsResult>;
};

export type GetDocumentResult = ErrorToGetDocument | FinalResponseGetDocument;

export type GetDocumentTagsSummaryInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDocumentTagsSummaryResult = {
  __typename?: 'GetDocumentTagsSummaryResult';
  categories?: Maybe<Array<Maybe<CategorySummary>>>;
};

export type GetDocumentTagsSummaryResultUnion = Error | GetDocumentTagsSummaryResult;

export type GetEmployeeAbsenceCountersByCriteriaFinalResult = ErrorToGetEmployeeAbsenceCountersByCriteria | GetEmployeeAbsenceCountersByCriteriaResult;

export type GetEmployeeAbsenceCountersByCriteriaInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type GetEmployeeAbsenceCountersByCriteriaResult = {
  __typename?: 'GetEmployeeAbsenceCountersByCriteriaResult';
  completed?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
};

export type GetEmployeeAbsencesByCriteriaFinalResult = ErrorToGetEmployeeAbsencesByCriteria | GetEmployeeAbsencesByCriteriaResult;

export type GetEmployeeAbsencesByCriteriaInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GetEmployeeAbsencesByCriteriaResult = {
  __typename?: 'GetEmployeeAbsencesByCriteriaResult';
  absenceData?: Maybe<Array<Maybe<AbsenceFinalItem>>>;
};

export type GetEmployeeHolidaysSummaryResult = {
  __typename?: 'GetEmployeeHolidaysSummaryResult';
  approvedHolidayRequestToSignAsTaken?: Maybe<HolidayRequest>;
  employmentStartDate?: Maybe<Scalars['Date']['output']>;
  holidaySetupError?: Maybe<Scalars['String']['output']>;
  holidaysSummary: Array<HolidaySummary>;
  pendingHolidayRequest?: Maybe<HolidayRequest>;
  rejectedHolidayRequest?: Maybe<HolidayRequest>;
  unsignedApprovedHolidayRequest?: Maybe<HolidayRequest>;
};

export type GetEmployeeHolidaysSummaryResultUnion = Error | GetEmployeeHolidaysSummaryResult;

export type GetEmployeeInfoInput = {
  employeeId: Scalars['String']['input'];
  employeeWorkSpaceId?: InputMaybe<Scalars['String']['input']>;
};

export type GetEmployeeInfoResult = {
  __typename?: 'GetEmployeeInfoResult';
  employeeDocumentCounts?: Maybe<EmployeeDocumentCountsResult>;
  employeeInfo?: Maybe<EmployeeResult>;
  employeeReceiptCounts?: Maybe<EmployeeReceiptCountsResult>;
  recordChecklistAssigned?: Maybe<RecordChecklistAssignedResult>;
  recordChecklistAssignedDocumentsCounts?: Maybe<RecordChecklistAssignedDocumentsCountsResult>;
};

export type GetEmployeeRecordsTagsResult = {
  __typename?: 'GetEmployeeRecordsTagsResult';
  _id: Scalars['String']['output'];
  category: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isSoraCategory?: Maybe<Scalars['Boolean']['output']>;
  subcategories?: Maybe<Array<Maybe<EmployeeRecordsTagSubcategory>>>;
};

export type GetEmployeesByGroupResult = GetEmployeesByGroupSuccess;

export type GetEmployeesByGroupSuccess = {
  __typename?: 'GetEmployeesByGroupSuccess';
  employees?: Maybe<Array<Maybe<User>>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetEmployeesByRecordChecklisFilterInput = {
  groupNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetEmployeesByRecordChecklistResult = GetEmployeesByRecordChecklistSuccess;

export type GetEmployeesByRecordChecklistSuccess = {
  __typename?: 'GetEmployeesByRecordChecklistSuccess';
  employees?: Maybe<Array<Maybe<User>>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetEmployeesByWorkTitleResult = GetEmployeesByWorkTitleSuccess;

export type GetEmployeesByWorkTitleSuccess = {
  __typename?: 'GetEmployeesByWorkTitleSuccess';
  employees?: Maybe<Array<Maybe<User>>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetEmployeesCountToSendOnboardNotifFinalResult = ErrorToGetEmployeesCountToSendOnboardNotif | GetEmployeesCountToSendOnboardNotifResult;

export type GetEmployeesCountToSendOnboardNotifInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type GetEmployeesCountToSendOnboardNotifResult = {
  __typename?: 'GetEmployeesCountToSendOnboardNotifResult';
  emailCount?: Maybe<Scalars['Int']['output']>;
  noContactCount?: Maybe<Scalars['Int']['output']>;
  phoneCount?: Maybe<Scalars['Int']['output']>;
};

export type GetEmployeesCountersByStatusInput = {
  advancedFilters?: InputMaybe<AdvancedFilters>;
  search?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};

export type GetEmployeesCountersByStatusResult = GetEmployeesCountersByStatusSuccess;

export type GetEmployeesCountersByStatusSuccess = {
  __typename?: 'GetEmployeesCountersByStatusSuccess';
  filteredCount?: Maybe<FilteredCount>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GetEmployeesCountersByStatusSupportInput = {
  advancedFilters?: InputMaybe<AdvancedFilters>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};

export type GetEmployeesWithoutChecklistDocumentFilterInput = {
  category: Scalars['String']['input'];
  recordChecklistId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  subcategory: Scalars['String']['input'];
};

export type GetEmployeesWithoutChecklistDocumentResult = {
  __typename?: 'GetEmployeesWithoutChecklistDocumentResult';
  employees: Array<Maybe<EmployeeWithoutRecordChecklistDocument>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetEmployeesWithoutRecordChecklisFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetEmployeesWithoutRecordChecklistResult = GetEmployeesWithoutRecordChecklistSuccess;

export type GetEmployeesWithoutRecordChecklistSuccess = {
  __typename?: 'GetEmployeesWithoutRecordChecklistSuccess';
  employees?: Maybe<Array<Maybe<EmployeeWithoutRecordChecklist>>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetFileDataByLegalStatusInput = {
  fileId: Scalars['String']['input'];
};

export type GetFileDataByLegalStatusResult = CompanyNotFound | FileData | FileNotFound | FileNotPublic | UserNotFound;

export type GetGroupsByCompanyIdsFilterInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetGroupsByCompanyIdsFinalResult = GetGroupsByCompanyIdsResult;

export type GetGroupsByCompanyIdsResult = {
  __typename?: 'GetGroupsByCompanyIdsResult';
  groups?: Maybe<Array<Maybe<CompanyGroupItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetHolidayAuthorizersTeamsFinalResult = Error | GetHolidayAuthorizersTeamsResult;

export type GetHolidayAuthorizersTeamsResult = {
  __typename?: 'GetHolidayAuthorizersTeamsResult';
  authorizerTeams?: Maybe<Array<Maybe<AuthorizerTeamItem>>>;
};

export type GetHolidaysFromRolesCountersInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetHolidaysFromRolesCountersResult = {
  __typename?: 'GetHolidaysFromRolesCountersResult';
  counters?: Maybe<Counters>;
};

export type GetHolidaysFromRolesInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status: HolidayFilterStatus;
};

export type GetHolidaysFromRolesResult = {
  __typename?: 'GetHolidaysFromRolesResult';
  data: Array<HolidayRequest>;
  total: Scalars['Int']['output'];
};

export type GetHolidaysFromRolesResultUnion = Error | GetHolidaysFromRolesResult;

export enum GetHtmlTypEnum {
  Document = 'DOCUMENT',
  Receipt = 'RECEIPT'
}

export type GetInfoRequestedByCompany = {
  __typename?: 'GetInfoRequestedByCompany';
  completedBy?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GetInfoRequestedByCompanyFilterInput = {
  companyId: Scalars['String']['input'];
};

export type GetInfoRequestedByCompanyFinalResult = ErrorToGetInfoRequestedByCompany | InfoRequestedByCompanyResult;

export type GetInfoUserSupportInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetLocationByIdInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};

export type GetLocationByIdResult = {
  __typename?: 'GetLocationByIdResult';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type GetLocationByZipCodeInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type GetLocationByZipCodeResult = {
  __typename?: 'GetLocationByZipCodeResult';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type GetLocationSuggestionsInput = {
  textToSearch?: InputMaybe<Scalars['String']['input']>;
};

export type GetLocationSuggestionsResult = {
  __typename?: 'GetLocationSuggestionsResult';
  suggestions?: Maybe<Array<Maybe<LocationSuggestion>>>;
};

export type GetMyPendingDocumentsAndReceiptsFilter = {
  excludeAdminDocs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetMyPendingDocumentsAndReceiptsResult = {
  __typename?: 'GetMyPendingDocumentsAndReceiptsResult';
  documentsAndReceipts?: Maybe<Array<Maybe<MyPendingDocumentOrReceipt>>>;
  requestedDocuments?: Maybe<Array<Maybe<RequestedEmployeeDocument>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetMyProfileResult = {
  __typename?: 'GetMyProfileResult';
  pendingDocs?: Maybe<PendingDocs>;
  user?: Maybe<User>;
};

export type GetOnboardingDocsInput = {
  user?: InputMaybe<Scalars['String']['input']>;
};

export type GetOnboardingDocsResult = ErrorToGetOnboardingDocs | FinalResponseGetOnboardingDocs;

export type GetOnboardingLinkInput = {
  employeeId: Scalars['String']['input'];
};

export type GetOnboardingLinkResult = GetOnboardingLinkSuccess | UserAlreadyActive | UserAlreadyHasPassword | UserIsNotAdmin | UserMustBeSifeType | UserNotFound;

export type GetOnboardingLinkSuccess = {
  __typename?: 'GetOnboardingLinkSuccess';
  onboardingLink?: Maybe<Scalars['String']['output']>;
};

export type GetPendingDocumentsByRecordChecklistFilterInput = {
  category: Scalars['String']['input'];
  recordChecklistId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  subcategory: Scalars['String']['input'];
};

export type GetPendingDocumentsByRecordChecklistResult = {
  __typename?: 'GetPendingDocumentsByRecordChecklistResult';
  documents: Array<Maybe<PendingDocumentByRecordChecklist>>;
  pagination?: Maybe<PaginationResult>;
};

export type GetPendingOnboardingDocumentsInput = {
  excludeAdminOnboardingDocs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetPrivacyPolicyByUserInput = {
  userId: Scalars['String']['input'];
};

export type GetPrivacyPolicyByUserResult = ErrorToGetPrivacyPolicyByUser | FinalResponseGetPrivacyPolicyByUser;

export type GetPrivateFileDataInput = {
  fileId: Scalars['String']['input'];
};

export type GetPrivateFileDataResult = CompanyNotFound | FileData | FileNotFound | UnauthorizedResource | UserNotFound;

export type GetReceiptByStatus = {
  __typename?: 'GetReceiptByStatus';
  receipts?: Maybe<Array<Maybe<Receipt>>>;
};

export type GetReceiptByStatusAdvancedFilterInput = {
  advancedSearch?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  workCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReceiptByStatusFilterInput = {
  dateRange?: InputMaybe<ReceiptsDateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  signStatus?: InputMaybe<SignStatusEnum>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReceiptByStatusResult = ForbiddenCompanyError | GetReceiptByStatus;

export type GetReceiptCountersByStatus = {
  __typename?: 'GetReceiptCountersByStatus';
  totalNonSignableReceipts?: Maybe<Scalars['Int']['output']>;
  totalReceipts?: Maybe<Scalars['Int']['output']>;
  totalSignedReceipts?: Maybe<Scalars['Int']['output']>;
  totalUnsignedReceipts?: Maybe<Scalars['Int']['output']>;
};

export type GetReceiptCountersByStatusAdvancedFilterInput = {
  advancedSearch?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  workCenters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReceiptCountersByStatusFilterInput = {
  dateRange?: InputMaybe<ReceiptsDateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReceiptCountersByStatusResult = ForbiddenCompanyError | GetReceiptCountersByStatus;

export type GetReceiptCountsByEmployeeInput = {
  advancedFilters?: InputMaybe<AdvancedFilters>;
  legalStatus?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortingAndPaging?: InputMaybe<SortingAndPaging>;
  status?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};

export type GetReceiptCountsByEmployeeResult = {
  __typename?: 'GetReceiptCountsByEmployeeResult';
  employeeReceiptCounts?: Maybe<EmployeeReceiptCountsResult>;
};

export type GetReceiptsByStatusInput = {
  advancedFilter?: InputMaybe<GetReceiptByStatusAdvancedFilterInput>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<GetReceiptByStatusFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<GetReceiptsByStatusSortInput>;
};

export enum GetReceiptsByStatusSortFieldEnum {
  Createdat = 'CREATEDAT',
  Date = 'DATE',
  Fullname = 'FULLNAME',
  Rfc = 'RFC',
  Title = 'TITLE'
}

export type GetReceiptsByStatusSortInput = {
  field: GetReceiptsByStatusSortFieldEnum;
  order: SortOrderEnum;
};

export type GetReceiptsCountersByStatusInput = {
  advancedFilter?: InputMaybe<GetReceiptCountersByStatusAdvancedFilterInput>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<GetReceiptCountersByStatusFilterInput>;
};

export type GetRecordChecklistDocumentTagPercentagesFilterInput = {
  companyId: Scalars['String']['input'];
  recordChecklistId: Scalars['String']['input'];
};

export type GetRecordChecklistDocumentTagPercentagesResult = {
  __typename?: 'GetRecordChecklistDocumentTagPercentagesResult';
  documentTagPercentages: Array<Maybe<DocumentTagPercentage>>;
};

export type GetRecordChecklistGeneralPercentageFilterInput = {
  companyIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type GetRecordChecklistGeneralPercentageResult = {
  __typename?: 'GetRecordChecklistGeneralPercentageResult';
  generalPercentage: Scalars['Float']['output'];
  individualPercentages: Array<Maybe<RecordChecklistIndividualPercentage>>;
};

export type GetSingleCompanyCommercialInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  getTotalGroup?: InputMaybe<Scalars['Boolean']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type GetSingleCompanyCommercialResult = ErrorToGetSingleCompanyCommercial | FinalResponseGetSingleCompanyCommercial;

export type GetSoraDashboardCommercialInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  granularity?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type GetSoraDashboardCommercialResult = ErrorToGetSoraDashboardCommercial | FinalResponseGetSoraDashboardCommercial;

export type GetTemplateResult = ResourceNotFound | TemplateResult;

export type GetTotalEmployeesByGroupResult = GetTotalEmployeesByGroupSuccess;

export type GetTotalEmployeesByGroupSuccess = {
  __typename?: 'GetTotalEmployeesByGroupSuccess';
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetTotalEmployeesByWorkTitleResult = GetTotalEmployeesByWorkTitleSuccess;

export type GetTotalEmployeesByWorkTitleSuccess = {
  __typename?: 'GetTotalEmployeesByWorkTitleSuccess';
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetTotalEmployeesWithDiffRecordChecklistResult = GetTotalEmployeesWithDiffRecordChecklistSuccess;

export type GetTotalEmployeesWithDiffRecordChecklistSuccess = {
  __typename?: 'GetTotalEmployeesWithDiffRecordChecklistSuccess';
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetUserOnboardingStepsInput = {
  excludeAdminOnboardingDocs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserOnboardingStepsResult = CurpRequiredForVideoAgreementRegistrationType | UserOnboardingSteps;

export type GetUserPermissionsResult = UserPermissions | WorkCenterNotFound;

export type GetUserSupportInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserSupportResult = FinalResponseGetUsersSupport | GetUsersNoResult;

export type GetUserWorkspaceFinalResult = ErrorToGetUserWorkspace | GetUserWorkspaceResult;

export type GetUserWorkspaceInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserWorkspaceResult = {
  __typename?: 'GetUserWorkspaceResult';
  workSpace?: Maybe<User>;
};

export type GetUsersBillingFilter = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type GetUsersBillingFinalResult = UsersBillingResult;

export type GetUsersIdentityValidationStatusCounterFilter = {
  companyId: Scalars['String']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userFullName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
  userRfc?: InputMaybe<Scalars['String']['input']>;
  userStatus: UserStatus;
};

export type GetUsersIdentityValidationStatusCounterInput = {
  filters?: InputMaybe<GetUsersIdentityValidationStatusCounterFilter>;
};

export type GetUsersIdentityValidationStatusCounterResult = {
  __typename?: 'GetUsersIdentityValidationStatusCounterResult';
  approved?: Maybe<Scalars['Int']['output']>;
  notVerified?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
};

export type GetUsersIdentityValidationStatusInput = {
  filters?: InputMaybe<Filter>;
  sortingAndPaging?: InputMaybe<Paging>;
};

export type GetUsersIdentityValidationStatusResult = {
  __typename?: 'GetUsersIdentityValidationStatusResult';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  identityValidationReason?: Maybe<Scalars['String']['output']>;
  identityValidationStatus?: Maybe<Scalars['String']['output']>;
  identityVerificationImages?: Maybe<IdentityVerificationImages>;
  identityVerificationType?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
};

export type GetUsersNoResult = ErrorMessage & {
  __typename?: 'GetUsersNoResult';
  message?: Maybe<Scalars['String']['output']>;
};

export type GetUsersResult = FailUsersResult | GetUsersSuccess;

export type GetUsersSuccess = {
  __typename?: 'GetUsersSuccess';
  newUsers?: Maybe<Array<Maybe<User>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetWCsByCompIdInput = {
  companyId: Scalars['String']['input'];
};

export type GetWCsByCompIdsInput = {
  compIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type GetWorkCentersByCompanyIdsFilterInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetWorkCentersByCompanyIdsFinalResult = GetWorkCentersByCompanyIdsResult;

export type GetWorkCentersByCompanyIdsResult = {
  __typename?: 'GetWorkCentersByCompanyIdsResult';
  total?: Maybe<Scalars['Int']['output']>;
  workCenters?: Maybe<Array<Maybe<WorkCenterItem>>>;
};

export type GetWorkTitlesByCompanyIdsFilterInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetWorkTitlesByCompanyIdsFinalResult = GetWorkTitlesByCompanyIdsResult;

export type GetWorkTitlesByCompanyIdsResult = {
  __typename?: 'GetWorkTitlesByCompanyIdsResult';
  total?: Maybe<Scalars['Int']['output']>;
  workTitles?: Maybe<Array<Maybe<CompanyWorkTitleItem>>>;
};

export type GroupAlreadyExists = {
  __typename?: 'GroupAlreadyExists';
  groupName?: Maybe<Scalars['String']['output']>;
};

export type GroupCompanySignerNotifications = {
  __typename?: 'GroupCompanySignerNotifications';
  active?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type GroupCompanySignerNotificationsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupCreated = {
  __typename?: 'GroupCreated';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GroupDeleted = {
  __typename?: 'GroupDeleted';
  name?: Maybe<Scalars['String']['output']>;
};

export type GroupUpdated = {
  __typename?: 'GroupUpdated';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Holiday = {
  __typename?: 'Holiday';
  _id: Scalars['String']['output'];
  color: Scalars['String']['output'];
  createdBy: HolidayCreatedBy;
  creationType: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  displayTitle: Scalars['String']['output'];
  timestamps: TimestampsItem;
  title: Scalars['String']['output'];
  type: HolidayType;
};

export type HolidayAlreadyExists = {
  __typename?: 'HolidayAlreadyExists';
  date?: Maybe<Scalars['Date']['output']>;
};

export type HolidayCreatedBy = {
  __typename?: 'HolidayCreatedBy';
  _id: Scalars['String']['output'];
  curp?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names: Scalars['String']['output'];
  rfc?: Maybe<Scalars['String']['output']>;
};

export enum HolidayFilterStatus {
  All = 'ALL',
  Finished = 'FINISHED',
  Incoming = 'INCOMING',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type HolidayRequest = {
  __typename?: 'HolidayRequest';
  _id: Scalars['String']['output'];
  approveEmployeeDocumentId: Scalars['String']['output'];
  authorizationTeam: AuthorizerTeamItem;
  authorizations: Array<HolidayRequestAuthorization>;
  comments?: Maybe<Scalars['String']['output']>;
  daysRequested: Array<Scalars['Date']['output']>;
  employee: UserAndWorkSpaceReferenceTypeDefs;
  holidayTakenEmployeeDocumentId?: Maybe<Scalars['String']['output']>;
  requestForYear: Scalars['Int']['output'];
  status: HolidayRequestStatus;
  timestamps: TimeStampObj;
  workCenter: WorkCenterReference;
};

export type HolidayRequestAuthorization = {
  __typename?: 'HolidayRequestAuthorization';
  authorizer: UserReference;
  comments: Scalars['String']['output'];
  status: HolidayRequestStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum HolidayRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Taken = 'TAKEN'
}

export type HolidayScheme = {
  __typename?: 'HolidayScheme';
  _id: Scalars['String']['output'];
  approveTemplateId?: Maybe<Scalars['String']['output']>;
  authorizersTeamId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdBy: UserReference;
  description?: Maybe<Scalars['String']['output']>;
  employeesCount: Scalars['Int']['output'];
  holidayTakenTemplateId?: Maybe<Scalars['String']['output']>;
  scheme: Array<Maybe<DaysEarned>>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type HolidaySchemeInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  daysPerMonth?: InputMaybe<Array<InputMaybe<DaysPerMonthInput>>>;
  year: Scalars['Int']['input'];
};

export type HolidaySummary = {
  __typename?: 'HolidaySummary';
  employmentStartDate: Scalars['Date']['output'];
  endDate: Scalars['Date']['output'];
  expired: Scalars['Boolean']['output'];
  holidaysApproved: Scalars['Int']['output'];
  holidaysApprovedDates: Array<Scalars['Date']['output']>;
  holidaysAvailable: Scalars['Int']['output'];
  holidaysInTakenState: Scalars['Int']['output'];
  holidaysTaken: Scalars['Int']['output'];
  holidaysTakenDates: Array<Scalars['Date']['output']>;
  startDate: Scalars['Date']['output'];
  year: Scalars['Int']['output'];
};

export enum HolidayType {
  Company = 'COMPANY',
  Official = 'OFFICIAL'
}

export type HolidaysResult = {
  __typename?: 'HolidaysResult';
  holidays?: Maybe<Array<Maybe<Holiday>>>;
};

export enum HttpMethods {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export enum IdentityValidationStatus {
  Approved = 'APPROVED',
  NotVerified = 'NOT_VERIFIED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type IdentityVerificationImages = {
  __typename?: 'IdentityVerificationImages';
  back?: Maybe<Scalars['String']['output']>;
  front?: Maybe<Scalars['String']['output']>;
  selfie?: Maybe<Scalars['String']['output']>;
};

export type ImportAuthorizersTeamError = {
  __typename?: 'ImportAuthorizersTeamError';
  errors: Array<Maybe<ImportAuthorizersTeamErrorItem>>;
  rows: Array<Maybe<ImportAuthorizersTeamRow>>;
};

export type ImportAuthorizersTeamErrorItem = {
  __typename?: 'ImportAuthorizersTeamErrorItem';
  line: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  type: ImportAuthorizersTeamErrorType;
  value: Scalars['String']['output'];
};

export enum ImportAuthorizersTeamErrorType {
  Employee = 'EMPLOYEE',
  Team = 'TEAM'
}

export type ImportAuthorizersTeamResult = Error | ImportAuthorizersTeamError | Success;

export type ImportAuthorizersTeamRow = {
  __typename?: 'ImportAuthorizersTeamRow';
  authorizers: Array<Scalars['String']['output']>;
  employeeRfc: Scalars['String']['output'];
  line: Scalars['Int']['output'];
  signInOrder: Scalars['Boolean']['output'];
  team: Scalars['String']['output'];
};

export type ImportAuthorizersTeamRowInput = {
  authorizers: Array<Scalars['String']['input']>;
  employeeRfc: Scalars['String']['input'];
  line: Scalars['Int']['input'];
  signInOrder: Scalars['Boolean']['input'];
  team: Scalars['String']['input'];
};

export type ImssEntity = {
  __typename?: 'ImssEntity';
  nss?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InfoRequestedByCompanyResult = {
  __typename?: 'InfoRequestedByCompanyResult';
  requestedInfoToUsers?: Maybe<Array<Maybe<GetInfoRequestedByCompany>>>;
};

export type InfoUserSupport = {
  __typename?: 'InfoUserSupport';
  endToken?: Maybe<Scalars['String']['output']>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  workSpaces?: Maybe<Array<Maybe<AllWorkSpaces>>>;
};

export type InitCompanyInput = {
  clientName: Scalars['String']['input'];
  isItAMexicanCompany: Scalars['Boolean']['input'];
  isItASubsidiaryCompany: Scalars['Boolean']['input'];
  web?: InputMaybe<Scalars['String']['input']>;
};

export type InitCompanySuccess = {
  __typename?: 'InitCompanySuccess';
  companyData?: Maybe<Company>;
  token?: Maybe<Scalars['String']['output']>;
  workSpaceRoles?: Maybe<Array<Maybe<WorkSpaceRolesType>>>;
};

export type InitCompanySupportInput = {
  adminRfc: Scalars['String']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  billingData?: InputMaybe<BillingDataInput>;
  clientName: Scalars['String']['input'];
  isItAMexicanCompany: Scalars['Boolean']['input'];
  isItASubsidiaryCompany: Scalars['Boolean']['input'];
  modulesConfiguration: SoraModulesConfiguration;
  name: Scalars['String']['input'];
  nameToInvoice?: InputMaybe<Scalars['String']['input']>;
  rfc: Scalars['String']['input'];
  web?: InputMaybe<Scalars['String']['input']>;
};

export type InitCompanySupportResult = Success | UserNotFound;

export type InvalidInput = {
  __typename?: 'InvalidInput';
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type InvalidToken = ErrorMessage & {
  __typename?: 'InvalidToken';
  message?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type InvalidWorkCenter = ErrorMessage & {
  __typename?: 'InvalidWorkCenter';
  message?: Maybe<Scalars['String']['output']>;
};

export type InvalidWorkTitle = {
  __typename?: 'InvalidWorkTitle';
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InvalidXmlFormat = ErrorMessage & {
  __typename?: 'InvalidXmlFormat';
  message?: Maybe<Scalars['String']['output']>;
};

export type ItemChartData = {
  __typename?: 'ItemChartData';
  accumulateSigned?: Maybe<Scalars['Int']['output']>;
  accumulateTotal?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  timestamps?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum LegalStatusEnum {
  Compliant = 'COMPLIANT',
  Suing = 'SUING'
}

export type LegalStatusType = {
  __typename?: 'LegalStatusType';
  createdBy?: Maybe<CreatedByType>;
  endDate?: Maybe<Scalars['Date']['output']>;
  name: LegalStatusEnum;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type LimitExceededError = ErrorMessage & {
  __typename?: 'LimitExceededError';
  message?: Maybe<Scalars['String']['output']>;
};

export type ListMetadata = {
  __typename?: 'ListMetadata';
  count: Scalars['Int']['output'];
};

export type LocationSuggestion = {
  __typename?: 'LocationSuggestion';
  location?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
};

export type LoginPermission = {
  __typename?: 'LoginPermission';
  code?: Maybe<Scalars['String']['output']>;
  create?: Maybe<Scalars['Boolean']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  adminDocs?: Maybe<Array<Maybe<Document>>>;
  highPriorityDocs?: Maybe<Array<Maybe<Document>>>;
  onboardingDocs?: Maybe<Array<Maybe<Document>>>;
  privacyPolicy?: Maybe<PrivacyPolicy>;
  token?: Maybe<Scalars['String']['output']>;
  tourCompletion?: Maybe<Array<Maybe<TourCompletitionInfo>>>;
  updateData?: Maybe<User>;
  updateLogins?: Maybe<Scalars['String']['output']>;
  workSpaceRoles?: Maybe<Array<Maybe<WorkSpaceRolesType>>>;
};

export type MasterAdminAlreadyExists = ErrorMessage & {
  __typename?: 'MasterAdminAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type MasterAdminIncorrectInfo = ErrorMessage & {
  __typename?: 'MasterAdminIncorrectInfo';
  message?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  CreateScheduledDocument?: Maybe<CreateScheduledDocumentResult>;
  ReloadCronJob?: Maybe<ReloadCronJobResult>;
  addAccessToken?: Maybe<AddAccessTokenResult>;
  addEmployeesToGroup?: Maybe<AddEmployeesToGroupResult>;
  addEmployeesToRecordChecklist?: Maybe<AddEmployeesToRecordChecklistResult>;
  addVideoAgreementToDocument?: Maybe<Document>;
  adminGenerateEmployees?: Maybe<AdminGenerateEmployeesResult>;
  adminGenerateWC?: Maybe<AdminGenerateWcResult>;
  approveDocumentFromEmployee?: Maybe<Document>;
  approveDocumentVideoAgreement?: Maybe<Document>;
  approveTemplate?: Maybe<ApproveTemplateResult>;
  blockCompanyUsersSupport?: Maybe<BlockCompanyUserSupportResult>;
  cancelActiveUserDataModificationRequest?: Maybe<UpdateUserDataChangeRequestResult>;
  cancelHolidayRequest: CreateHolidayRequestResult;
  changeEmployeeLegalStatus?: Maybe<ChangeEmployeeLegalStatusResult>;
  changeWorkCenterEmployeeSupport?: Maybe<ChangeWorkCenterEmployeeSupportResult>;
  completeActiveUserDataChangeRequest?: Maybe<UpdateUserDataChangeRequestResult>;
  completeUserInfoRequested?: Maybe<CompleteUserInfoRequestedResult>;
  confirmGeneratedReceiptImport?: Maybe<ConfirmReceiptImportResponse>;
  confirmImportedReceiptImport?: Maybe<ConfirmReceiptPdfImportResponse>;
  confirmReceiptImport?: Maybe<ConfirmReceiptImportResponse>;
  confirmReceiptPdfImport?: Maybe<ConfirmReceiptPdfImportResponse>;
  confirmXmlReceiptsToLink?: Maybe<ConfirmXmlReceiptsToLinkResult>;
  createAuthorizersTeam?: Maybe<CreateAuthorizersTeamResult>;
  createBeneficiariesDocument?: Maybe<CreateBeneficiariesDocumentFinalResult>;
  createCategory?: Maybe<CreateCategoryResult>;
  createCompanyAdminRh?: Maybe<CreateCompanyAdminRhResult>;
  createCompanyRespLetter?: Maybe<CreateCompanyRespLetterResponse>;
  createCompanyWorkCenterAdmin?: Maybe<CreateCompanyWorkCenterAdminResult>;
  createCreditPayments?: Maybe<CreateCreditPaymentsResult>;
  createDocument?: Maybe<CreateDocumentResult>;
  createDocumentTag?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createEmployeeAbsence?: Maybe<CreateEmployeeAbsenceFinalResult>;
  createGroup?: Maybe<CreateGroupResult>;
  createHoliday?: Maybe<CreateHolidayResult>;
  createHolidayRequest: CreateHolidayRequestResult;
  createHolidayScheme?: Maybe<CreateHolidaySchemeResult>;
  createMasterAdminForCompany?: Maybe<CreateMasterAdminResult>;
  createNewAccount?: Maybe<CreateNewAccountResult>;
  createOfficialHoliday?: Maybe<CreateHolidayResult>;
  createRecordChecklist?: Maybe<CreateRecordChecklistResult>;
  createSubcategory?: Maybe<CreateSubcategoryResult>;
  createTemplate?: Maybe<CreateTemplateResult>;
  createUser?: Maybe<CreateUserResult>;
  createUserForCompanyFromSupport?: Maybe<CreateUserForCompanyFromSupportResult>;
  createUserSupport?: Maybe<CreateUserResult>;
  createUsers?: Maybe<GetUsersResult>;
  createVideoAgreementTemplate?: Maybe<CreateVideoAgreementTemplateResult>;
  createWorkCenter?: Maybe<WorkCenterResult>;
  createWorkCenterAdmin?: Maybe<WorkCenterAdminResult>;
  createWorkCenterAdmins?: Maybe<WorkCenter>;
  createWorkCenters?: Maybe<CreateWorkCentersResult>;
  createWorkTitle?: Maybe<CreateWorkTitleResult>;
  deleteAuthorizersTeamEmployees?: Maybe<DeleteAuthorizersTeamEmployeesResult>;
  deleteBeneficiariesDocument?: Maybe<DeleteBeneficiariesDocumentFinalResult>;
  deleteCategory?: Maybe<DeleteCategoryResult>;
  deleteCompanyAdmins?: Maybe<DeleteCompanyAdminsResult>;
  deleteCreditPayments?: Maybe<DeleteCreditPaymentsResult>;
  deleteCredits?: Maybe<DeleteCreditsResult>;
  deleteDocument?: Maybe<DeleteDocumentResult>;
  deleteDocumentTag?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deleteDocuments?: Maybe<DeleteDocumentsResult>;
  deleteEmployeeRecords?: Maybe<DeleteEmployeeRecordsResult>;
  deleteEmployeesFromGroup?: Maybe<DeleteEmployeesFromGroupResult>;
  deleteEmployeesFromHolidayScheme?: Maybe<DeleteEmployeesFromHolidaySchemeResult>;
  deleteEmployeesFromRecordChecklist?: Maybe<DeleteEmployeesFromRecordChecklistResult>;
  deleteGroup?: Maybe<DeleteGroupResult>;
  deleteHoliday?: Maybe<DeleteHolidayResult>;
  deleteMultipleEmployeeAbsences?: Maybe<DeleteMultipleEmployeeAbsencesFinalResult>;
  deleteOfficialHoliday?: Maybe<DeleteHolidayResult>;
  deleteRecordChecklist?: Maybe<DeleteRecordChecklistResult>;
  deleteSingleEmployeeAbsence?: Maybe<DeleteSingleEmployeeAbsenceFinalResult>;
  deleteSubcategory?: Maybe<DeleteSubcategoryResult>;
  deleteTemplate?: Maybe<DeleteTemplateResult>;
  deleteUserSupport?: Maybe<DeleteUserResult>;
  deleteVideoAgreementTemplate?: Maybe<DeleteVideoAgreementTemplateResult>;
  deleteWorkCenterAdmin?: Maybe<WorkCenter>;
  deleteWorkTitle?: Maybe<DeleteWorkTitleResult>;
  dismissActiveUserDataModificationRequest?: Maybe<UpdateUserDataChangeRequestResult>;
  downloadDocumentUserSupport?: Maybe<GetDocumentResult>;
  downloadReceiptUserSupport?: Maybe<DownloadReceiptResult>;
  downloadVerifyEmployeeData?: Maybe<DownloadVerifyEmployeeDataFinalResult>;
  duplicateRecordChecklist?: Maybe<DuplicateRecordChecklistResult>;
  editExtApi?: Maybe<EditExtApiResult>;
  editUserSupport?: Maybe<EditUserResult>;
  employeesValidator?: Maybe<EmployeesValidationFinalResult>;
  exportBilling?: Maybe<ExportBillingFinalResult>;
  exportCustomersBilling?: Maybe<ExportCustomersBillingFinalResult>;
  exportDashboard?: Maybe<ExportDashboardResult>;
  exportDocuments?: Maybe<ExportDocumentsResult>;
  exportEmployeeAbsences?: Maybe<ExportEmployeeAbsencesFinalResult>;
  exportGlobalDashboard?: Maybe<ExportGlobalDashboardFinalResult>;
  exportNewDashboard?: Maybe<ExportNewDashboardFinalResult>;
  exportReceipts?: Maybe<ExportReceiptResult>;
  exportReceiptsByStatus?: Maybe<Scalars['String']['output']>;
  exportReportByCompanies?: Maybe<ExportReportByCompanyResult>;
  exportUsers?: Maybe<ExportUsersResult>;
  exportUsersBilling?: Maybe<ExportUsersBillingFinalResult>;
  finishEmployeeAbsence?: Maybe<FinishEmployeeAbsenceFinalResult>;
  finishEmployeeAbsences?: Maybe<FinishEmployeeAbsencesFinalResult>;
  generateLetterSupport?: Maybe<GenerateLetterSupportResult>;
  generateTemporalPassword?: Maybe<GenerateTemporalPasswordResult>;
  getClientsReportCommercial?: Maybe<GetClientsReportCommercialResult>;
  importAuthorizersTeam?: Maybe<ImportAuthorizersTeamResult>;
  initCompany?: Maybe<InitCompanySuccess>;
  initCompanySupport?: Maybe<InitCompanySupportResult>;
  inviteUserToVerifyCompany?: Maybe<User>;
  login?: Maybe<LoginResponse>;
  markOnboardingAsCompleted?: Maybe<OnboardingStatus>;
  moveRejectedDocumentToPendingReview?: Maybe<Document>;
  privacyPolicyAccepted?: Maybe<PrivacyPolicyAcceptedResult>;
  publishTemplate?: Maybe<PublishTemplateResult>;
  rejectActiveUserDataChangeRequest?: Maybe<UpdateUserDataChangeRequestResult>;
  rejectDocumentFromEmployee?: Maybe<Document>;
  rejectDocumentVideoAgreement?: Maybe<Document>;
  rejectHolidayRequest: RejectHolidayRequestResult;
  rejectTemplate?: Maybe<RejectTemplateResult>;
  renewAccessToken?: Maybe<ApiAccessToken>;
  renewToken?: Maybe<RenewTokenReponse>;
  requestBeneficiariesToEmployee?: Maybe<RequestBeneficiariesToEmployeeFinalResult>;
  requestDocumentToEmployee?: Maybe<Document>;
  retryImportAuthorizersTeam?: Maybe<ImportAuthorizersTeamResult>;
  sendDocumentUploadedNotificationToCompSigners?: Maybe<Success>;
  sendMassiveOnboardingNotification?: Maybe<SendMassiveOnboardingNotificationFinalResult>;
  sendOnboardingNotification?: Maybe<SendOnboardingNotificationResult>;
  sendPendingDocsNotifToEmployeesByCompanyIds?: Maybe<SendPendingDocsNotifToEmployeesByCompanyIdsResult>;
  sendPendingDocumentsNotificationToEmployees?: Maybe<SendPendingDocumentsNotificationToEmployeesResult>;
  sendPendingDocumentsNotificationToSingleEmployee?: Maybe<SendPendingDocumentsNotificationToSingleEmployeeResult>;
  sendRecoveryUserSupport?: Maybe<SendRecoveryUserSupportResult>;
  sendVerificationData?: Maybe<SendVerificationDataFinalResult>;
  setDocumentSeen?: Maybe<Document>;
  setDocumentVisibility?: Maybe<SetDocumentsVisibility>;
  setMyData?: Maybe<User>;
  setReceiptConfigs?: Maybe<ReceiptConfigs>;
  setTourCompletion?: Maybe<User>;
  setUserData?: Maybe<User>;
  sifeChangeOtp?: Maybe<ChangeOtpResult>;
  sifeChangePassword?: Maybe<ChangePasswordResult>;
  sifeConfirmDocumentSign?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sifeResendActivation?: Maybe<SifeResendActivationResult>;
  sifeResendVerificationLink?: Maybe<SifeResendVerificationLinkResult>;
  sifeSendDocuments?: Maybe<SifeSendDocumentResult>;
  sifeSendRecovery?: Maybe<SifeSendRecoveryResult>;
  sifeSendVerificationCode?: Maybe<SifeSendVerificationCodeResult>;
  sifeVerifyContactMethod?: Maybe<SifeVerifyContactMethodResult>;
  signedFileXmlValidator?: Maybe<SignedFileXmlValidatorResult>;
  skipProfilePicture?: Maybe<Scalars['String']['output']>;
  updateActiveUserData?: Maybe<UpdateActiveUserDataResult>;
  updateAuthorizersTeam?: Maybe<UpdateAuthorizersTeamResult>;
  updateCategory?: Maybe<UpdateCategoryResult>;
  updateCompany?: Maybe<Company>;
  updateCompanyActiveModules?: Maybe<UpdateCompanyActiveModulesResponse>;
  updateCompanyConfig?: Maybe<UpdateCompanyConfigResult>;
  updateCompanyNotificationsConfig?: Maybe<UpdateCompanyNotificationsConfigResponse>;
  updateCompanyRoles?: Maybe<Success>;
  updateCompanySignerNotificationsConfig?: Maybe<UpdateCompanySignerNotificationsConfigResult>;
  updateCreditStatus?: Maybe<UpdateCreditStatusResult>;
  updateEmployeeAbsence?: Maybe<UpdateEmployeeAbsenceFinalResult>;
  updateEmployeeContactMethods?: Maybe<UpdateEmployeeContactMethodsResult>;
  updateEmployeeData?: Maybe<UpdateEmployeeDataResult>;
  updateEmployeeDocumentScheduledFor?: Maybe<UpdateEmployeeDocumentScheduledForResult>;
  updateEmployeeInfoRequired?: Maybe<UpdateEmployeeInfoRequiredFinalResult>;
  updateEmployeeNominaData?: Maybe<UpdateEmployeeNominaDataResult>;
  updateEmployeeRecordType?: Maybe<UpdateEmployeeRecordTypeResult>;
  updateEmployeeWorkTitles?: Maybe<UpdateEmployeeWorkTitlesResult>;
  updateGroup?: Maybe<UpdateGroupResult>;
  updateHoliday?: Maybe<UpdateHolidayResult>;
  updateHolidayScheme?: Maybe<UpdateHolidaySchemeResult>;
  updateInfoRequestedByCompany?: Maybe<UpdateInfoRequestedByCompanyFinalResult>;
  updateMultiEmployeeGroups?: Maybe<UpdateMultiEmployeeGroupsResult>;
  updateMyCompanyConfig?: Maybe<UpdateCompanyConfigResult>;
  updateOfficialHoliday?: Maybe<UpdateHolidayResult>;
  updateRecordChecklist?: Maybe<UpdateRecordChecklistResult>;
  updateSubcategory?: Maybe<UpdateSubcategoryResult>;
  updateTemplate?: Maybe<UpdateTemplateResult>;
  updateUserIdentityValidationStatus?: Maybe<UpdateUserIdentityValidationStatusResult>;
  updateUserPermissions?: Maybe<UpdateUserPermissionsResult>;
  updateVideoAgreementTemplate?: Maybe<UpdateVideoAgreementTemplateResult>;
  updateWCAdminWorkCenters?: Maybe<UpdateWcAdminWorkCentersResult>;
  updateWorkCenterData?: Maybe<WorkCenterResult>;
  updateWorkTitle?: Maybe<UpdateWorkTitleResult>;
  uploadDocument?: Maybe<Array<Maybe<Document>>>;
  uploadDocuments?: Maybe<CreateDocumentResult>;
  uploadEmployeeRecordDocs?: Maybe<UploadEmployeeRecordsResult>;
  uploadGeneratedReceipts?: Maybe<UploadReceiptValidation>;
  uploadImportedReceipts?: Maybe<UploadReceiptPdfResponse>;
  uploadPdfOnlyForLinkingXml?: Maybe<UploadPdfOnlyForLinkingXmlResult>;
  uploadPendingDocument?: Maybe<Document>;
  uploadProfilePicture?: Maybe<Scalars['String']['output']>;
  uploadReceiptPdf?: Maybe<UploadReceiptPdfResponse>;
  uploadReceipts?: Maybe<UploadReceiptValidation>;
  uploadSalary?: Maybe<SalaryUpdate>;
  uploadUsers?: Maybe<Array<Maybe<NewUserValidation>>>;
  uploadWorkCenterAdmins?: Maybe<Array<Maybe<NewWorkCenterAdminValidation>>>;
  uploadWorkCenters?: Maybe<UploadWorkCenterResult>;
  validateCreditPayments?: Maybe<ValidateCreditPaymentsResult>;
  validateUserInfo?: Maybe<ValidateUserInfoResult>;
  validateXmlReceiptsToLink?: Maybe<ValidateXmlReceiptsToLinkResult>;
  verifyCertificate?: Maybe<Scalars['String']['output']>;
  verifyEmployeeData?: Maybe<VerifyEmployeeDataFinalResult>;
  verifyPendingDocumentWithAi?: Maybe<VerifyPendingDocumentWithAiFinalResult>;
};


export type MutationCreateScheduledDocumentArgs = {
  input: CreateScheduledDocumentInput;
};


export type MutationReloadCronJobArgs = {
  cronJobId: Scalars['String']['input'];
};


export type MutationAddAccessTokenArgs = {
  input?: InputMaybe<AddAccessTokenInput>;
};


export type MutationAddEmployeesToGroupArgs = {
  input?: InputMaybe<AddEmployeesToGroupInput>;
};


export type MutationAddEmployeesToRecordChecklistArgs = {
  input?: InputMaybe<AddEmployeesToRecordChecklistInput>;
};


export type MutationAddVideoAgreementToDocumentArgs = {
  input?: InputMaybe<AddVideoAgreementToDocumentInput>;
  video: Scalars['Upload']['input'];
};


export type MutationAdminGenerateEmployeesArgs = {
  input: AdminGenerateEmployeesInput;
};


export type MutationAdminGenerateWcArgs = {
  input: AdminGenerateWcInput;
};


export type MutationApproveDocumentFromEmployeeArgs = {
  input: ApproveDocumentFromEmployeeInput;
};


export type MutationApproveDocumentVideoAgreementArgs = {
  input: ApproveDocumentVideoAgreementInput;
};


export type MutationApproveTemplateArgs = {
  input?: InputMaybe<ApproveTemplateInput>;
};


export type MutationBlockCompanyUsersSupportArgs = {
  companyId: Scalars['String']['input'];
  isBlockAction: Scalars['Boolean']['input'];
};


export type MutationCancelActiveUserDataModificationRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationCancelHolidayRequestArgs = {
  input: CancelHolidayRequestInput;
};


export type MutationChangeEmployeeLegalStatusArgs = {
  input: ChangeEmployeeLegalStatusInput;
};


export type MutationChangeWorkCenterEmployeeSupportArgs = {
  input?: InputMaybe<ChangeWorkCenterEmployeeSupportInput>;
};


export type MutationCompleteActiveUserDataChangeRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationCompleteUserInfoRequestedArgs = {
  input?: InputMaybe<CompleteUserInfoRequestedInput>;
};


export type MutationConfirmGeneratedReceiptImportArgs = {
  requestKey: Scalars['String']['input'];
  stampList: Array<InputMaybe<Scalars['String']['input']>>;
  xmlOnly: Scalars['Boolean']['input'];
};


export type MutationConfirmImportedReceiptImportArgs = {
  requestKey: Scalars['String']['input'];
  stampList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationConfirmReceiptImportArgs = {
  requestKey: Scalars['String']['input'];
  stampList: Array<InputMaybe<Scalars['String']['input']>>;
  xmlOnly: Scalars['Boolean']['input'];
};


export type MutationConfirmReceiptPdfImportArgs = {
  requestKey: Scalars['String']['input'];
  stampList: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationConfirmXmlReceiptsToLinkArgs = {
  input: ConfirmXmlReceiptsToLinkInput;
};


export type MutationCreateAuthorizersTeamArgs = {
  input: CreateAuthorizersTeamInput;
};


export type MutationCreateBeneficiariesDocumentArgs = {
  input?: InputMaybe<CreateBeneficiariesDocumentInput>;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateCompanyAdminRhArgs = {
  input: CompanyAdminRhAdminInput;
};


export type MutationCreateCompanyRespLetterArgs = {
  input: CreateCompanyRespLetterInput;
};


export type MutationCreateCompanyWorkCenterAdminArgs = {
  input: CompanyWorkCenterAdminInput;
};


export type MutationCreateCreditPaymentsArgs = {
  input: Array<InputMaybe<CreateCreditPaymentInput>>;
};


export type MutationCreateDocumentArgs = {
  firstImage?: InputMaybe<Scalars['Upload']['input']>;
  input?: InputMaybe<CreateDocumentInput>;
  secondImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateDocumentTagArgs = {
  tag: Scalars['String']['input'];
};


export type MutationCreateEmployeeAbsenceArgs = {
  input?: InputMaybe<CreateEmployeeAbsenceInput>;
};


export type MutationCreateGroupArgs = {
  input?: InputMaybe<CreateGroupInput>;
};


export type MutationCreateHolidayArgs = {
  input: CreateHolidayInput;
};


export type MutationCreateHolidayRequestArgs = {
  input: CreateHolidayRequestInput;
};


export type MutationCreateHolidaySchemeArgs = {
  input: CreateHolidaySchemeInput;
};


export type MutationCreateMasterAdminForCompanyArgs = {
  input?: InputMaybe<CreateMasterAdminInput>;
};


export type MutationCreateNewAccountArgs = {
  input?: InputMaybe<CreateNewAccountInput>;
};


export type MutationCreateOfficialHolidayArgs = {
  input: CreateHolidayInput;
};


export type MutationCreateRecordChecklistArgs = {
  input?: InputMaybe<CreateRecordChecklistInput>;
};


export type MutationCreateSubcategoryArgs = {
  input: CreateSubcategoryInput;
};


export type MutationCreateTemplateArgs = {
  input?: InputMaybe<CreateTemplateInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationCreateUserForCompanyFromSupportArgs = {
  input: CreateUserForCompanyFromSupportInput;
};


export type MutationCreateUserSupportArgs = {
  input?: InputMaybe<CreateUserSupportInput>;
};


export type MutationCreateUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateUserInput>>>;
};


export type MutationCreateVideoAgreementTemplateArgs = {
  input: CreateVideoAgreementTemplateInput;
};


export type MutationCreateWorkCenterArgs = {
  input?: InputMaybe<WorkCenterInput>;
};


export type MutationCreateWorkCenterAdminArgs = {
  input?: InputMaybe<CreateWorkCenterAdminInput>;
};


export type MutationCreateWorkCenterAdminsArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateWorkCenterAdminInput>>>;
};


export type MutationCreateWorkCentersArgs = {
  input?: InputMaybe<CreateWorkCentersInput>;
};


export type MutationCreateWorkTitleArgs = {
  input?: InputMaybe<CreateWorkTitleInput>;
};


export type MutationDeleteAuthorizersTeamEmployeesArgs = {
  input: DeleteAuthorizersTeamEmployeesInput;
};


export type MutationDeleteBeneficiariesDocumentArgs = {
  input?: InputMaybe<DeleteBeneficiariesDocumentInput>;
};


export type MutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


export type MutationDeleteCompanyAdminsArgs = {
  input: DeleteCompanyAdminsInput;
};


export type MutationDeleteCreditPaymentsArgs = {
  input?: InputMaybe<Array<DeleteCreditPaymentsInput>>;
};


export type MutationDeleteCreditsArgs = {
  input?: InputMaybe<Array<DeleteCreditsInput>>;
};


export type MutationDeleteDocumentArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteDocumentTagArgs = {
  tag: Scalars['String']['input'];
};


export type MutationDeleteDocumentsArgs = {
  input: DeleteDocumentsInput;
};


export type MutationDeleteEmployeeRecordsArgs = {
  input: DeleteEmployeeRecordsInput;
};


export type MutationDeleteEmployeesFromGroupArgs = {
  input?: InputMaybe<DeleteEmployeesFromGroupInput>;
};


export type MutationDeleteEmployeesFromHolidaySchemeArgs = {
  input: DeleteEmployeesFromHolidaySchemeInput;
};


export type MutationDeleteEmployeesFromRecordChecklistArgs = {
  input?: InputMaybe<DeleteEmployeesFromRecordChecklistInput>;
};


export type MutationDeleteGroupArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteHolidayArgs = {
  input: DeleteHolidayInput;
};


export type MutationDeleteMultipleEmployeeAbsencesArgs = {
  input?: InputMaybe<DeleteMultipleEmployeeAbsencesInput>;
};


export type MutationDeleteOfficialHolidayArgs = {
  input: DeleteHolidayInput;
};


export type MutationDeleteRecordChecklistArgs = {
  recordChecklistId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteSingleEmployeeAbsenceArgs = {
  input?: InputMaybe<DeleteSingleEmployeeAbsenceInput>;
};


export type MutationDeleteSubcategoryArgs = {
  input: DeleteSubcategoryInput;
};


export type MutationDeleteTemplateArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserSupportArgs = {
  input?: InputMaybe<ParamsToDeleteUserInput>;
};


export type MutationDeleteVideoAgreementTemplateArgs = {
  input: DeleteVideoAgreementTemplateInput;
};


export type MutationDeleteWorkCenterAdminArgs = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteWorkTitleArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDismissActiveUserDataModificationRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationDownloadDocumentUserSupportArgs = {
  input?: InputMaybe<DownloadUserDocumentSupportInput>;
};


export type MutationDownloadReceiptUserSupportArgs = {
  input?: InputMaybe<DownloadUserReceiptSupportInput>;
};


export type MutationDownloadVerifyEmployeeDataArgs = {
  input?: InputMaybe<DownloadVerifyEmployeeDataInput>;
};


export type MutationDuplicateRecordChecklistArgs = {
  recordChecklistId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditExtApiArgs = {
  input: EditExtApiInput;
};


export type MutationEditUserSupportArgs = {
  input?: InputMaybe<ParamsSupportInput>;
};


export type MutationEmployeesValidatorArgs = {
  input?: InputMaybe<EmployeesValidationInput>;
};


export type MutationExportBillingArgs = {
  filter?: InputMaybe<ExportBillingFilter>;
};


export type MutationExportCustomersBillingArgs = {
  input?: InputMaybe<ExportCustomersBillingInput>;
};


export type MutationExportDashboardArgs = {
  input?: InputMaybe<ExportDashboardInput>;
};


export type MutationExportDocumentsArgs = {
  input?: InputMaybe<ExportDocumentsInput>;
};


export type MutationExportEmployeeAbsencesArgs = {
  input?: InputMaybe<ExportEmployeeAbsencesFilterInput>;
};


export type MutationExportGlobalDashboardArgs = {
  filter?: InputMaybe<ExportGlobalDashboardFilterInput>;
};


export type MutationExportNewDashboardArgs = {
  filter?: InputMaybe<DocumentsByCompanyIdsFilterInput>;
};


export type MutationExportReceiptsArgs = {
  input?: InputMaybe<ExportReceiptsInput>;
};


export type MutationExportReceiptsByStatusArgs = {
  input: ExportReceiptsByStatusInput;
};


export type MutationExportReportByCompaniesArgs = {
  input?: InputMaybe<ExportReportByCompanyInput>;
};


export type MutationExportUsersArgs = {
  input?: InputMaybe<ExportUsersInput>;
};


export type MutationExportUsersBillingArgs = {
  filter?: InputMaybe<ExportUsersBillingFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFinishEmployeeAbsenceArgs = {
  input?: InputMaybe<FinishEmployeeAbsenceInput>;
};


export type MutationFinishEmployeeAbsencesArgs = {
  input?: InputMaybe<FinishEmployeeAbsencesInput>;
};


export type MutationGenerateLetterSupportArgs = {
  input?: InputMaybe<GenerateLetterSupportInput>;
};


export type MutationGenerateTemporalPasswordArgs = {
  input: GenerateTemporalPasswordInput;
};


export type MutationGetClientsReportCommercialArgs = {
  input?: InputMaybe<GetClientsReportCommercialInput>;
};


export type MutationImportAuthorizersTeamArgs = {
  input: ImportAuthorizersTeamInput;
};


export type MutationInitCompanyArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationInitCompanySupportArgs = {
  input: InitCompanySupportInput;
};


export type MutationInviteUserToVerifyCompanyArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationLoginArgs = {
  input?: InputMaybe<SifeDataInput>;
};


export type MutationMoveRejectedDocumentToPendingReviewArgs = {
  _id: Scalars['String']['input'];
};


export type MutationPrivacyPolicyAcceptedArgs = {
  input?: InputMaybe<PrivacyPolicyAcceptedInput>;
};


export type MutationPublishTemplateArgs = {
  input?: InputMaybe<PublishTemplateInput>;
};


export type MutationRejectActiveUserDataChangeRequestArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
};


export type MutationRejectDocumentFromEmployeeArgs = {
  input: RejectDocumentFromEmployeeInput;
};


export type MutationRejectDocumentVideoAgreementArgs = {
  input: RejectDocumentVideoAgreementInput;
};


export type MutationRejectHolidayRequestArgs = {
  input: RejectHolidayRequestInput;
};


export type MutationRejectTemplateArgs = {
  input?: InputMaybe<RejectTemplateInput>;
};


export type MutationRenewAccessTokenArgs = {
  input: RenewAccessTokenInput;
};


export type MutationRequestBeneficiariesToEmployeeArgs = {
  input?: InputMaybe<RequestBeneficiariesToEmployeeInput>;
};


export type MutationRequestDocumentToEmployeeArgs = {
  _id: Scalars['String']['input'];
};


export type MutationRetryImportAuthorizersTeamArgs = {
  input: RetryImportAuthorizersTeamInput;
};


export type MutationSendDocumentUploadedNotificationToCompSignersArgs = {
  compSignersToMarkAsSeen: Array<InputMaybe<CompSignerToSendNotification>>;
  compSignersToSign: Array<InputMaybe<CompSignerToSendNotification>>;
};


export type MutationSendMassiveOnboardingNotificationArgs = {
  input?: InputMaybe<SendMassiveOnboardingNotificationInput>;
};


export type MutationSendOnboardingNotificationArgs = {
  input: SendOnboardingNotificationInput;
};


export type MutationSendPendingDocsNotifToEmployeesByCompanyIdsArgs = {
  input?: InputMaybe<SendPendingDocsNotifToEmployeesByCompanyIdsInput>;
};


export type MutationSendPendingDocumentsNotificationToSingleEmployeeArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSendRecoveryUserSupportArgs = {
  input?: InputMaybe<SendRecoveryUserSupportInput>;
};


export type MutationSendVerificationDataArgs = {
  input?: InputMaybe<SendVerificationDataInput>;
};


export type MutationSetDocumentSeenArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetDocumentVisibilityArgs = {
  documentIds: Array<InputMaybe<Scalars['String']['input']>>;
  hide: Scalars['Boolean']['input'];
};


export type MutationSetMyDataArgs = {
  input?: InputMaybe<MyDataInput>;
};


export type MutationSetReceiptConfigsArgs = {
  input: ReceiptConfigInput;
};


export type MutationSetTourCompletionArgs = {
  completionType: SetTourCompletionInput;
};


export type MutationSetUserDataArgs = {
  input?: InputMaybe<UserDataInput>;
};


export type MutationSifeChangeOtpArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationSifeChangePasswordArgs = {
  input?: InputMaybe<SifeChangePasswordInput>;
};


export type MutationSifeConfirmDocumentSignArgs = {
  input?: InputMaybe<Array<InputMaybe<SifeConfirmSignInput>>>;
};


export type MutationSifeResendActivationArgs = {
  rfc: Scalars['String']['input'];
};


export type MutationSifeResendVerificationLinkArgs = {
  input: SifeResendVerificationLinkInput;
};


export type MutationSifeSendDocumentsArgs = {
  input?: InputMaybe<Array<InputMaybe<SifeSendDocumentInput>>>;
};


export type MutationSifeSendRecoveryArgs = {
  input?: InputMaybe<SifeSendRecoveryInput>;
};


export type MutationSifeSendVerificationCodeArgs = {
  input?: InputMaybe<SifeSendVerificationCodeInput>;
};


export type MutationSifeVerifyContactMethodArgs = {
  input?: InputMaybe<SifeVerifyContactMethodInput>;
};


export type MutationSignedFileXmlValidatorArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpdateActiveUserDataArgs = {
  input: UpdateActiveUserDataInput;
};


export type MutationUpdateAuthorizersTeamArgs = {
  input: UpdateAuthorizersTeamInput;
};


export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyActiveModulesArgs = {
  input: UpdateCompanyActiveModulesInput;
};


export type MutationUpdateCompanyConfigArgs = {
  input: CompanyConfigOption;
};


export type MutationUpdateCompanyNotificationsConfigArgs = {
  input: UpdateCompanyNotificationsConfigInput;
};


export type MutationUpdateCompanyRolesArgs = {
  input: CompanyRolesInput;
};


export type MutationUpdateCompanySignerNotificationsConfigArgs = {
  input?: InputMaybe<UpdateCompanySignerNotificationsConfigInput>;
};


export type MutationUpdateCreditStatusArgs = {
  input?: InputMaybe<UpdateCreditStatusInput>;
};


export type MutationUpdateEmployeeAbsenceArgs = {
  input?: InputMaybe<UpdateEmployeeAbsenceInput>;
};


export type MutationUpdateEmployeeContactMethodsArgs = {
  input: EmployeeContactMethods;
};


export type MutationUpdateEmployeeDataArgs = {
  employeeData: EmployeeData;
};


export type MutationUpdateEmployeeDocumentScheduledForArgs = {
  employeeDocumentId: Scalars['String']['input'];
  scheduledFor?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateEmployeeInfoRequiredArgs = {
  input?: InputMaybe<UpdateEmployeeInfoRequiredInput>;
};


export type MutationUpdateEmployeeNominaDataArgs = {
  input: EmployeeNominaData;
};


export type MutationUpdateEmployeeRecordTypeArgs = {
  input: UpdateEmployeeRecordData;
};


export type MutationUpdateEmployeeWorkTitlesArgs = {
  input?: InputMaybe<UpdateEmployeeWorkTitlesInput>;
};


export type MutationUpdateGroupArgs = {
  input?: InputMaybe<UpdateGroupInput>;
};


export type MutationUpdateHolidayArgs = {
  input: UpdateHolidayInput;
};


export type MutationUpdateHolidaySchemeArgs = {
  input: UpdateHolidaySchemeInput;
};


export type MutationUpdateInfoRequestedByCompanyArgs = {
  input?: InputMaybe<UpdateInfoRequestedByCompanyFilterInput>;
};


export type MutationUpdateMultiEmployeeGroupsArgs = {
  file: Scalars['Upload']['input'];
  input?: InputMaybe<UpdateMultiEmployeeGroupsInput>;
};


export type MutationUpdateMyCompanyConfigArgs = {
  input: CompanyConfigOption;
};


export type MutationUpdateOfficialHolidayArgs = {
  input: UpdateHolidayInput;
};


export type MutationUpdateRecordChecklistArgs = {
  input?: InputMaybe<UpdateRecordChecklistInput>;
};


export type MutationUpdateSubcategoryArgs = {
  input: UpdateSubcategoryInput;
};


export type MutationUpdateTemplateArgs = {
  input?: InputMaybe<UpdateTemplateInput>;
};


export type MutationUpdateUserIdentityValidationStatusArgs = {
  input: UpdateUserIdentityValidationStatusInput;
};


export type MutationUpdateUserPermissionsArgs = {
  input: UpdateUserPermissionsInput;
};


export type MutationUpdateVideoAgreementTemplateArgs = {
  input: UpdateVideoAgreementTemplateInput;
};


export type MutationUpdateWcAdminWorkCentersArgs = {
  input: UpdateWcAdminWorkCentersInput;
};


export type MutationUpdateWorkCenterDataArgs = {
  input?: InputMaybe<UpdateWorkCenterDataInput>;
};


export type MutationUpdateWorkTitleArgs = {
  input?: InputMaybe<UpdateWorkTitleInput>;
};


export type MutationUploadDocumentArgs = {
  file: Scalars['Upload']['input'];
  input?: InputMaybe<DocumentUploadData>;
};


export type MutationUploadDocumentsArgs = {
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  input?: InputMaybe<DocumentBulkUploadData>;
};


export type MutationUploadEmployeeRecordDocsArgs = {
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  input?: InputMaybe<Array<InputMaybe<UploadEmployeeRecordDocType>>>;
};


export type MutationUploadGeneratedReceiptsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadImportedReceiptsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadPdfOnlyForLinkingXmlArgs = {
  input: UploadPdfOnlyForLinkingXmlInput;
};


export type MutationUploadPendingDocumentArgs = {
  file: Scalars['Upload']['input'];
  input: UploadPendingDocumentInput;
};


export type MutationUploadProfilePictureArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadReceiptPdfArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadReceiptsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadSalaryArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadUsersArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadWorkCenterAdminsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadWorkCentersArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationValidateCreditPaymentsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationValidateUserInfoArgs = {
  input?: InputMaybe<ValidateUserInfoInput>;
};


export type MutationValidateXmlReceiptsToLinkArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationVerifyCertificateArgs = {
  certificate: Scalars['String']['input'];
};


export type MutationVerifyEmployeeDataArgs = {
  input?: InputMaybe<VerifyEmployeeDataInput>;
};


export type MutationVerifyPendingDocumentWithAiArgs = {
  file: Scalars['Upload']['input'];
  input: VerifyPendingDocumentWithAiInput;
};

export type MyCredits = {
  __typename?: 'MyCredits';
  credits?: Maybe<Array<Maybe<Credit>>>;
};

export type MyCreditsResult = MyCredits;

export type MyDataInput = {
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type MyDocsAndReceiptFilter = {
  canBeSigned?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type MyDocsAndReceipts = {
  __typename?: 'MyDocsAndReceipts';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  constantType?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['String']['output']>;
  employeeSignature?: Maybe<EmployeeSignature>;
  fiscalDetails?: Maybe<FiscalDetails>;
  history?: Maybe<Array<Maybe<DocumentHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  linkUuid?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  queueStatus?: Maybe<Scalars['String']['output']>;
  receiptDetail?: Maybe<ReceiptDetails>;
  seen?: Maybe<Scalars['Date']['output']>;
  signDate?: Maybe<Scalars['Date']['output']>;
  signatureType?: Maybe<Scalars['String']['output']>;
  signatures?: Maybe<Array<Maybe<Signatures>>>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  signers?: Maybe<Array<Maybe<Signers>>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MyDocsAndReceiptsResult = {
  __typename?: 'MyDocsAndReceiptsResult';
  count?: Maybe<Scalars['Int']['output']>;
  docsAndReceipts?: Maybe<Array<Maybe<MyDocsAndReceipts>>>;
};

export type MyDocument = {
  __typename?: 'MyDocument';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<Maybe<DocumentHistory>>>;
  historyStatus?: Maybe<DocumentHistoryStatusEnum>;
  isUploadedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  queueStatus?: Maybe<Scalars['String']['output']>;
  seen?: Maybe<Scalars['Date']['output']>;
  signDate?: Maybe<Scalars['Date']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  videoAgreement?: Maybe<VideoAgreement>;
  videoAgreementRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type MyDocumentsFilter = {
  excludeAdminDocs?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MyDocumentsResult = {
  __typename?: 'MyDocumentsResult';
  count?: Maybe<Scalars['Int']['output']>;
  documents?: Maybe<Array<Maybe<MyDocument>>>;
  requestedDocuments?: Maybe<Array<Maybe<RequestedEmployeeDocument>>>;
};

export type MyPendingDocument = {
  __typename?: 'MyPendingDocument';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<DocumentAndReceiptItemType>;
  queueStatus?: Maybe<Scalars['String']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<DocumentAndReceiptTimestamps>;
  title?: Maybe<Scalars['String']['output']>;
  videoAgreement?: Maybe<VideoAgreement>;
  videoAgreementRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type MyPendingDocumentOrReceipt = MyPendingDocument | MyPendingReceipt;

export type MyPendingReceipt = {
  __typename?: 'MyPendingReceipt';
  _id?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<DocumentAndReceiptItemType>;
  queueStatus?: Maybe<Scalars['String']['output']>;
  receiptDetail?: Maybe<MyPendingReceiptDetail>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  timestamps?: Maybe<DocumentAndReceiptTimestamps>;
};

export type MyPendingReceiptDetail = {
  __typename?: 'MyPendingReceiptDetail';
  paymentEndDate?: Maybe<Scalars['Date']['output']>;
  paymentStartDate?: Maybe<Scalars['Date']['output']>;
};

export type MyReceiptsFilter = {
  canBeSigned?: InputMaybe<Scalars['Boolean']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MyReceiptsResult = {
  __typename?: 'MyReceiptsResult';
  count?: Maybe<Scalars['Int']['output']>;
  receipts?: Maybe<Array<Maybe<Receipt>>>;
};

export type MyReceiptsSort = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortOrderEnum>;
};

export type NeedsContactMethods = {
  __typename?: 'NeedsContactMethods';
  message?: Maybe<Scalars['String']['output']>;
};

export type NewPasswordMustBeDifferent = ErrorMessage & {
  __typename?: 'NewPasswordMustBeDifferent';
  message?: Maybe<Scalars['String']['output']>;
};

export type NewSubcategoryRequiredForDocuments = {
  __typename?: 'NewSubcategoryRequiredForDocuments';
  totalDocuments?: Maybe<Scalars['Int']['output']>;
};

export type NewSubcategoryRequiredForRecordChecklist = {
  __typename?: 'NewSubcategoryRequiredForRecordChecklist';
  recordChecklistNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NewUserImportValidationResult = {
  __typename?: 'NewUserImportValidationResult';
  passed?: Maybe<Scalars['Boolean']['output']>;
  validationErrors?: Maybe<NewUserValidationResultInputError>;
};

export type NewUserValidation = {
  __typename?: 'NewUserValidation';
  alta?: Maybe<StringValidationResult>;
  birthdate?: Maybe<StringValidationResult>;
  city?: Maybe<StringValidationResult>;
  colony?: Maybe<StringValidationResult>;
  contractType?: Maybe<StringValidationResult>;
  country?: Maybe<StringValidationResult>;
  curp?: Maybe<StringValidationResult>;
  email?: Maybe<StringValidationResult>;
  employmentStartDate?: Maybe<StringValidationResult>;
  externalNumber?: Maybe<StringValidationResult>;
  gender?: Maybe<StringValidationResult>;
  groups?: Maybe<StringArrayValidationResult>;
  internalNumber?: Maybe<StringValidationResult>;
  lastNameM?: Maybe<StringValidationResult>;
  lastNameP?: Maybe<StringValidationResult>;
  maritalStatus?: Maybe<StringValidationResult>;
  names?: Maybe<StringValidationResult>;
  payrollId?: Maybe<StringValidationResult>;
  phone?: Maybe<StringValidationResult>;
  recordChecklistName?: Maybe<StringValidationResult>;
  rfc?: Maybe<StringValidationResult>;
  salary?: Maybe<StringValidationResult>;
  socialSecurityNumber?: Maybe<StringValidationResult>;
  state?: Maybe<StringValidationResult>;
  street?: Maybe<StringValidationResult>;
  workCenterId?: Maybe<StringValidationResult>;
  workCenterName?: Maybe<StringValidationResult>;
  workDayType?: Maybe<StringValidationResult>;
  workTitle?: Maybe<StringValidationResult>;
  zipCode?: Maybe<StringValidationResult>;
};

export type NewUserValidationResultInputError = {
  __typename?: 'NewUserValidationResultInputError';
  curp?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastNameM?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastNameP?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  payrollId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phone?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rfc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  wcCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NewWorkCenterAdminValidation = {
  __typename?: 'NewWorkCenterAdminValidation';
  adminId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workCenterId?: Maybe<Scalars['String']['output']>;
};

export type NewWorkCenterValidation = {
  __typename?: 'NewWorkCenterValidation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalNumber?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  validationResult?: Maybe<NewWorkCenterValidationResult>;
};

export type NewWorkCenterValidationResult = {
  __typename?: 'NewWorkCenterValidationResult';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  internalNumber?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

export type NoCreditPaymentsCreated = {
  __typename?: 'NoCreditPaymentsCreated';
  message?: Maybe<Scalars['String']['output']>;
};

export type NoCreditPaymentsDeleted = {
  __typename?: 'NoCreditPaymentsDeleted';
  message?: Maybe<Scalars['String']['output']>;
};

export type NoCreditStatusUpdated = {
  __typename?: 'NoCreditStatusUpdated';
  message?: Maybe<Scalars['String']['output']>;
};

export type NoCreditsDeleted = {
  __typename?: 'NoCreditsDeleted';
  message?: Maybe<Scalars['String']['output']>;
};

export type NotEmployeeError = {
  __typename?: 'NotEmployeeError';
  message?: Maybe<Scalars['String']['output']>;
};

export type NotificationTimeout = {
  __typename?: 'NotificationTimeout';
  esMessage?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type OtpNotValid = ErrorMessage & {
  __typename?: 'OTPNotValid';
  message?: Maybe<Scalars['String']['output']>;
};

export type OldestUnsignedReceipt = {
  __typename?: 'OldestUnsignedReceipt';
  data?: Maybe<Receipt>;
  unsignedReceiptsCount?: Maybe<Scalars['Int']['output']>;
};

export type OnBoardingDocsSupport = {
  __typename?: 'OnBoardingDocsSupport';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  constantType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['Date']['output']>;
  signedAt?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OnboardingDocsUser = {
  __typename?: 'OnboardingDocsUser';
  _id?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
};

export type OnboardingDocument = {
  __typename?: 'OnboardingDocument';
  constantType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OnboardingStatus = {
  __typename?: 'OnboardingStatus';
  completedAt?: Maybe<Scalars['Date']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
};

export type OtherVerifiedData = {
  __typename?: 'OtherVerifiedData';
  age?: Maybe<Scalars['Int']['output']>;
  jobSeniority?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['String']['output']>;
};

export type OtpNotFound = ErrorMessage & {
  __typename?: 'OtpNotFound';
  message?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  currentPage?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalItemsWithFilter?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Paging = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type ParamsSupportInput = {
  payload?: InputMaybe<PayloadEditUserSupport>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ParamsToDeleteUserInput = {
  confirmDelete?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordChanged = {
  __typename?: 'PasswordChanged';
  message?: Maybe<Scalars['String']['output']>;
};

export type PayloadEditUserSupport = {
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type PdfReceiptValidationData = {
  __typename?: 'PdfReceiptValidationData';
  employeeExists?: Maybe<Scalars['Boolean']['output']>;
  employeeRfc?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  pdfFound?: Maybe<Scalars['Boolean']['output']>;
};

export type PendingDocs = {
  __typename?: 'PendingDocs';
  adminDocs?: Maybe<Array<Maybe<Document>>>;
  highPriorityDocs?: Maybe<Array<Maybe<Document>>>;
  onboardingDocs?: Maybe<Array<Maybe<Document>>>;
};

export type PendingDocumentByRecordChecklist = {
  __typename?: 'PendingDocumentByRecordChecklist';
  _id: Scalars['String']['output'];
  canBeSeen: Scalars['Boolean']['output'];
  canBeSigned: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  lastNameM: Scalars['String']['output'];
  lastNameP: Scalars['String']['output'];
  names: Scalars['String']['output'];
  profilePicture: Scalars['String']['output'];
  rfc: Scalars['String']['output'];
  seen: Scalars['Boolean']['output'];
  signed: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type PendingOnboardingDocument = {
  __typename?: 'PendingOnboardingDocument';
  _id?: Maybe<Scalars['String']['output']>;
  constantType?: Maybe<Scalars['String']['output']>;
  preSignedUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PendingTask = {
  __typename?: 'PendingTask';
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  receiptData?: Maybe<ReceiptData>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Perception = {
  __typename?: 'Perception';
  concept?: Maybe<Scalars['String']['output']>;
  extraHours?: Maybe<Scalars['Int']['output']>;
  extraHoursCode?: Maybe<Scalars['String']['output']>;
  import?: Maybe<Scalars['Float']['output']>;
  perceptionType?: Maybe<Scalars['String']['output']>;
};

export type Period = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PeriodType = {
  __typename?: 'PeriodType';
  end?: Maybe<Scalars['Date']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
};

export enum PeriodicityEnum {
  TwoWeeks = 'TWO_WEEKS',
  Weekly = 'WEEKLY'
}

export enum PermissionAction {
  Create = 'create',
  Delete = 'delete',
  Read = 'read',
  Update = 'update'
}

export type PermissionInput = {
  hasAccess?: InputMaybe<Scalars['Boolean']['input']>;
  method: MethodEnum;
  route: Scalars['String']['input'];
};

export type Permit = {
  __typename?: 'Permit';
  comment?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate: Scalars['Date']['output'];
  type: Scalars['String']['output'];
};

export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type PreviousReference = {
  __typename?: 'PreviousReference';
  id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PrivacyPolicyAcceptedInput = {
  privacyPolicyAccepted: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type PrivacyPolicyAcceptedResult = FinalResponsePrivacyPolicyAccepted | PrivacyPolicyError;

export type PrivacyPolicyByUser = {
  __typename?: 'PrivacyPolicyByUser';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PrivacyPolicyError = ErrorMessage & {
  __typename?: 'PrivacyPolicyError';
  message?: Maybe<Scalars['String']['output']>;
};

export type PrivateReceiptQrResult = ReceiptPrivateForbidden | ReceiptQrData;

export type PublishTemplateInput = {
  comments: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PublishTemplateResult = ErrorToPublishTemplate | TemplatePublished;

export type Query = {
  __typename?: 'Query';
  FederalEntity?: Maybe<FederalEntityCountry>;
  FederalEntityState?: Maybe<FederalEntityState>;
  GetReceiptsByStatus?: Maybe<GetReceiptByStatusResult>;
  GetReceiptsCountersByStatus?: Maybe<GetReceiptCountersByStatusResult>;
  WorkCenter?: Maybe<WorkCenter>;
  _allCreditsMeta?: Maybe<CreditListMetadata>;
  _allDocumentsMeta?: Maybe<DocumentListMetadata>;
  _allReceiptsMeta?: Maybe<ReceiptListMetadata>;
  _allUsersMeta?: Maybe<ListMetadata>;
  _allWorkCentersMeta?: Maybe<ListMetadata>;
  adoptionReport?: Maybe<ReportResult>;
  allCompanyGroups?: Maybe<AllCompanyGroupsResult>;
  allCompanyWorkTitles?: Maybe<AllCompanyWorkTitlesResult>;
  allCredits?: Maybe<AllCreditsResult>;
  allDocuments?: Maybe<DocumentResponse>;
  allEmployees?: Maybe<AllEmployeesResult>;
  allFederalEntities?: Maybe<Array<Maybe<FederalEntityCountry>>>;
  allReceipts?: Maybe<Array<Maybe<Receipt>>>;
  allRecordChecklist?: Maybe<AllRecordChecklistResultResult>;
  allTemplates?: Maybe<AllTemplatesResult>;
  allUsers?: Maybe<Array<Maybe<User>>>;
  allWorkCenters?: Maybe<Array<Maybe<WorkCenter>>>;
  downloadAdminFile?: Maybe<Scalars['String']['output']>;
  downloadEmployeeRecords?: Maybe<DownloadEmployeeRecordsResult>;
  downloadExtApiFile?: Maybe<DownloadExtApiResult>;
  downloadMyFile?: Maybe<DownloadMyFileResult>;
  downloadMyFiles?: Maybe<Scalars['String']['output']>;
  downloadSignedDocumentXmlFormat?: Maybe<DownloadDocumentXmlResult>;
  downloadSignedReceiptXmlFormat?: Maybe<DownloadSignedReceiptXmlFormatResult>;
  downloadUserCartas?: Maybe<Scalars['String']['output']>;
  downloadUserFile?: Maybe<Scalars['String']['output']>;
  employeesByCompanyId?: Maybe<Array<Maybe<User>>>;
  exportCompanyDocuments?: Maybe<ExportCompanyDocumentsResult>;
  exportCredits?: Maybe<ExportCreditsResult>;
  getAccessTokens?: Maybe<Array<Maybe<AccessToken>>>;
  getAccessTokensByCompanyId?: Maybe<Array<Maybe<AccessToken>>>;
  getAdminDashboard?: Maybe<GetAdminDashboardFinalResult>;
  getAdminUsersForPanel?: Maybe<Array<Maybe<User>>>;
  getAllCompanies?: Maybe<Array<Maybe<Company>>>;
  getAllCompanyAdmins?: Maybe<GetCompanyAdminsFinalResult>;
  getAllEmployeesByCriteria?: Maybe<GetAllEmployeesByCriteriaResult>;
  getAllTemplatesCounters?: Maybe<AllTemplatesCountersResult>;
  getAllVideoAgreementTemplates?: Maybe<GetAllVideoAgreementTemplatesResult>;
  getAllWorkCenters?: Maybe<AllWorkCentersResult>;
  getBeneficiaries?: Maybe<GetBeneficiariesFinalResult>;
  getBillingInfo?: Maybe<GetBillingInfoFinalResult>;
  getClientDashboardCommercial?: Maybe<GetClientDashboardCommercialResult>;
  getClientDashboardCommercialMeta?: Maybe<Scalars['Int']['output']>;
  getCompaniesInfoSupport?: Maybe<GetCompaniesInfoSupportResult>;
  getCompaniesReportSupport?: Maybe<GetCompaniesReportSupportResult>;
  getCompany?: Maybe<GetCompanyFinalResult>;
  getCompanyAdmins?: Maybe<Array<Maybe<User>>>;
  getCompanyDefaultRoles?: Maybe<CompanyDefaultRoles>;
  getCompanyDocuments?: Maybe<GetCompanyDocumentsResult>;
  getCompanyDocumentsCounters?: Maybe<CompanyDocumentsCountersResult>;
  getCompanyEmployees?: Maybe<GetCompanyEmployeesResult>;
  getCompanyEmployeesSupport?: Maybe<GetCompanyEmployeesResult>;
  getCompanyHolidays?: Maybe<GetCompanyHolidaysResult>;
  getCompanyModules?: Maybe<GetCompanyModulesFinalResult>;
  getCompanySchemes?: Maybe<GetCompanySchemesResult>;
  getCompanySignerNotificationsConfig?: Maybe<GetCompanySignerNotificationsConfigResult>;
  getCompanyWorkCenterSupport?: Maybe<Array<Maybe<WorkCenter>>>;
  getCompletedDocumentsByRecordChecklist?: Maybe<GetCompletedDocumentsByRecordChecklistResult>;
  getCountries?: Maybe<Array<Maybe<CountryResult>>>;
  getCustomChartCommercial?: Maybe<GetCustomChartCommercialResult>;
  getCustomersBilling?: Maybe<GetCustomersBillingFinalResult>;
  getDashboard?: Maybe<Dashboard>;
  getDocumentCountByCategory?: Maybe<Scalars['Int']['output']>;
  getDocumentCountBySubcategory?: Maybe<Scalars['Int']['output']>;
  getDocumentCountsByEmployee?: Maybe<GetDocumentCountsByEmployeeResult>;
  getDocumentTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getDocumentTagsSummary?: Maybe<GetDocumentTagsSummaryResultUnion>;
  getDocumentVideoAgreementUrl?: Maybe<Scalars['String']['output']>;
  getDocumentsByCompanyIds?: Maybe<DocumentsByCompanyIdsFinalResult>;
  getDocumentsCountByCompanyIds?: Maybe<DocumentsCountByCompanyIdsFinalResult>;
  getEmployeeAbsenceCountersByCriteria?: Maybe<GetEmployeeAbsenceCountersByCriteriaFinalResult>;
  getEmployeeAbsencesByCriteria?: Maybe<GetEmployeeAbsencesByCriteriaFinalResult>;
  getEmployeeHolidaysSummary: GetEmployeeHolidaysSummaryResultUnion;
  getEmployeeInfo: GetEmployeeInfoResult;
  getEmployeeRecordsTags?: Maybe<Array<Maybe<GetEmployeeRecordsTagsResult>>>;
  getEmployeesByAuthorizersTeam: GetEmployeesByAuthorizersTeamResult;
  getEmployeesByCollectiveCount?: Maybe<Scalars['Int']['output']>;
  getEmployeesByCompanyIds?: Maybe<AllEmployeesByCompanyIdsFinalResult>;
  getEmployeesByGroup?: Maybe<GetEmployeesByGroupResult>;
  getEmployeesByHolidayScheme: GetEmployeesByHolidaySchemeResult;
  getEmployeesByRecordChecklist?: Maybe<GetEmployeesByRecordChecklistResult>;
  getEmployeesByWorkTitle?: Maybe<GetEmployeesByWorkTitleResult>;
  getEmployeesCountToSendOnboardNotif?: Maybe<GetEmployeesCountToSendOnboardNotifFinalResult>;
  getEmployeesCounterByCompanyIds?: Maybe<EmployeesCounterByCompanyIdsFinalResult>;
  getEmployeesCountersByStatus?: Maybe<GetEmployeesCountersByStatusResult>;
  getEmployeesCountersByStatusSupport?: Maybe<GetEmployeesCountersByStatusResult>;
  getEmployeesWithPendingDocuments?: Maybe<GetEmployeesWithPendingDocumentsUnionResponse>;
  getEmployeesWithoutRecordChecklist?: Maybe<GetEmployeesWithoutRecordChecklistResult>;
  getEmployeesWithoutRecordChecklistDocument?: Maybe<GetEmployeesWithoutChecklistDocumentResult>;
  getExtApiById?: Maybe<AccessToken>;
  getExtApiPermissions?: Maybe<Array<Maybe<TokenPermissions>>>;
  getFileAsHtml?: Maybe<Scalars['String']['output']>;
  getFileDataByLegalStatus?: Maybe<GetFileDataByLegalStatusResult>;
  getGroupsByCompanyIds?: Maybe<GetGroupsByCompanyIdsFinalResult>;
  getHolidayAuthorizersTeams?: Maybe<GetHolidayAuthorizersTeamsFinalResult>;
  getHolidaysFromRoles: GetHolidaysFromRolesResultUnion;
  getHolidaysFromRolesCounters: GetHolidaysFromRolesCountersResult;
  getInfoRequestedByCompany?: Maybe<GetInfoRequestedByCompanyFinalResult>;
  getInfoUserSupport?: Maybe<InfoUserSupport>;
  getLocationById?: Maybe<GetLocationByIdResult>;
  getLocationByZipCode?: Maybe<GetLocationByZipCodeResult>;
  getLocationSuggestions?: Maybe<GetLocationSuggestionsResult>;
  getMasterFromCompany?: Maybe<Array<Maybe<User>>>;
  getMyCompanies?: Maybe<Array<Maybe<Company>>>;
  getMyCompanyHolidays?: Maybe<GetCompanyHolidaysResult>;
  getMyFileAsHtml?: Maybe<Scalars['String']['output']>;
  getMyPendingDataChangeRequest?: Maybe<UserDataChangeRequest>;
  getMyPendingDocumentsAndReceipts?: Maybe<GetMyPendingDocumentsAndReceiptsResult>;
  getMyProfile?: Maybe<GetMyProfileResult>;
  getOfficialHolidays?: Maybe<GetCompanyHolidaysResult>;
  getOnboardingDocsSupport?: Maybe<GetOnboardingDocsResult>;
  getOnboardingLink?: Maybe<GetOnboardingLinkResult>;
  getPendingDataChangeRequest?: Maybe<UserDataChangeRequest>;
  getPendingDocumentsByRecordChecklist?: Maybe<GetPendingDocumentsByRecordChecklistResult>;
  getPendingOnboardingDocuments?: Maybe<Array<Maybe<PendingOnboardingDocument>>>;
  getPrivacyPolicyByUser?: Maybe<GetPrivacyPolicyByUserResult>;
  getPrivateFileData?: Maybe<GetPrivateFileDataResult>;
  getReceiptCountsByEmployee?: Maybe<GetReceiptCountsByEmployeeResult>;
  getReceiptsByCompanyIds?: Maybe<AllReceiptsByCompanyIdsFinalResult>;
  getReceiptsCounterByCompanyIds?: Maybe<ReceiptsCounterByCompanyIdsFinalResult>;
  getRecordChecklistAssignedByEmployee?: Maybe<RecordChecklistAssignedByEmployeeResult>;
  getRecordChecklistDocumentTagPercentages?: Maybe<GetRecordChecklistDocumentTagPercentagesResult>;
  getRecordChecklistGeneralPercentage?: Maybe<GetRecordChecklistGeneralPercentageResult>;
  getRequestedEmployeeDocuments?: Maybe<Array<Maybe<RequestedEmployeeDocument>>>;
  getSingleCompanyCommercial?: Maybe<GetSingleCompanyCommercialResult>;
  getSoraDashboardCommercial?: Maybe<GetSoraDashboardCommercialResult>;
  getTemplate?: Maybe<GetTemplateResult>;
  getTotalEmployeesByGroup?: Maybe<GetTotalEmployeesByGroupResult>;
  getTotalEmployeesByWorkTitle?: Maybe<GetTotalEmployeesByWorkTitleResult>;
  getTotalEmployeesWithDiffRecordChecklist?: Maybe<GetTotalEmployeesWithDiffRecordChecklistResult>;
  getUserInfoRequestedByCompany?: Maybe<Array<Maybe<UserInfoRequestedByCompany>>>;
  getUserOnboardingSteps?: Maybe<GetUserOnboardingStepsResult>;
  getUserPermissions?: Maybe<GetUserPermissionsResult>;
  getUserProfile?: Maybe<UserProfileResult>;
  getUserWorkspace?: Maybe<GetUserWorkspaceFinalResult>;
  getUsersBilling?: Maybe<GetUsersBillingFinalResult>;
  getUsersIdentityValidationStatus?: Maybe<Array<Maybe<GetUsersIdentityValidationStatusResult>>>;
  getUsersIdentityValidationStatusCounter?: Maybe<GetUsersIdentityValidationStatusCounterResult>;
  getUsersSupport?: Maybe<GetUserSupportResult>;
  getWCsByCompId?: Maybe<Array<Maybe<WorkCenter>>>;
  getWorkCentersByCompanyIds?: Maybe<GetWorkCentersByCompanyIdsFinalResult>;
  getWorkTitlesByCompanyIds?: Maybe<GetWorkTitlesByCompanyIdsFinalResult>;
  getWorkcentersByCompanySupport?: Maybe<Array<Maybe<WcCompany>>>;
  myCredits?: Maybe<MyCreditsResult>;
  myDashboard?: Maybe<EmployeeDashboard>;
  myDocsAndReceipts?: Maybe<MyDocsAndReceiptsResult>;
  myDocuments?: Maybe<MyDocumentsResult>;
  myReceipts?: Maybe<MyReceiptsResult>;
  oldestUnsignedReceipt?: Maybe<OldestUnsignedReceipt>;
  sifeContactMethods?: Maybe<SifeContactMethodsResponse>;
  userOnboarding?: Maybe<UserOnboardingResult>;
  verifyPrivateReceiptQr?: Maybe<PrivateReceiptQrResult>;
};


export type QueryFederalEntityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFederalEntityStateArgs = {
  federalEntityId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReceiptsByStatusArgs = {
  input?: InputMaybe<GetReceiptsByStatusInput>;
};


export type QueryGetReceiptsCountersByStatusArgs = {
  input?: InputMaybe<GetReceiptsCountersByStatusInput>;
};


export type QueryWorkCenterArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type Query_AllDocumentsMetaArgs = {
  filter?: InputMaybe<DocumentFilter>;
};


export type Query_AllReceiptsMetaArgs = {
  filter?: InputMaybe<ReceiptFilter>;
};


export type Query_AllUsersMetaArgs = {
  filter?: InputMaybe<UserFilter>;
};


export type QueryAdoptionReportArgs = {
  input: ReportDate;
};


export type QueryAllCompanyGroupsArgs = {
  filter?: InputMaybe<AllCompanyGroupsFilter>;
};


export type QueryAllCompanyWorkTitlesArgs = {
  filter?: InputMaybe<AllCompanyWorkTitlesFilter>;
};


export type QueryAllCreditsArgs = {
  filter?: InputMaybe<AllCreditsFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<AllDocumentsSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrderEnum>;
};


export type QueryAllEmployeesArgs = {
  filter?: InputMaybe<FilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllFederalEntitiesArgs = {
  filter?: InputMaybe<FederalEntityFilter>;
};


export type QueryAllReceiptsArgs = {
  filter?: InputMaybe<ReceiptFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<AllReceiptsSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrderEnum>;
};


export type QueryAllTemplatesArgs = {
  filter?: InputMaybe<GetAllTemplatesInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<AllUsersSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrderEnum>;
};


export type QueryDownloadAdminFileArgs = {
  type: DownloadAdminFileEnum;
};


export type QueryDownloadEmployeeRecordsArgs = {
  employeeId: Scalars['String']['input'];
};


export type QueryDownloadExtApiFileArgs = {
  input?: InputMaybe<DownloadExtApiFileInput>;
};


export type QueryDownloadMyFileArgs = {
  asAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  searchId: Scalars['String']['input'];
  type: DownloadRequestTypeEnum;
};


export type QueryDownloadMyFilesArgs = {
  input?: InputMaybe<DownloadMyFilesInput>;
};


export type QueryDownloadSignedDocumentXmlFormatArgs = {
  employeeDocumentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadSignedReceiptXmlFormatArgs = {
  receiptId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadUserCartasArgs = {
  input: DownloadUserCartas;
};


export type QueryDownloadUserFileArgs = {
  asAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  searchId?: InputMaybe<Scalars['String']['input']>;
  type: DownloadRequestTypeEnum;
  userId: Scalars['String']['input'];
};


export type QueryEmployeesByCompanyIdArgs = {
  companyId: Scalars['String']['input'];
  filter?: InputMaybe<UserFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<AllUsersSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrderEnum>;
};


export type QueryExportCompanyDocumentsArgs = {
  input?: InputMaybe<ExportCompanyDocumentsInput>;
};


export type QueryExportCreditsArgs = {
  input?: InputMaybe<ExportCreditsInput>;
};


export type QueryGetAccessTokensByCompanyIdArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetAdminDashboardArgs = {
  input?: InputMaybe<GetAdminDashboardFilter>;
};


export type QueryGetAdminUsersForPanelArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetAllCompanyAdminsArgs = {
  filter?: InputMaybe<GetCompanyAdminsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllEmployeesByCriteriaArgs = {
  filter?: InputMaybe<GetAllEmployeesByCriteriaFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAllTemplatesCountersArgs = {
  filter?: InputMaybe<GetAllTemplatesCountersInput>;
};


export type QueryGetAllWorkCentersArgs = {
  filter?: InputMaybe<FilterInputWorkCenterFinder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBeneficiariesArgs = {
  input?: InputMaybe<GetBeneficiariesInput>;
};


export type QueryGetBillingInfoArgs = {
  filter?: InputMaybe<GetBillingInfoFilter>;
};


export type QueryGetClientDashboardCommercialArgs = {
  filter?: InputMaybe<GetClientDashboardCommercialInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetClientDashboardCommercialMetaArgs = {
  input?: InputMaybe<GetClientDashboardCommercialInput>;
};


export type QueryGetCompaniesInfoSupportArgs = {
  input?: InputMaybe<GetCompaniesInfoInput>;
};


export type QueryGetCompaniesReportSupportArgs = {
  input?: InputMaybe<GetCompaniesReportInput>;
};


export type QueryGetCompanyArgs = {
  filter?: InputMaybe<GetCompanyFilter>;
};


export type QueryGetCompanyAdminsArgs = {
  adminTypes?: InputMaybe<Array<InputMaybe<AdminType>>>;
  searchPermission?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCompanyDocumentsArgs = {
  input?: InputMaybe<GetCompanyDocumentsInput>;
};


export type QueryGetCompanyDocumentsCountersArgs = {
  input?: InputMaybe<GetCompanyDocumentsCountersInput>;
};


export type QueryGetCompanyEmployeesArgs = {
  input?: InputMaybe<GetCompanyEmployeesInput>;
};


export type QueryGetCompanyEmployeesSupportArgs = {
  input?: InputMaybe<GetCompanyEmployeesSupportInput>;
};


export type QueryGetCompanyHolidaysArgs = {
  input: GetCompanyHolidaysInput;
};


export type QueryGetCompanyModulesArgs = {
  filter?: InputMaybe<GetCompanyModulesFilterInput>;
};


export type QueryGetCompanyWorkCenterSupportArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompletedDocumentsByRecordChecklistArgs = {
  filter: GetCompletedDocumentsByRecordChecklistFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetCustomChartCommercialArgs = {
  input?: InputMaybe<GetCustomChartCommercialInput>;
};


export type QueryGetCustomersBillingArgs = {
  filter?: InputMaybe<GetCustomersBillingFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDashboardArgs = {
  filter?: InputMaybe<DashboardFilter>;
};


export type QueryGetDocumentCountByCategoryArgs = {
  category: Scalars['String']['input'];
};


export type QueryGetDocumentCountBySubcategoryArgs = {
  category: Scalars['String']['input'];
  subcategory: Scalars['String']['input'];
};


export type QueryGetDocumentCountsByEmployeeArgs = {
  input?: InputMaybe<GetDocumentCountsByEmployeeInput>;
};


export type QueryGetDocumentTagsSummaryArgs = {
  input?: InputMaybe<GetDocumentTagsSummaryInput>;
};


export type QueryGetDocumentVideoAgreementUrlArgs = {
  asAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  documentId: Scalars['String']['input'];
};


export type QueryGetDocumentsByCompanyIdsArgs = {
  filter?: InputMaybe<DocumentsByCompanyIdsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDocumentsCountByCompanyIdsArgs = {
  filter?: InputMaybe<DocumentsByCompanyIdsFilterInput>;
};


export type QueryGetEmployeeAbsenceCountersByCriteriaArgs = {
  filter?: InputMaybe<GetEmployeeAbsenceCountersByCriteriaInput>;
};


export type QueryGetEmployeeAbsencesByCriteriaArgs = {
  filter?: InputMaybe<GetEmployeeAbsencesByCriteriaInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEmployeeInfoArgs = {
  input: GetEmployeeInfoInput;
};


export type QueryGetEmployeesByAuthorizersTeamArgs = {
  input: GetEmployeesByAuthorizersTeamInput;
};


export type QueryGetEmployeesByCollectiveCountArgs = {
  input: GetEmployeesByCollectiveCountInput;
};


export type QueryGetEmployeesByCompanyIdsArgs = {
  filter?: InputMaybe<EmployeesByCompanyIdsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEmployeesByGroupArgs = {
  group: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmployeesByHolidaySchemeArgs = {
  input: GetEmployeesByHolidaySchemeInput;
};


export type QueryGetEmployeesByRecordChecklistArgs = {
  filter?: InputMaybe<GetEmployeesByRecordChecklisFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  recordChecklistId: Scalars['String']['input'];
};


export type QueryGetEmployeesByWorkTitleArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  workTitle: Scalars['String']['input'];
};


export type QueryGetEmployeesCountToSendOnboardNotifArgs = {
  input?: InputMaybe<GetEmployeesCountToSendOnboardNotifInput>;
};


export type QueryGetEmployeesCounterByCompanyIdsArgs = {
  filter?: InputMaybe<EmployeesByCompanyIdsFilterInput>;
};


export type QueryGetEmployeesCountersByStatusArgs = {
  input?: InputMaybe<GetEmployeesCountersByStatusInput>;
};


export type QueryGetEmployeesCountersByStatusSupportArgs = {
  input?: InputMaybe<GetEmployeesCountersByStatusSupportInput>;
};


export type QueryGetEmployeesWithoutRecordChecklistArgs = {
  filter?: InputMaybe<GetEmployeesWithoutRecordChecklisFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetEmployeesWithoutRecordChecklistDocumentArgs = {
  filter: GetEmployeesWithoutChecklistDocumentFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetExtApiByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryGetExtApiPermissionsArgs = {
  extApiId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileAsHtmlArgs = {
  searchId?: InputMaybe<Scalars['String']['input']>;
  type: DownloadRequestTypeEnum;
  userId: Scalars['String']['input'];
};


export type QueryGetFileDataByLegalStatusArgs = {
  input: GetFileDataByLegalStatusInput;
};


export type QueryGetGroupsByCompanyIdsArgs = {
  filter?: InputMaybe<GetGroupsByCompanyIdsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetHolidaysFromRolesArgs = {
  input: GetHolidaysFromRolesInput;
};


export type QueryGetHolidaysFromRolesCountersArgs = {
  input: GetHolidaysFromRolesCountersInput;
};


export type QueryGetInfoRequestedByCompanyArgs = {
  input?: InputMaybe<GetInfoRequestedByCompanyFilterInput>;
};


export type QueryGetInfoUserSupportArgs = {
  input?: InputMaybe<GetInfoUserSupportInput>;
};


export type QueryGetLocationByIdArgs = {
  input: GetLocationByIdInput;
};


export type QueryGetLocationByZipCodeArgs = {
  input: GetLocationByZipCodeInput;
};


export type QueryGetLocationSuggestionsArgs = {
  input: GetLocationSuggestionsInput;
};


export type QueryGetMasterFromCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetMyCompanyHolidaysArgs = {
  input: GetCompanyHolidaysInput;
};


export type QueryGetMyFileAsHtmlArgs = {
  searchId?: InputMaybe<Scalars['String']['input']>;
  type: DownloadRequestTypeEnum;
};


export type QueryGetMyPendingDocumentsAndReceiptsArgs = {
  filter?: InputMaybe<GetMyPendingDocumentsAndReceiptsFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOfficialHolidaysArgs = {
  input: GetCompanyHolidaysInput;
};


export type QueryGetOnboardingDocsSupportArgs = {
  input?: InputMaybe<GetOnboardingDocsInput>;
};


export type QueryGetOnboardingLinkArgs = {
  input: GetOnboardingLinkInput;
};


export type QueryGetPendingDataChangeRequestArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPendingDocumentsByRecordChecklistArgs = {
  filter: GetPendingDocumentsByRecordChecklistFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPendingOnboardingDocumentsArgs = {
  input?: InputMaybe<GetPendingOnboardingDocumentsInput>;
};


export type QueryGetPrivacyPolicyByUserArgs = {
  input?: InputMaybe<GetPrivacyPolicyByUserInput>;
};


export type QueryGetPrivateFileDataArgs = {
  input: GetPrivateFileDataInput;
};


export type QueryGetReceiptCountsByEmployeeArgs = {
  input?: InputMaybe<GetReceiptCountsByEmployeeInput>;
};


export type QueryGetReceiptsByCompanyIdsArgs = {
  filter?: InputMaybe<ReceiptsByCompanyIdsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetReceiptsCounterByCompanyIdsArgs = {
  filter?: InputMaybe<ReceiptsByCompanyIdsFilterInput>;
};


export type QueryGetRecordChecklistAssignedByEmployeeArgs = {
  employeeId: Scalars['String']['input'];
};


export type QueryGetRecordChecklistDocumentTagPercentagesArgs = {
  filter: GetRecordChecklistDocumentTagPercentagesFilterInput;
};


export type QueryGetRecordChecklistGeneralPercentageArgs = {
  filter: GetRecordChecklistGeneralPercentageFilterInput;
};


export type QueryGetSingleCompanyCommercialArgs = {
  input?: InputMaybe<GetSingleCompanyCommercialInput>;
};


export type QueryGetSoraDashboardCommercialArgs = {
  input?: InputMaybe<GetSoraDashboardCommercialInput>;
};


export type QueryGetTemplateArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTotalEmployeesByGroupArgs = {
  group: Scalars['String']['input'];
};


export type QueryGetTotalEmployeesByWorkTitleArgs = {
  workTitle: Scalars['String']['input'];
};


export type QueryGetTotalEmployeesWithDiffRecordChecklistArgs = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  recordChecklistId: Scalars['String']['input'];
  workCenterId?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserOnboardingStepsArgs = {
  input?: InputMaybe<GetUserOnboardingStepsInput>;
};


export type QueryGetUserPermissionsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserProfileArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserWorkspaceArgs = {
  input?: InputMaybe<GetUserWorkspaceInput>;
};


export type QueryGetUsersBillingArgs = {
  filter?: InputMaybe<GetUsersBillingFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUsersIdentityValidationStatusArgs = {
  input: GetUsersIdentityValidationStatusInput;
};


export type QueryGetUsersIdentityValidationStatusCounterArgs = {
  input: GetUsersIdentityValidationStatusCounterInput;
};


export type QueryGetUsersSupportArgs = {
  input?: InputMaybe<GetUserSupportInput>;
};


export type QueryGetWCsByCompIdArgs = {
  input?: InputMaybe<GetWCsByCompIdInput>;
};


export type QueryGetWorkCentersByCompanyIdsArgs = {
  filter?: InputMaybe<GetWorkCentersByCompanyIdsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetWorkTitlesByCompanyIdsArgs = {
  filter?: InputMaybe<GetWorkTitlesByCompanyIdsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetWorkcentersByCompanySupportArgs = {
  input?: InputMaybe<GetWCsByCompIdsInput>;
};


export type QueryMyDocsAndReceiptsArgs = {
  filter?: InputMaybe<MyDocsAndReceiptFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyDocumentsArgs = {
  filter?: InputMaybe<MyDocumentsFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyReceiptsArgs = {
  filter?: InputMaybe<MyReceiptsFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MyReceiptsSort>;
};


export type QuerySifeContactMethodsArgs = {
  input?: InputMaybe<SifeContactMethodsInput>;
};


export type QueryVerifyPrivateReceiptQrArgs = {
  input: ReceiptQrInput;
};

export type Receipt = {
  __typename?: 'Receipt';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeSignature?: Maybe<EmployeeSignature>;
  fiscalDetails?: Maybe<FiscalDetails>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  linkUuid?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  previousId?: Maybe<Scalars['String']['output']>;
  queueStatus?: Maybe<Scalars['String']['output']>;
  receiptDetail?: Maybe<ReceiptDetails>;
  rfc?: Maybe<Scalars['String']['output']>;
  signDate?: Maybe<Scalars['Date']['output']>;
  signatureType?: Maybe<Scalars['String']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  title?: Maybe<Scalars['String']['output']>;
  tokenQr?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workCenterMessage?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
};

export type ReceiptConfigInput = {
  areReceiptsSignable?: InputMaybe<Scalars['Boolean']['input']>;
  showRegisteredSalary?: InputMaybe<Scalars['Boolean']['input']>;
  showSalaryType?: InputMaybe<Scalars['Boolean']['input']>;
  showXMLSalary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReceiptConfigs = {
  __typename?: 'ReceiptConfigs';
  areReceiptsSignable?: Maybe<CompanyConfig>;
  showRegisteredSalary?: Maybe<CompanyConfig>;
  showSalaryType?: Maybe<CompanyConfig>;
  showXMLSalary?: Maybe<CompanyConfig>;
};

export type ReceiptCounters = {
  __typename?: 'ReceiptCounters';
  pending?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReceiptCounts = {
  __typename?: 'ReceiptCounts';
  signed?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReceiptData = {
  __typename?: 'ReceiptData';
  endDate?: Maybe<Scalars['Date']['output']>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ReceiptDetails = {
  __typename?: 'ReceiptDetails';
  deductions?: Maybe<Array<Maybe<Deduction>>>;
  disabilities?: Maybe<Array<Maybe<Disability>>>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentEndDate?: Maybe<Scalars['Date']['output']>;
  paymentStartDate?: Maybe<Scalars['Date']['output']>;
  perceptions?: Maybe<Array<Maybe<Perception>>>;
  stampUUID?: Maybe<Scalars['String']['output']>;
  totalDeductions?: Maybe<Scalars['String']['output']>;
  totalPaidDays?: Maybe<Scalars['String']['output']>;
  totalPayment?: Maybe<Scalars['String']['output']>;
  totalPerceptions?: Maybe<Scalars['String']['output']>;
};

export type ReceiptFilter = {
  canBeSigned?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReceiptItem = {
  __typename?: 'ReceiptItem';
  _id?: Maybe<Scalars['String']['output']>;
  canBeSigned?: Maybe<Scalars['Boolean']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  paymentEndDate?: Maybe<Scalars['String']['output']>;
  paymentPeriodicity?: Maybe<Scalars['String']['output']>;
  paymentStartDate?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
};

export type ReceiptListMetadata = {
  __typename?: 'ReceiptListMetadata';
  all?: Maybe<Scalars['Int']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  unsignable?: Maybe<Scalars['Int']['output']>;
  unsigned?: Maybe<Scalars['Int']['output']>;
};

export type ReceiptNotCompletelySigned = {
  __typename?: 'ReceiptNotCompletelySigned';
  message?: Maybe<Scalars['String']['output']>;
};

export type ReceiptPrivate = {
  __typename?: 'ReceiptPrivate';
  message?: Maybe<Scalars['String']['output']>;
};

export type ReceiptPrivateForbidden = {
  __typename?: 'ReceiptPrivateForbidden';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ReceiptQrData = {
  __typename?: 'ReceiptQRData';
  companyName?: Maybe<Scalars['String']['output']>;
  companyRfc?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  employeeRfc?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  signDate?: Maybe<Scalars['Date']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  stampUuid?: Maybe<Scalars['String']['output']>;
};

export type ReceiptQrInput = {
  companyId: Scalars['String']['input'];
  employeeRfc: Scalars['String']['input'];
  receiptId: Scalars['String']['input'];
};

export type ReceiptQrResult = ReceiptPrivate | ReceiptQrData;

export type ReceiptValidationData = {
  __typename?: 'ReceiptValidationData';
  companyDataMatches?: Maybe<Scalars['Boolean']['output']>;
  employeeExists?: Maybe<Scalars['Boolean']['output']>;
  employeeRfc?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ReceiptsByCompanyIdsFilterInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employees?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  groups?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
  period?: InputMaybe<ReceiptsDateFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  shouldGroupReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSearchByAllGroups?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  workCenters?: InputMaybe<Array<InputMaybe<EmployeeAndWorkCenterItem>>>;
  workTitles?: InputMaybe<Array<InputMaybe<WorkTitleAndGroupItem>>>;
};

export type ReceiptsByCompanyIdsResult = {
  __typename?: 'ReceiptsByCompanyIdsResult';
  receipts?: Maybe<Array<Maybe<ReceiptItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReceiptsCounterByCompanyIdsFinalResult = ReceiptsCounterByCompanyIdsResult;

export type ReceiptsCounterByCompanyIdsResult = {
  __typename?: 'ReceiptsCounterByCompanyIdsResult';
  data?: Maybe<Array<Maybe<ItemChartData>>>;
  receiptsCounter?: Maybe<ReceiptCounters>;
};

export type ReceiptsDateFilter = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type ReceiptsDateRangeInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type RecordChecklist = {
  __typename?: 'RecordChecklist';
  _id?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<UserReference>;
  description?: Maybe<Scalars['String']['output']>;
  documentTags?: Maybe<Array<Maybe<RecordChecklistDocumentTag>>>;
  name?: Maybe<Scalars['String']['output']>;
  totalEmployees?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<UserReference>;
};

export type RecordChecklistAlreadyExists = {
  __typename?: 'RecordChecklistAlreadyExists';
  name?: Maybe<Scalars['String']['output']>;
};

export type RecordChecklistAssigned = {
  __typename?: 'RecordChecklistAssigned';
  _id: Scalars['String']['output'];
  assignType: Scalars['String']['output'];
  assignedAt: Scalars['Date']['output'];
  assignedBy?: Maybe<RecordChecklistAssignedBy>;
  name: Scalars['String']['output'];
};

export type RecordChecklistAssignedBy = {
  __typename?: 'RecordChecklistAssignedBy';
  _id: Scalars['String']['output'];
  curp?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP: Scalars['String']['output'];
  names: Scalars['String']['output'];
  rfc?: Maybe<Scalars['String']['output']>;
};

export type RecordChecklistAssignedByEmployeeResult = {
  __typename?: 'RecordChecklistAssignedByEmployeeResult';
  recordChecklistAssigned?: Maybe<RecordChecklistAssignedResult>;
  recordChecklistAssignedDocuments?: Maybe<RecordChecklistAssignedDocumentsResult>;
  recordChecklistAssignedDocumentsCounts?: Maybe<RecordChecklistAssignedDocumentsCountsResult>;
};

export type RecordChecklistAssignedDocument = {
  __typename?: 'RecordChecklistAssignedDocument';
  _id: Scalars['String']['output'];
  canBeSigned: Scalars['Boolean']['output'];
  canRequestNewDoc: Scalars['Boolean']['output'];
  category: Scalars['String']['output'];
  categoryColor: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  history: Array<Maybe<DocumentHistory>>;
  onlyStorage: Scalars['Boolean']['output'];
  seen: Scalars['Boolean']['output'];
  seenAt?: Maybe<Scalars['Date']['output']>;
  signed: Scalars['Boolean']['output'];
  signedAt?: Maybe<Scalars['Date']['output']>;
  status: RecordChecklistAssignedDocumentStatus;
  subcategory: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uploaded: Scalars['Boolean']['output'];
  videoAgreement?: Maybe<VideoAgreement>;
  videoAgreementRequired: Scalars['Boolean']['output'];
};

export enum RecordChecklistAssignedDocumentStatus {
  Completed = 'COMPLETED',
  EmployeeUploadDoc = 'EMPLOYEE_UPLOAD_DOC',
  Pending = 'PENDING',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED'
}

export type RecordChecklistAssignedDocuments = {
  __typename?: 'RecordChecklistAssignedDocuments';
  documents?: Maybe<Array<Maybe<RecordChecklistAssignedDocument>>>;
};

export type RecordChecklistAssignedDocumentsCounts = {
  __typename?: 'RecordChecklistAssignedDocumentsCounts';
  percentageCompleted: Scalars['Float']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalDocumentsCompleted: Scalars['Int']['output'];
};

export type RecordChecklistAssignedDocumentsCountsResult = RecordChecklistAssignedDocumentsCounts | RecordChecklistNotAssigned | ResourceNotFound;

export type RecordChecklistAssignedDocumentsResult = RecordChecklistAssignedDocuments | RecordChecklistNotAssigned | ResourceNotFound;

export type RecordChecklistAssignedResult = RecordChecklistAssigned | RecordChecklistNotAssigned | ResourceNotFound;

export type RecordChecklistDeleted = {
  __typename?: 'RecordChecklistDeleted';
  recordChecklistId?: Maybe<Scalars['String']['output']>;
};

export type RecordChecklistDocumentTag = {
  __typename?: 'RecordChecklistDocumentTag';
  documentAction: Scalars['String']['output'];
  documentCategoryColor: Scalars['String']['output'];
  documentCategoryName: Scalars['String']['output'];
  documentSubcategoryName: Scalars['String']['output'];
};

export type RecordChecklistDocumentTagInput = {
  documentAction: Scalars['String']['input'];
  documentCategoryColor: Scalars['String']['input'];
  documentCategoryName: Scalars['String']['input'];
  documentSubcategoryName: Scalars['String']['input'];
};

export type RecordChecklistIndividualPercentage = {
  __typename?: 'RecordChecklistIndividualPercentage';
  clientName: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  recordChecklistId: Scalars['String']['output'];
  recordChecklistName: Scalars['String']['output'];
};

export type RecordChecklistInvalidDocumentTags = {
  __typename?: 'RecordChecklistInvalidDocumentTags';
  numberOfTags?: Maybe<Scalars['Int']['output']>;
};

export type RecordChecklistNotAssigned = {
  __typename?: 'RecordChecklistNotAssigned';
  companyId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RecordChecklistResult = {
  __typename?: 'RecordChecklistResult';
  allRecordChecklist?: Maybe<Array<Maybe<RecordChecklist>>>;
};

export type RegistrationNotAllowed = ErrorMessage & {
  __typename?: 'RegistrationNotAllowed';
  message?: Maybe<Scalars['String']['output']>;
};

export type RejectDocumentFromEmployeeInput = {
  _id: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
};

export type RejectDocumentVideoAgreementInput = {
  documentId: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
};

export type RejectHolidayRequestInput = {
  comments: Scalars['String']['input'];
  holidayId: Scalars['String']['input'];
};

export type RejectHolidayRequestResult = Error | Success;

export type RejectTemplateInput = {
  comments: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RejectTemplateResult = ErrorToRejectTemplate | TemplateRejected;

export type ReloadCronJobResult = Error | Success;

export type RenewAccessTokenInput = {
  _id: Scalars['String']['input'];
};

export type RenewTokenReponse = {
  __typename?: 'RenewTokenReponse';
  token?: Maybe<Scalars['String']['output']>;
};

export type ReportDate = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportLink = {
  __typename?: 'ReportLink';
  link: Scalars['String']['output'];
};

export type ReportResult = GeneralError | ReportLink;

export type RequestBeneficiariesToEmployeeFinalResult = ErrorToRequestBeneficiariesToEmployee | RequestBeneficiariesToEmployeeResult;

export type RequestBeneficiariesToEmployeeInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
};

export type RequestBeneficiariesToEmployeeResult = {
  __typename?: 'RequestBeneficiariesToEmployeeResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestedEmployeeDocument = {
  __typename?: 'RequestedEmployeeDocument';
  _id?: Maybe<Scalars['String']['output']>;
  aiResponse?: Maybe<DocumentAi>;
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<Maybe<DocumentHistory>>>;
  status: DocumentHistoryStatusEnum;
  subcategory: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ResourceNotFound = {
  __typename?: 'ResourceNotFound';
  message?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['String']['output']>;
};

export type ResponseItem = {
  __typename?: 'ResponseItem';
  message?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type RetryImportAuthorizersTeamInput = {
  rows: Array<ImportAuthorizersTeamRowInput>;
};

export type RfcAlreadyInUse = {
  __typename?: 'RfcAlreadyInUse';
  message?: Maybe<Scalars['String']['output']>;
};

export type RhPod = {
  __typename?: 'RhPod';
  otp?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export enum Sora_Modules {
  Documents = 'DOCUMENTS',
  Rest = 'REST'
}

export type SalaryUpdate = Success | UploadSalaryNoRfcsFoundInExcel | UploadSalaryUsersNotFound | UploadSalaryWsNotFound;

export type SatAiEntity = {
  __typename?: 'SatAiEntity';
  documentData?: Maybe<SatData>;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  webScrapingData?: Maybe<SatData>;
};

export type SatData = {
  __typename?: 'SatData';
  CIF?: Maybe<Scalars['String']['output']>;
  CURP?: Maybe<Scalars['String']['output']>;
  RFC?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  internalNumber?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  lastStatusChangeDate?: Maybe<Scalars['String']['output']>;
  localityName?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  roadType?: Maybe<Scalars['String']['output']>;
  startDateOfOperations?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  statusInRegistry?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tradeName?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ScheduledDocumentCategoriesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export enum ScheduledDocumentPriority {
  High = 'HIGH',
  None = 'NONE'
}

export type SelectedPdfConflict = {
  __typename?: 'SelectedPdfConflict';
  message?: Maybe<Scalars['String']['output']>;
};

export type SendMassiveOnboardingNotification = {
  __typename?: 'SendMassiveOnboardingNotification';
  dateSent?: Maybe<Scalars['Date']['output']>;
};

export type SendMassiveOnboardingNotificationFinalResult = ErrorToSendMassiveOnboardingNotification | SendMassiveOnboardingNotificationResult;

export type SendMassiveOnboardingNotificationInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type SendMassiveOnboardingNotificationResult = {
  __typename?: 'SendMassiveOnboardingNotificationResult';
  errors?: Maybe<Array<Maybe<ResponseItem>>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  totalSuccess?: Maybe<Scalars['Int']['output']>;
};

export type SendOnboardingNotificationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['String']['input'];
};

export type SendOnboardingNotificationResult = EmailAlreadyInUse | NotificationTimeout | SendOnboardingNotificationSuccess | UserAlreadyActive | UserNotFound;

export type SendOnboardingNotificationSuccess = {
  __typename?: 'SendOnboardingNotificationSuccess';
  esMessage?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SendPendingDocsNotifToEmployeesByCompanyIdsInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SendPendingDocsNotifToEmployeesByCompanyIdsResult = Error | SendPendingDocsNotifToEmployeesByCompanyIdsSuccess;

export type SendPendingDocsNotifToEmployeesByCompanyIdsSuccess = {
  __typename?: 'SendPendingDocsNotifToEmployeesByCompanyIdsSuccess';
  failed?: Maybe<Scalars['Int']['output']>;
  failedNotifications?: Maybe<Array<Maybe<FailedNotification>>>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type SendPendingDocumentsNotificationToEmployeesResult = Error | SendPendingDocumentsNotificationToEmployeesSuccess;

export type SendPendingDocumentsNotificationToEmployeesSuccess = {
  __typename?: 'SendPendingDocumentsNotificationToEmployeesSuccess';
  failed?: Maybe<Scalars['Int']['output']>;
  failedNotifications?: Maybe<Array<Maybe<FailedNotification>>>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type SendPendingDocumentsNotificationToSingleEmployeeResult = Error | Success;

export type SendRecoveryUserSupportInput = {
  contactMethod?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SendRecoveryUserSupportResult = ErrorToSendRecoveryUserSupport | FinalResponseSendRecoveryUserSupport;

export type SendVerificationDataFinalResult = ErrorToSendVerificationData | SendVerificationDataResult;

export type SendVerificationDataInput = {
  contactMethod: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SendVerificationDataResult = {
  __typename?: 'SendVerificationDataResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SentDocument = {
  __typename?: 'SentDocument';
  message?: Maybe<Scalars['String']['output']>;
};

export type SentOnboardingNotification = {
  __typename?: 'SentOnboardingNotification';
  dateSent?: Maybe<Scalars['Date']['output']>;
  sentBy?: Maybe<CreatedByType>;
};

export type SetDocumentsVisibility = SetDocumentsVisibilityError | Success;

export type SetDocumentsVisibilityDocumentError = {
  __typename?: 'SetDocumentsVisibilityDocumentError';
  _id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SetDocumentsVisibilityError = {
  __typename?: 'SetDocumentsVisibilityError';
  errors?: Maybe<Array<Maybe<SetDocumentsVisibilityDocumentError>>>;
};

export type SifeChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  rfc: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: SifeChangePasswordType;
};

export enum SifeChangePasswordType {
  SifePreRegistration = 'SIFE_PRE_REGISTRATION',
  SifeResetPassword = 'SIFE_RESET_PASSWORD'
}

export type SifeConfirmSignInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SifeDocumentTypeEnum>;
};

export type SifeContactMethods = {
  __typename?: 'SifeContactMethods';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SifeContactMethodsInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type SifeContactMethodsResponse = ResourceNotFound | SifeContactMethods;

export type SifeDataInput = {
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export enum SifeDocumentTypeEnum {
  Document = 'DOCUMENT',
  Receipt = 'RECEIPT'
}

export type SifeError = {
  __typename?: 'SifeError';
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type SifeResendActivationResult = Success | UserAlreadyActive | UserNotFound;

export type SifeResendVerificationLinkInput = {
  _id: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};

export type SifeResendVerificationLinkResult = NotEmployeeError | Success | UserAlreadyExists | UserNotFound | ValidationError;

export type SifeSendDocumentInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SifeDocumentTypeEnum>;
};

export type SifeSendDocumentResult = InvalidToken | SentDocument | TokenExpired | UserNotFound;

export type SifeSendRecoveryInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  contactMethod: ContactMethods;
  email?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type SifeSendRecoveryResult = Success | UserAlreadyActive | UserIsCarta | UserNotFound;

export type SifeSendVerificationCodeInput = {
  contactMethod?: InputMaybe<ContactMethods>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type SifeSendVerificationCodeResult = Success | UserAlreadyExists | UserNotFound | ValidationError;

export type SifeVerifyContactMethodInput = {
  contactMethod?: InputMaybe<ContactMethods>;
  token?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type SifeVerifyContactMethodResult = OtpNotValid | Success | TokenExpired | TokenNotValid | UserNotFound | ValidationError;

export type SignOnboardingDocumentsStep = {
  __typename?: 'SignOnboardingDocumentsStep';
  completed: Scalars['Boolean']['output'];
  pendingDocuments: Array<OnboardingDocument>;
};

export enum SignStatusEnum {
  All = 'ALL',
  Signed = 'SIGNED',
  Unsignable = 'UNSIGNABLE',
  Unsigned = 'UNSIGNED'
}

export type Signature = {
  __typename?: 'Signature';
  cryptoSignature?: Maybe<CryptoSignature>;
};

export type SignatureValidationFailed = {
  __typename?: 'SignatureValidationFailed';
  message?: Maybe<Scalars['String']['output']>;
};

export type Signatures = {
  __typename?: 'Signatures';
  signAt?: Maybe<Scalars['Date']['output']>;
  signBy?: Maybe<Scalars['String']['output']>;
};

export type SignedDocumentXmlFormatResult = {
  __typename?: 'SignedDocumentXmlFormatResult';
  url?: Maybe<Scalars['String']['output']>;
};

export type SignedFileXmlValidatorResult = InvalidXmlFormat | ResourceNotFound | UnknowError | ValidationStatus;

export type SignedReceiptXmlFormatResult = {
  __typename?: 'SignedReceiptXmlFormatResult';
  url?: Maybe<Scalars['String']['output']>;
};

export type SignerItem = {
  __typename?: 'SignerItem';
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  isSigned?: Maybe<Scalars['Boolean']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Signers = {
  __typename?: 'Signers';
  employeeId?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  isSigned?: Maybe<Scalars['Boolean']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SignersConfig = {
  __typename?: 'SignersConfig';
  companySignersSignInOrder?: Maybe<Scalars['Boolean']['output']>;
  currentSigner?: Maybe<Scalars['String']['output']>;
  employeeSignsFirst?: Maybe<Scalars['Boolean']['output']>;
  signInOrder?: Maybe<Scalars['Boolean']['output']>;
};

export type SignersConfigInput = {
  companySignersSignInOrder: Scalars['Boolean']['input'];
  employeeSignsFirst: Scalars['Boolean']['input'];
  signInOrder: Scalars['Boolean']['input'];
};

export type SignersConfigItem = {
  __typename?: 'SignersConfigItem';
  companySignersSignInOrder?: Maybe<Scalars['Boolean']['output']>;
  employeeSignsFirst?: Maybe<Scalars['Boolean']['output']>;
  signInOrder?: Maybe<Scalars['Boolean']['output']>;
};

export type SoraModule = {
  __typename?: 'SoraModule';
  active: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
  updatedBy: SoraModuleUpdater;
};

export type SoraModuleUpdater = {
  __typename?: 'SoraModuleUpdater';
  _id: Scalars['String']['output'];
  curp?: Maybe<Scalars['String']['output']>;
  lastNameM: Scalars['String']['output'];
  lastNameP: Scalars['String']['output'];
  names: Scalars['String']['output'];
  rfc?: Maybe<Scalars['String']['output']>;
};

export type SoraModulesConfiguration = {
  ai: AiModuleConfiguration;
  documents: Scalars['Boolean']['input'];
  holidays: Scalars['Boolean']['input'];
  rest: Scalars['Boolean']['input'];
};

export enum SortOrderEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortingAndPaging = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type Status = {
  __typename?: 'Status';
  endDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type StringArrayValidationResult = {
  __typename?: 'StringArrayValidationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  providedValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  usedValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type StringValidationResult = {
  __typename?: 'StringValidationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  providedValue?: Maybe<Scalars['String']['output']>;
  usedValue?: Maybe<Scalars['String']['output']>;
};

export type SubCompany = {
  __typename?: 'SubCompany';
  _id?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  averageActiveUsersByMonth?: Maybe<Scalars['Float']['output']>;
  base?: Maybe<Scalars['Float']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  costByUser?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  exceededUsers?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<Scalars['String']['output']>;
};

export type Subcategory = {
  __typename?: 'Subcategory';
  _id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type SubtractPerception = {
  __typename?: 'SubtractPerception';
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  concept: Scalars['String']['output'];
  conceptType?: Maybe<ConceptType>;
  previousId?: Maybe<Scalars['String']['output']>;
  showNegative: Scalars['Boolean']['output'];
  timestamps?: Maybe<TimeStampObj>;
  useSatCode: Scalars['Boolean']['output'];
};

export type Success = {
  __typename?: 'Success';
  message?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SuperAdminCompanyPermissions = {
  __typename?: 'SuperAdminCompanyPermissions';
  billing: CompanyPermission;
  companyData: CompanyPermission;
  consumption: CompanyPermission;
  legalRepresentative: CompanyPermission;
  modules: CompanyPermission;
  rolesAndPermissions: CompanyPermission;
  signDocuments: CompanyPermission;
  superAdmins: CompanyPermission;
};

export type SuperAdminCompanyPermissionsInput = {
  billing: CompanyPermissionInput;
  companyData: CompanyPermissionInput;
  consumption: CompanyPermissionInput;
  legalRepresentative: CompanyPermissionInput;
  modules: CompanyPermissionInput;
  rolesAndPermissions: CompanyPermissionInput;
  signDocuments: CompanyPermissionInput;
  superAdmins: CompanyPermissionInput;
};

export type SuperAdminCompanyUserPermissions = {
  __typename?: 'SuperAdminCompanyUserPermissions';
  billing: CompanyUserPermission;
  companyData: CompanyUserPermission;
  consumption: CompanyUserPermission;
  legalRepresentative: CompanyUserPermission;
  modules: CompanyUserPermission;
  rolesAndPermissions: CompanyUserPermission;
  signDocuments: CompanyUserPermission;
  superAdmins: CompanyUserPermission;
};

export type SuperAdminCompanyUserPermissionsInput = {
  billing: CompanyUserPermissionInput;
  companyData: CompanyUserPermissionInput;
  consumption: CompanyUserPermissionInput;
  legalRepresentative: CompanyUserPermissionInput;
  modules: CompanyUserPermissionInput;
  rolesAndPermissions: CompanyUserPermissionInput;
  signDocuments: CompanyUserPermissionInput;
  superAdmins: CompanyUserPermissionInput;
};

export type SuperAdminPermissions = {
  __typename?: 'SuperAdminPermissions';
  companyPermissions: SuperAdminCompanyPermissions;
  rhPodPermissions: SuperAdminRhPodPermissions;
};

export type SuperAdminPermissionsInput = {
  companyPermissions: SuperAdminCompanyPermissionsInput;
  rhPodPermissions: SuperAdminRhPodPermissionsInput;
};

export type SuperAdminRhPodPermissions = {
  __typename?: 'SuperAdminRhPodPermissions';
  approveDocsFromEmployees: CompanyPermission;
  authorizeTemplates: CompanyPermission;
  companyGroupReports: CompanyPermission;
  dashboard: CompanyPermission;
  documents: CompanyPermission;
  employees: CompanyPermission;
  employeesStatus: CompanyPermission;
  groups: CompanyPermission;
  holidays: CompanyPermission;
  hrAdmins: CompanyPermission;
  legalRepresentative: CompanyPermission;
  publishTemplates: CompanyPermission;
  receipts: CompanyPermission;
  recordChecklist: CompanyPermission;
  requestDocsToEmployees: CompanyPermission;
  templates: CompanyPermission;
  videoAgreementAuthorizer: CompanyPermission;
  videoAgreementTemplates: CompanyPermission;
  workCenters: CompanyPermission;
  workTitles: CompanyPermission;
};

export type SuperAdminRhPodPermissionsInput = {
  approveDocsFromEmployees: CompanyPermissionInput;
  authorizeTemplates: CompanyPermissionInput;
  companyGroupReports: CompanyPermissionInput;
  dashboard: CompanyPermissionInput;
  documents: CompanyPermissionInput;
  employees: CompanyPermissionInput;
  employeesStatus: CompanyPermissionInput;
  groups: CompanyPermissionInput;
  holidays: CompanyPermissionInput;
  hrAdmins: CompanyPermissionInput;
  legalRepresentative: CompanyPermissionInput;
  publishTemplates: CompanyPermissionInput;
  receipts: CompanyPermissionInput;
  recordChecklist: CompanyPermissionInput;
  requestDocsToEmployees: CompanyPermissionInput;
  templates: CompanyPermissionInput;
  videoAgreementAuthorizer: CompanyPermissionInput;
  videoAgreementTemplates: CompanyPermissionInput;
  workCenters: CompanyPermissionInput;
  workTitles: CompanyPermissionInput;
};

export type SuperAdminRhPodUserPermissions = {
  __typename?: 'SuperAdminRhPodUserPermissions';
  approveDocsFromEmployees: CompanyUserPermission;
  authorizeTemplates: CompanyUserPermission;
  companyGroupReports: CompanyUserPermission;
  dashboard: CompanyUserPermission;
  documents: CompanyUserPermission;
  employees: CompanyUserPermission;
  employeesStatus: CompanyUserPermission;
  groups: CompanyUserPermission;
  holidays: CompanyUserPermission;
  hrAdmins: CompanyUserPermission;
  legalRepresentative: CompanyUserPermission;
  publishTemplates: CompanyUserPermission;
  receipts: CompanyUserPermission;
  recordChecklist: CompanyUserPermission;
  requestDocsToEmployees: CompanyUserPermission;
  templates: CompanyUserPermission;
  videoAgreementAuthorizer: CompanyUserPermission;
  videoAgreementTemplates: CompanyUserPermission;
  workCenters: CompanyUserPermission;
  workTitles: CompanyUserPermission;
};

export type SuperAdminRhPodUserPermissionsInput = {
  approveDocsFromEmployees: CompanyUserPermissionInput;
  authorizeTemplates: CompanyUserPermissionInput;
  companyGroupReports: CompanyUserPermissionInput;
  dashboard: CompanyUserPermissionInput;
  documents: CompanyUserPermissionInput;
  employees: CompanyUserPermissionInput;
  employeesStatus: CompanyUserPermissionInput;
  groups: CompanyUserPermissionInput;
  holidays: CompanyUserPermissionInput;
  hrAdmins: CompanyUserPermissionInput;
  legalRepresentative: CompanyUserPermissionInput;
  publishTemplates: CompanyUserPermissionInput;
  receipts: CompanyUserPermissionInput;
  recordChecklist: CompanyUserPermissionInput;
  requestDocsToEmployees: CompanyUserPermissionInput;
  templates: CompanyUserPermissionInput;
  videoAgreementAuthorizer: CompanyUserPermissionInput;
  videoAgreementTemplates: CompanyUserPermissionInput;
  workCenters: CompanyUserPermissionInput;
  workTitles: CompanyUserPermissionInput;
};

export type SuperAdminRoles = {
  __typename?: 'SuperAdminRoles';
  permissions: SuperAdminPermissions;
};

export type SuperAdminRolesInput = {
  permissions: SuperAdminPermissionsInput;
};

export type SuperAdminUserPermissions = {
  __typename?: 'SuperAdminUserPermissions';
  companyPermissions: SuperAdminCompanyUserPermissions;
  rhPodPermissions: SuperAdminRhPodUserPermissions;
};

export type SuperAdminUserPermissionsInput = {
  companyPermissions: SuperAdminCompanyUserPermissionsInput;
  rhPodPermissions: SuperAdminRhPodUserPermissionsInput;
};

export type Template = {
  __typename?: 'Template';
  _id?: Maybe<Scalars['String']['output']>;
  authorizations?: Maybe<Array<Maybe<AuthorizationResult>>>;
  categories?: Maybe<CategoriesResult>;
  color?: Maybe<ColorResult>;
  createdBy?: Maybe<CreatorUser>;
  description?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<Maybe<TemplateHistoryItem>>>;
  orderConfig?: Maybe<TemplateOrderConfig>;
  status?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplateApproved = {
  __typename?: 'TemplateApproved';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TemplateCreated = {
  __typename?: 'TemplateCreated';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<TemplateCreatedItem>;
};

export type TemplateCreatedItem = {
  __typename?: 'TemplateCreatedItem';
  _id?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<CategoriesResult>;
  color?: Maybe<ColorResult>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplateDeleted = {
  __typename?: 'TemplateDeleted';
  _id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplateHistoryItem = {
  __typename?: 'TemplateHistoryItem';
  action?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserReference>;
  timestamps?: Maybe<TimeStampObj>;
};

export type TemplateOrderConfig = {
  __typename?: 'TemplateOrderConfig';
  authorizeInOrder?: Maybe<Scalars['Boolean']['output']>;
  currentAuthorizer?: Maybe<Scalars['String']['output']>;
};

export type TemplatePublished = {
  __typename?: 'TemplatePublished';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TemplateRejected = {
  __typename?: 'TemplateRejected';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TemplateResult = {
  __typename?: 'TemplateResult';
  _id?: Maybe<Scalars['String']['output']>;
  authorizers?: Maybe<Array<Maybe<AuthorizationResult>>>;
  categories?: Maybe<CategoriesResult>;
  color?: Maybe<ColorResult>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  orderConfig?: Maybe<TemplateOrderConfig>;
  status?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplateUpdated = {
  __typename?: 'TemplateUpdated';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<TemplateUpdatedItem>;
};

export type TemplateUpdatedItem = {
  __typename?: 'TemplateUpdatedItem';
  _id?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<CategoriesResult>;
  color?: Maybe<ColorResult>;
  description?: Maybe<Scalars['String']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplatesCountersResult = {
  __typename?: 'TemplatesCountersResult';
  pending?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Int']['output']>;
  ready_to_publish?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TemplatesResult = {
  __typename?: 'TemplatesResult';
  creatorUsers?: Maybe<Array<Maybe<CreatorUser>>>;
  templates?: Maybe<Array<Maybe<Template>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TimeStampObj = {
  __typename?: 'TimeStampObj';
  createdAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TimeStampObjInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type TimestampsAuthorizers = {
  __typename?: 'TimestampsAuthorizers';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  rejectedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TimestampsItem = {
  __typename?: 'TimestampsItem';
  createdAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TokenExpired = ErrorMessage & {
  __typename?: 'TokenExpired';
  message?: Maybe<Scalars['String']['output']>;
};

export type TokenNotValid = ErrorMessage & {
  __typename?: 'TokenNotValid';
  message?: Maybe<Scalars['String']['output']>;
};

export type TokenPermissions = {
  __typename?: 'TokenPermissions';
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  method?: Maybe<HttpMethods>;
  route?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
};

export type TokenPermissionsInput = {
  hasAccess?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<HttpMethods>;
  route?: InputMaybe<Scalars['String']['input']>;
};

export type TotalRececeiptsSentDashboardResult = {
  __typename?: 'TotalRececeiptsSentDashboardResult';
  data?: Maybe<Array<Maybe<AdminDashboardChart>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum TourCompletionEnum {
  Finish = 'FINISH',
  Skip = 'SKIP'
}

export type TourCompletitionInfo = {
  __typename?: 'TourCompletitionInfo';
  completition?: Maybe<TourCompletionEnum>;
  completitionDate?: Maybe<Scalars['Date']['output']>;
  tourName: Scalars['String']['output'];
};

export type UnauthorizedResource = {
  __typename?: 'UnauthorizedResource';
  message?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
};

export type UnknowError = ErrorMessage & {
  __typename?: 'UnknowError';
  message?: Maybe<Scalars['String']['output']>;
};

export type UnsupportedDocumentXmlValidation = {
  __typename?: 'UnsupportedDocumentXmlValidation';
  message?: Maybe<Scalars['String']['output']>;
};

export type UnsupportedReciptXmlValidation = {
  __typename?: 'UnsupportedReciptXmlValidation';
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateAuthorizersTeamInput = {
  authorizersIds: Array<InputMaybe<Scalars['String']['input']>>;
  authorizersTeamId: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  sendToAllEmployees: Scalars['Boolean']['input'];
  signInOrder: Scalars['Boolean']['input'];
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAuthorizersTeamResult = Error | Success;

export type UpdateCategoryInput = {
  category: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
};

export type UpdateCategoryResult = ErrorUpdateCategory | Success;

export type UpdateCompanyConfigResult = CompanyNotFound | Success;

export type UpdateCompanyInput = {
  _id: Scalars['String']['input'];
  alias?: InputMaybe<Scalars['String']['input']>;
  base?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  costByUser?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isItAMexicanCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isItASubsidiaryCompany?: InputMaybe<Scalars['Boolean']['input']>;
  largeLogo?: InputMaybe<Scalars['Upload']['input']>;
  largeLogoEmail?: InputMaybe<Scalars['Upload']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameToInvoice?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Period>;
  plants?: InputMaybe<Scalars['Int']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyNotificationsConfigInput = {
  active: Scalars['Boolean']['input'];
  periodicity: PeriodicityEnum;
  weekDay: Scalars['Int']['input'];
};

export type UpdateCompanyNotificationsConfigResponse = Company | Error | Success;

export type UpdateCompanySignerNotificationsConfigInput = {
  disableCompanySignerNotifications?: InputMaybe<DisableCompanySignerNotificationsInput>;
  groupCompanySignerNotifications?: InputMaybe<GroupCompanySignerNotificationsInput>;
};

export type UpdateCompanySignerNotificationsConfigResult = {
  __typename?: 'UpdateCompanySignerNotificationsConfigResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCreditStatusInput = {
  finished: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type UpdateCreditStatusResult = NoCreditStatusUpdated | Success;

export type UpdateEmployeeAbsenceFinalResult = ErrorToUpdateEmployeeAbsence | UpdateEmployeeAbsenceResult;

export type UpdateEmployeeAbsenceInput = {
  absenceId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateFile?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  updateStatusToEndAbsent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEmployeeAbsenceResult = {
  __typename?: 'UpdateEmployeeAbsenceResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateEmployeeDocumentScheduledForResult = Error | Success;

export type UpdateEmployeeInfoRequiredFinalResult = ErrorToUpdateEmployeeInfoRequired | UpdateEmployeeInfoRequiredResult;

export type UpdateEmployeeInfoRequiredInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeInfo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeInfoRequiredResult = {
  __typename?: 'UpdateEmployeeInfoRequiredResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateEmployeeRecordData = {
  category: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  subcategory: Scalars['String']['input'];
};

export type UpdateEmployeeWorkTitlesInput = {
  employeeIdsToExclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  employeeIdsToUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originWorkTitle: Scalars['String']['input'];
  targetWorkTitle: Scalars['String']['input'];
};

export type UpdateEmployeeWorkTitlesResult = InvalidWorkTitle | ResourceNotFound | UpdateEmployeeWorkTitlesSuccess;

export type UpdateEmployeeWorkTitlesSuccess = {
  __typename?: 'UpdateEmployeeWorkTitlesSuccess';
  employeesUpdated?: Maybe<Scalars['Int']['output']>;
};

export type UpdateGroupInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
};

export type UpdateGroupResult = GroupAlreadyExists | GroupUpdated | ResourceNotFound;

export type UpdateHolidayInput = {
  _id: Scalars['String']['input'];
  color: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type UpdateHolidayResult = Error | Success;

export type UpdateHolidaySchemeInput = {
  approveTemplateId: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidaySchemeId: Scalars['String']['input'];
  holidayTakenTemplateId?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<Array<InputMaybe<HolidaySchemeInput>>>;
  title: Scalars['String']['input'];
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateHolidaySchemeResult = Error | Success;

export type UpdateInfoRequestedByCompany = {
  completedBy: Scalars['String']['input'];
  optional: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type UpdateInfoRequestedByCompanyFilterInput = {
  companyId: Scalars['String']['input'];
  fieldsToUpdate?: InputMaybe<Array<InputMaybe<UpdateInfoRequestedByCompany>>>;
};

export type UpdateInfoRequestedByCompanyFinalResult = ErrorToUpdateInfoRequestedByCompany | UpdateInfoRequestedByCompanyResult;

export type UpdateInfoRequestedByCompanyResult = {
  __typename?: 'UpdateInfoRequestedByCompanyResult';
  requestedInfoToUsers?: Maybe<Array<Maybe<GetInfoRequestedByCompany>>>;
};

export type UpdateMultiEmployeeGroupsError = {
  __typename?: 'UpdateMultiEmployeeGroupsError';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateMultiEmployeeGroupsErrors = {
  __typename?: 'UpdateMultiEmployeeGroupsErrors';
  errors?: Maybe<Array<Maybe<UpdateMultiEmployeeGroupsError>>>;
};

export type UpdateMultiEmployeeGroupsInput = {
  skipErrors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMultiEmployeeGroupsSuccess = {
  __typename?: 'UpdateMultiEmployeeGroupsSuccess';
  employeesUpdated?: Maybe<Scalars['Int']['output']>;
};

export type UpdateRecordChecklistInput = {
  _id: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentTags?: InputMaybe<Array<InputMaybe<RecordChecklistDocumentTagInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecordChecklistResult = RecordChecklist | RecordChecklistAlreadyExists | RecordChecklistInvalidDocumentTags | ResourceNotFound;

export type UpdateSubcategoryInput = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  subcategory: Scalars['String']['input'];
  subcategoryId: Scalars['String']['input'];
};

export type UpdateSubcategoryResult = ErrorUpdateSubcategory | Success;

export type UpdateTemplateInput = {
  _id: Scalars['String']['input'];
  authorizeInOrder?: InputMaybe<Scalars['Boolean']['input']>;
  authorizers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<CategoriesInput>;
  color: ColorInput;
  comments?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excludeUpdates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  htmlContent: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateTemplateResult = ErrorToUpdateTemplate | ResourceNotFound | TemplateUpdated;

export type UpdateUserDataChangeRequestResult = GeneralError | Success;

export enum UpdateUserIdentityValidationStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type UpdateUserIdentityValidationStatusInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status: UpdateUserIdentityValidationStatus;
  userId: Scalars['String']['input'];
};

export type UpdateUserIdentityValidationStatusResult = {
  __typename?: 'UpdateUserIdentityValidationStatusResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserPermissionsInput = {
  permissions: UserPermissionsInput;
  role?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateVideoAgreementTemplateInput = {
  _id: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVideoAgreementTemplateResult = VideoAgreementTemplate | VideoAgreementTemplateAlreadyExists;

export type UpdateWorkCenterDataInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  code: Scalars['String']['input'];
  colony?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  externalNumber: Scalars['String']['input'];
  internalNumber?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  workCenterId: Scalars['String']['input'];
};

export type UpdateWorkTitleInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
};

export type UpdateWorkTitleResult = ResourceNotFound | WorkTitleAlreadyExists | WorkTitleUpdated;

export type UploadEmployeeRecordDocType = {
  category?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type UploadEmployeeRecordsResult = Success | UserIsntEmployee;

export type UploadPendingDocumentInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  adminUploadDocument?: InputMaybe<Scalars['Boolean']['input']>;
  category: Scalars['String']['input'];
  responseAi?: InputMaybe<AiResponseUploadDocType>;
  subcategory: Scalars['String']['input'];
  uploadDocumentWithAi?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UploadReceiptPdfResponse = UploadReceiptPdfValidation | UploadReceiptPdfValidationErrors;

export type UploadReceiptPdfValidation = {
  __typename?: 'UploadReceiptPdfValidation';
  receiptValidation?: Maybe<Array<Maybe<PdfReceiptValidationData>>>;
  requestKey?: Maybe<Scalars['String']['output']>;
  requestStamps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadReceiptPdfValidationError = {
  __typename?: 'UploadReceiptPdfValidationError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type UploadReceiptPdfValidationErrors = {
  __typename?: 'UploadReceiptPdfValidationErrors';
  errors?: Maybe<Array<Maybe<UploadReceiptPdfValidationError>>>;
};

export type UploadReceiptValidation = {
  __typename?: 'UploadReceiptValidation';
  csvFileUrl?: Maybe<Scalars['String']['output']>;
  receiptValidation?: Maybe<Array<Maybe<ReceiptValidationData>>>;
  requestKey?: Maybe<Scalars['String']['output']>;
  requestStamps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  wasThereErrors?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadRequestedDocumentsStep = {
  __typename?: 'UploadRequestedDocumentsStep';
  completed: Scalars['Boolean']['output'];
  totalPendingDocuments: Scalars['Int']['output'];
};

export type UploadSalaryNoRfcsFoundInExcel = {
  __typename?: 'UploadSalaryNoRfcsFoundInExcel';
  message?: Maybe<Scalars['String']['output']>;
};

export type UploadSalaryUsersNotFound = {
  __typename?: 'UploadSalaryUsersNotFound';
  rfcs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadSalaryWsNotFound = {
  __typename?: 'UploadSalaryWsNotFound';
  rfcs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadWorkCenterResult = {
  __typename?: 'UploadWorkCenterResult';
  workCenterAdminsValidation?: Maybe<Array<Maybe<WorkCenterAdminsValidation>>>;
  workCenterValidation?: Maybe<Array<Maybe<NewWorkCenterValidation>>>;
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Int']['output']>;
  allWorkCenterData?: Maybe<Array<Maybe<WorkCenterData>>>;
  alta?: Maybe<Scalars['String']['output']>;
  bajaDate?: Maybe<Scalars['Date']['output']>;
  beneficiaries?: Maybe<Array<Maybe<BeneficiaryEntity>>>;
  beneficiariesNotifications?: Maybe<BeneficiariesNotifications>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  documentsCounts?: Maybe<Counts>;
  email?: Maybe<Scalars['String']['output']>;
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasEverBeenActive?: Maybe<Scalars['Boolean']['output']>;
  hasFinishedRegistration?: Maybe<Scalars['Boolean']['output']>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hasPermissions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAdminFromBajaEmployee?: Maybe<Scalars['Boolean']['output']>;
  isEmployee?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['Date']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  legalStatus?: Maybe<LegalStatusType>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  previousReference?: Maybe<PreviousReference>;
  privacyPolicy?: Maybe<PrivacyPolicy>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  receiptCounts?: Maybe<Counts>;
  recordChecklistAssigned?: Maybe<RecordChecklistAssigned>;
  rfc?: Maybe<Scalars['String']['output']>;
  rol?: Maybe<Scalars['String']['output']>;
  sendMassiveOnboardingNotification?: Maybe<SendMassiveOnboardingNotification>;
  sentOnboardingNotification?: Maybe<SentOnboardingNotification>;
  signatures?: Maybe<Signature>;
  status?: Maybe<WorkSpaceStatusEnum>;
  timestamps?: Maybe<TimeStampObj>;
  tourCompletion?: Maybe<Array<Maybe<TourCompletitionInfo>>>;
  type?: Maybe<Scalars['String']['output']>;
  userWhoInvite?: Maybe<UserWhoInvite>;
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workCenterData?: Maybe<WorkCenterData>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workCenterIdAsEmployee?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type UserAddress = {
  __typename?: 'UserAddress';
  city?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  internalNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserAddressData = {
  __typename?: 'UserAddressData';
  city?: Maybe<Scalars['String']['output']>;
  colony?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  internalNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserAddressInput = {
  city: Scalars['String']['input'];
  colony: Scalars['String']['input'];
  country: Scalars['String']['input'];
  externalNumber: Scalars['String']['input'];
  internalNumber?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type UserAlreadyActive = ErrorMessage & {
  __typename?: 'UserAlreadyActive';
  esMessage?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserAlreadyExists = ErrorMessage & {
  __typename?: 'UserAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserAlreadyHasPassword = {
  __typename?: 'UserAlreadyHasPassword';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserAndWorkSpaceReferenceTypeDefs = {
  __typename?: 'UserAndWorkSpaceReferenceTypeDefs';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type UserAndWorkspaceAuthorizer = {
  __typename?: 'UserAndWorkspaceAuthorizer';
  _id?: Maybe<Scalars['String']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workSpaceStatus?: Maybe<Scalars['String']['output']>;
};

export type UserCompanySupport = {
  __typename?: 'UserCompanySupport';
  _id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
};

export type UserCounts = {
  __typename?: 'UserCounts';
  active?: Maybe<Scalars['Int']['output']>;
  baja?: Maybe<Scalars['Int']['output']>;
  inactive?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UserDataChangeRequest = {
  __typename?: 'UserDataChangeRequest';
  _id?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  employeeDocumentId?: Maybe<Scalars['String']['output']>;
  input?: Maybe<UserDataChangeRequestDataChanged>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserDataChangeRequestStatusEnum>;
  timestamps?: Maybe<TimeStampObj>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserDataChangeRequestDataChanged = {
  __typename?: 'UserDataChangeRequestDataChanged';
  curp?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
};

export type UserDataChangeRequestSent = {
  __typename?: 'UserDataChangeRequestSent';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserDataChangeRequestSentContactMethodsUpdated = {
  __typename?: 'UserDataChangeRequestSentContactMethodsUpdated';
  message?: Maybe<Scalars['String']['output']>;
};

export enum UserDataChangeRequestStatusEnum {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type UserDataInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alta?: InputMaybe<AltaEnum>;
  blockEmployeeOnBaja?: InputMaybe<Scalars['Boolean']['input']>;
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  payrollId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  workCenterId?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UserDoc = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UserDocUpload = {
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UserDocumentItem = {
  __typename?: 'UserDocumentItem';
  _id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  advancedFilter?: InputMaybe<AdvancedFilter>;
  alta?: InputMaybe<AltaEnum>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  hasLoggedIn?: InputMaybe<Scalars['Boolean']['input']>;
  permit?: InputMaybe<Scalars['Boolean']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WorkSpaceStatusEnum>;
  workCenterId?: InputMaybe<Scalars['String']['input']>;
};

export type UserHasNotWorkCenterAssigned = {
  __typename?: 'UserHasNotWorkCenterAssigned';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserIncompleteRegistration = ErrorMessage & {
  __typename?: 'UserIncompleteRegistration';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserInfoCompletionConfig = {
  __typename?: 'UserInfoCompletionConfig';
  active?: Maybe<Scalars['Boolean']['output']>;
  timestamps?: Maybe<TimeStampObj>;
  userInfoRequested?: Maybe<Array<Maybe<UserInfoRequestedByCompany>>>;
};

export type UserInfoCompletionInput = {
  active: Scalars['Boolean']['input'];
  userInfoRequested?: InputMaybe<Array<InputMaybe<UserInfoRequestedInput>>>;
};

export type UserInfoRequestedByCompany = {
  __typename?: 'UserInfoRequestedByCompany';
  completedBy?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UserInfoRequestedInput = {
  optional: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type UserIsCarta = ErrorMessage & {
  __typename?: 'UserIsCarta';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserIsNotAdmin = {
  __typename?: 'UserIsNotAdmin';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserIsRegisteredInMoreThanOneCompany = {
  __typename?: 'UserIsRegisteredInMoreThanOneCompany';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserIsntEmployee = {
  __typename?: 'UserIsntEmployee';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserMustBeSifeType = {
  __typename?: 'UserMustBeSifeType';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserNotFound = ErrorMessage & {
  __typename?: 'UserNotFound';
  esMessage?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserOnboardingCompanyRequirements = {
  __typename?: 'UserOnboardingCompanyRequirements';
  infoRequested?: Maybe<Array<Maybe<UserInfoRequestedByCompany>>>;
  pendingDocuments?: Maybe<Array<Maybe<RequestedEmployeeDocument>>>;
};

export type UserOnboardingGeneralRequirements = {
  __typename?: 'UserOnboardingGeneralRequirements';
  infoRequired?: Maybe<Array<Maybe<UserOnboardingInfoRequired>>>;
};

export type UserOnboardingInfoRequired = {
  __typename?: 'UserOnboardingInfoRequired';
  completedAt?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<DataCompletionStatusEnum>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UserOnboardingResult = {
  __typename?: 'UserOnboardingResult';
  companyRequirements?: Maybe<UserOnboardingCompanyRequirements>;
  generalRequirements?: Maybe<UserOnboardingGeneralRequirements>;
};

export type UserOnboardingSteps = {
  __typename?: 'UserOnboardingSteps';
  completeBeneficiaries: CompleteBeneficiariesStep;
  completeRequestedInformation: CompleteRequestedInformationStep;
  createElectronicSignature: CreateElectronicSignatureStep;
  onboardingStatus: OnboardingStatus;
  signOnboardingDocuments: SignOnboardingDocumentsStep;
  uploadRequestedDocuments: UploadRequestedDocumentsStep;
  verifyIdentity: VeifyIdentityStep;
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  adminRh?: Maybe<AdminRhUserPermissions>;
  adminWC?: Maybe<AdminWcUserPermissions>;
  superAdmin?: Maybe<SuperAdminUserPermissions>;
};

export type UserPermissionsInput = {
  adminRh?: InputMaybe<AdminRhUserPermissionsInput>;
  adminWC?: InputMaybe<AdminWcUserPermissionsInput>;
  superAdmin?: InputMaybe<SuperAdminUserPermissionsInput>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  counts?: Maybe<UserProfileCounts>;
  documents?: Maybe<Array<Maybe<Document>>>;
  receipts?: Maybe<Array<Maybe<Receipt>>>;
  recordChecklistAssignedDocuments?: Maybe<RecordChecklistAssignedDocumentsResult>;
  recordChecklistAssignedDocumentsCounts?: Maybe<RecordChecklistAssignedDocumentsCountsResult>;
  user?: Maybe<User>;
};

export type UserProfileCounts = {
  __typename?: 'UserProfileCounts';
  signedDocuments?: Maybe<Scalars['Int']['output']>;
  signedReceipts?: Maybe<Scalars['Int']['output']>;
  totalDocuments?: Maybe<Scalars['Int']['output']>;
  totalReceipts?: Maybe<Scalars['Int']['output']>;
  unsignedDocuments?: Maybe<Scalars['Int']['output']>;
  unsignedReceipts?: Maybe<Scalars['Int']['output']>;
};

export type UserProfileResult = UserNotFound | UserProfile;

export type UserReference = {
  __typename?: 'UserReference';
  _id?: Maybe<Scalars['String']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
};

export type UserReferenceVerifyEmployeeData = {
  __typename?: 'UserReferenceVerifyEmployeeData';
  otherData?: Maybe<OtherVerifiedData>;
  user?: Maybe<UserVerifyData>;
  workCenter?: Maybe<WorkCenterVerifyData>;
  workSpace?: Maybe<WorkSpaceVerifyData>;
};

export type UserReferenceWithProfilePicture = {
  __typename?: 'UserReferenceWithProfilePicture';
  _id: Scalars['String']['output'];
  curp: Scalars['String']['output'];
  lastNameM: Scalars['String']['output'];
  lastNameP: Scalars['String']['output'];
  names: Scalars['String']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc: Scalars['String']['output'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  Baja = 'BAJA',
  Preregistered = 'PREREGISTERED'
}

export type UserSupport = {
  __typename?: 'UserSupport';
  _id?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<Maybe<UserCompanySupport>>>;
  contactMethods?: Maybe<ContactVerificationMethod>;
  curp?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endRegistrationToken?: Maybe<EndRegistrationToken>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  rhPod?: Maybe<RhPod>;
};

export type UserValidationInputError = {
  __typename?: 'UserValidationInputError';
  email?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  wcCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserValidationResult = {
  __typename?: 'UserValidationResult';
  errors?: Maybe<UserValidationInputError>;
  passed?: Maybe<Scalars['Boolean']['output']>;
};

export type UserVerifyData = {
  __typename?: 'UserVerifyData';
  _id?: Maybe<Scalars['String']['output']>;
  address?: Maybe<UserAddressData>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  socialSecurityNumber?: Maybe<Scalars['String']['output']>;
};

export type UserWhoInvite = {
  __typename?: 'UserWhoInvite';
  _id?: Maybe<Scalars['String']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
};

export type UsersBilling = {
  __typename?: 'UsersBilling';
  averageByQ?: Maybe<Scalars['Float']['output']>;
  base?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  fluctuation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  nameToInvoice?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  periods?: Maybe<Array<Maybe<CompanyPeriods>>>;
};

export type UsersBillingResult = {
  __typename?: 'UsersBillingResult';
  companies?: Maybe<Array<Maybe<UsersBilling>>>;
  periods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type UsersBillingType = {
  __typename?: 'UsersBillingType';
  base?: Maybe<Scalars['String']['output']>;
  costByUser?: Maybe<Scalars['String']['output']>;
};

export type ValidateCreditPaymentsResult = CreditPaymentValidations | EmptyCreditPaymentsTemplate;

export type ValidateUserInfoInput = {
  file?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateUserInfoResult = ErrorToValidateUserInfo | FinalResponseValidateUserInfo;

export type ValidateXmlLookup = {
  __typename?: 'ValidateXmlLookup';
  filename?: Maybe<Scalars['String']['output']>;
  receiptDetails?: Maybe<XmlValidationReceiptDetails>;
  receiptsFound?: Maybe<Array<Maybe<XmlValidationReceiptsFound>>>;
  stampUuid?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  field?: Maybe<Scalars['String']['output']>;
  validationMessage?: Maybe<Scalars['String']['output']>;
};

export type ValidationStatus = {
  __typename?: 'ValidationStatus';
  status?: Maybe<ValidationStatusEnum>;
};

export enum ValidationStatusEnum {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type ValidityFilter = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type VeifyIdentityStep = {
  __typename?: 'VeifyIdentityStep';
  completed: Scalars['Boolean']['output'];
  videoAgreementTextToRead: Scalars['String']['output'];
};

export enum VerificationTypeEnum {
  LivenessIdMatch = 'LIVENESS_ID_MATCH',
  LivenessVideoAgreement = 'LIVENESS_VIDEO_AGREEMENT'
}

export type VerifyEmployeeDataFinalResult = ErrorToVerifyEmployeeData | VerifyEmployeeDataResult;

export type VerifyEmployeeDataInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedVariables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sendAll?: InputMaybe<Scalars['Boolean']['input']>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VerifyEmployeeDataResult = {
  __typename?: 'VerifyEmployeeDataResult';
  errorsData?: Maybe<Array<Maybe<ErrorData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  successData?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VerifyPendingDocumentWithAiFinalResult = ErrorToVerifyPendingDocumentWithAi | LimitExceededError | VerifyPendingDocumentWithAiResult;

export type VerifyPendingDocumentWithAiInput = {
  categoryId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  subcategoryId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type VerifyPendingDocumentWithAiResult = {
  __typename?: 'VerifyPendingDocumentWithAiResult';
  imssResponse?: Maybe<ImssEntity>;
  message?: Maybe<Scalars['String']['output']>;
  satResponse?: Maybe<SatAiEntity>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VideoAgreement = {
  __typename?: 'VideoAgreement';
  _id?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type VideoAgreementTemplate = {
  __typename?: 'VideoAgreementTemplate';
  _id?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type VideoAgreementTemplateAlreadyExists = {
  __typename?: 'VideoAgreementTemplateAlreadyExists';
  name?: Maybe<Scalars['String']['output']>;
};

export type WcCompany = {
  __typename?: 'WcCompany';
  _id?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  workCenters?: Maybe<Array<Maybe<WorkCenter>>>;
};

export type WorkCenter = {
  __typename?: 'WorkCenter';
  _id?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  addressData?: Maybe<AddressData>;
  adminData?: Maybe<Array<Maybe<User>>>;
  adminUsers?: Maybe<Array<Maybe<WorkCenterAdmin>>>;
  code?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  employeeCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<WorkCenterMessage>;
  name?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
};

export type WorkCenterAdmin = {
  __typename?: 'WorkCenterAdmin';
  active?: Maybe<Scalars['Boolean']['output']>;
  adminId?: Maybe<Scalars['String']['output']>;
  functionalities?: Maybe<FunctionalityObj>;
};

export type WorkCenterAdminInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  payrollId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc: Scalars['String']['input'];
  userType: WorkCenterAdminsImportType;
  wcCode?: InputMaybe<Scalars['String']['input']>;
  workTitle?: InputMaybe<Scalars['String']['input']>;
};

export type WorkCenterAdminResult = UserNotFound | WorkCenter | WorkCenterAlreadyExists | WorkCenterNotFound;

export type WorkCenterAdminsValidation = {
  __typename?: 'WorkCenterAdminsValidation';
  _id?: Maybe<Scalars['String']['output']>;
  curp?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  lastNameM?: Maybe<Scalars['String']['output']>;
  lastNameP?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  newUserValidation?: Maybe<NewUserImportValidationResult>;
  payrollId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rfc?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<WorkCenterAdminsImportType>;
  validationResult?: Maybe<UserValidationResult>;
  wcCode?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type WorkCenterAlreadyExists = ErrorMessage & {
  __typename?: 'WorkCenterAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkCenterData = {
  __typename?: 'WorkCenterData';
  active?: Maybe<Scalars['Boolean']['output']>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  employee?: Maybe<Scalars['Boolean']['output']>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
};

export type WorkCenterDataSupport = {
  __typename?: 'WorkCenterDataSupport';
  active?: Maybe<Scalars['Boolean']['output']>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  employee?: Maybe<Scalars['Boolean']['output']>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workCenterName?: Maybe<Scalars['String']['output']>;
};

export type WorkCenterDocumentItem = {
  __typename?: 'WorkCenterDocumentItem';
  _id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkCenterInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  code: Scalars['String']['input'];
  colony?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  externalNumber: Scalars['String']['input'];
  internalNumber?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
};

export type WorkCenterItem = {
  __typename?: 'WorkCenterItem';
  _id?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkCenterMessage = {
  __typename?: 'WorkCenterMessage';
  content?: Maybe<Scalars['String']['output']>;
  timestamps?: Maybe<TimeStampObj>;
};

export type WorkCenterNotFound = ErrorMessage & {
  __typename?: 'WorkCenterNotFound';
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkCenterReference = {
  __typename?: 'WorkCenterReference';
  _id: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type WorkCenterResult = ValidationError | WorkCenter | WorkCenterAlreadyExists;

export type WorkCenterVerifyData = {
  __typename?: 'WorkCenterVerifyData';
  _id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkCentersCodeAlreadyExists = ErrorMessage & {
  __typename?: 'WorkCentersCodeAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
  workCentersCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WorkCentersResult = {
  __typename?: 'WorkCentersResult';
  total?: Maybe<Scalars['Int']['output']>;
  workCenters?: Maybe<Array<Maybe<WorkCenter>>>;
};

export type WorkSpaceRolesType = {
  __typename?: 'WorkSpaceRolesType';
  companyId?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isAdminRh?: Maybe<Scalars['Boolean']['output']>;
  isEmployee?: Maybe<Scalars['String']['output']>;
  isMaster?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<Maybe<LoginPermission>>>;
};

export type WorkSpaceStatus = {
  __typename?: 'WorkSpaceStatus';
  endDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum WorkSpaceStatusEnum {
  Absent = 'ABSENT',
  Active = 'ACTIVE',
  Baja = 'BAJA',
  Preregistered = 'PREREGISTERED'
}

export type WorkSpaceVerifyData = {
  __typename?: 'WorkSpaceVerifyData';
  _id?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  employmentStartDate?: Maybe<Scalars['Date']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  workCenterId?: Maybe<Scalars['String']['output']>;
  workDayType?: Maybe<Scalars['String']['output']>;
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type WorkTitleAlreadyExists = {
  __typename?: 'WorkTitleAlreadyExists';
  workTitle?: Maybe<Scalars['String']['output']>;
};

export type WorkTitleAndGroupItem = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type WorkTitleCreated = {
  __typename?: 'WorkTitleCreated';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkTitleDeleted = {
  __typename?: 'WorkTitleDeleted';
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkTitleUpdated = {
  __typename?: 'WorkTitleUpdated';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkbookOptionsInput = {
  numOfCts?: InputMaybe<Scalars['Int']['input']>;
  preString?: InputMaybe<Scalars['String']['input']>;
};

export type WorkcenterCodeAlreadyExists = {
  __typename?: 'WorkcenterCodeAlreadyExists';
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type WorkcenterNotFound = {
  __typename?: 'WorkcenterNotFound';
  message?: Maybe<Scalars['String']['output']>;
};

export type XmlValidationReceiptDetails = {
  __typename?: 'XmlValidationReceiptDetails';
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentEndDate?: Maybe<Scalars['Date']['output']>;
  paymentStartDate?: Maybe<Scalars['Date']['output']>;
};

export type XmlValidationReceiptsFound = {
  __typename?: 'XmlValidationReceiptsFound';
  _id?: Maybe<Scalars['String']['output']>;
  paymentEndDate?: Maybe<Scalars['Date']['output']>;
  paymentStartDate?: Maybe<Scalars['Date']['output']>;
};

export type AdminHasNotPermission = {
  __typename?: 'adminHasNotPermission';
  message?: Maybe<Scalars['String']['output']>;
};

export type ConfirmReceiptPdfImportResponse = UploadReceiptPdfValidationErrors | ConfirmReceiptPdfImportResponseSuccess;

export type ConfirmReceiptPdfImportResponseSuccess = {
  __typename?: 'confirmReceiptPdfImportResponseSuccess';
  receipts?: Maybe<Array<Maybe<Receipt>>>;
};

export type ConfirmXmlReceiptsToLinkInput = {
  requestId: Scalars['String']['input'];
  solvingReceipts?: InputMaybe<Array<InputMaybe<SolvingReceiptsInput>>>;
  stampList: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ConfirmXmlReceiptsToLinkResult = SelectedPdfConflict | Success;

export type CreateCompanyAdminRhResult = AdminIncorrectInfo | CompanyNotFound | Success | UserAlreadyExists | ValidationError | WorkCenterNotFound;

export type CreateCompanyRespLetterInput = {
  clientName: Scalars['String']['input'];
  isItAMexicanCompany: Scalars['Boolean']['input'];
  isItASubsidiaryCompany: Scalars['Boolean']['input'];
  web?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyRespLetterResponse = {
  __typename?: 'createCompanyRespLetterResponse';
  documentId: Scalars['String']['output'];
};

export type CreateCompanyWorkCenterAdminResult = AdminIncorrectInfo | CompanyNotFound | Success | UserAlreadyExists | ValidationError | WorkCenterNotFound;

export type CreateDocumentResult = ErrorInDocument | FinalDocumentResponse;

export type CreateHolidayRequestInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  daysRequested?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  requestForYear?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateNewAccountInput = {
  email: Scalars['String']['input'];
  exisitingUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP: Scalars['String']['input'];
  names: Scalars['String']['input'];
};

export type DeleteAuthorizersTeamEmployeesInput = {
  authorizersTeamId: Scalars['String']['input'];
  employeesIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type DeleteEmployeesFromHolidaySchemeInput = {
  employeesIds: Array<InputMaybe<Scalars['String']['input']>>;
  holidaySchemeId: Scalars['String']['input'];
};

export type GetEmployeesByAuthorizersTeamInput = {
  authorizersTeamId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type GetEmployeesByAuthorizersTeamResult = {
  __typename?: 'getEmployeesByAuthorizersTeamResult';
  employees: Array<Maybe<EmployeeAssigned>>;
  total: Scalars['Int']['output'];
};

export type GetEmployeesByCollectiveCountInput = {
  employees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  getAllEmployeesTotal?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetEmployeesByHolidaySchemeInput = {
  holidaySchemeId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetEmployeesByHolidaySchemeResult = {
  __typename?: 'getEmployeesByHolidaySchemeResult';
  employees: Array<Maybe<EmployeeAssignedToScheme>>;
  total: Scalars['Int']['output'];
};

export type GetEmployeesWithPendingDocumentsResponse = {
  __typename?: 'getEmployeesWithPendingDocumentsResponse';
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetEmployeesWithPendingDocumentsUnionResponse = Error | GetEmployeesWithPendingDocumentsResponse;

export type ImportAuthorizersTeamInput = {
  file: Scalars['Upload']['input'];
};

export enum MethodEnum {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type SetTourCompletionInput = {
  completition?: InputMaybe<TourCompletionEnum>;
  completitionDate?: InputMaybe<Scalars['Date']['input']>;
  tourName: Scalars['String']['input'];
};

export type SolvingReceiptsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateActiveUserDataInput = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<UserAddressInput>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  curp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastNameM?: InputMaybe<Scalars['String']['input']>;
  lastNameP?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateActiveUserDataResult = GeneralError | Success | UserDataChangeRequestSent | UserDataChangeRequestSentContactMethodsUpdated | UserNotFound | ValidationError;

export type UpdateCompanyActiveModulesInput = {
  companyId: Scalars['String']['input'];
  modulesConfiguration: SoraModulesConfiguration;
};

export type UpdateCompanyActiveModulesResponse = ErrorUpdateCompanyActiveModules | Success;

export type UpdateEmployeeContactMethodsResult = EmailAlreadyInUse | NeedsContactMethods | SifeError | Success | UserIsRegisteredInMoreThanOneCompany | UserNotFound;

export type UpdateEmployeeDataResult = GeneralError | RfcAlreadyInUse | SifeError | Success | UserIsRegisteredInMoreThanOneCompany | UserNotFound;

export type UpdateEmployeeNominaDataResult = EmailAlreadyInUse | NeedsContactMethods | SifeError | Success | UserIsRegisteredInMoreThanOneCompany | UserNotFound | WorkcenterNotFound;

export type UpdateEmployeeRecordTypeResult = BelongToManyUsers | DocumentTypeUnchangeable | Success;

export type UpdateMultiEmployeeGroupsResult = EmptyExcelTemplate | UpdateMultiEmployeeGroupsErrors | UpdateMultiEmployeeGroupsSuccess;

export type UpdateUserPermissionsResult = Success | UserNotFound;

export type UpdateWcAdminWorkCentersInput = {
  userId: Scalars['String']['input'];
  workCenters: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UpdateWcAdminWorkCentersResult = Success | UserNotFound | WorkCenterNotFound;

export type UploadPdfOnlyForLinkingXmlInput = {
  file: Scalars['Upload']['input'];
  stampUuid: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UploadPdfOnlyForLinkingXmlResult = UserNotFound | UploadPdfOnlyForLinkingXmlSuccess;

export type UploadPdfOnlyForLinkingXmlSuccess = {
  __typename?: 'uploadPdfOnlyForLinkingXmlSuccess';
  requestId: Scalars['String']['output'];
};

export type ValidateXmlReceiptsToLinkResult = {
  __typename?: 'validateXmlReceiptsToLinkResult';
  fileLookupResume?: Maybe<Array<Maybe<ValidateXmlLookup>>>;
  receiptValidation?: Maybe<Array<Maybe<ReceiptValidationData>>>;
  requestKey?: Maybe<Scalars['String']['output']>;
  requestStamps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  wasThereErrors?: Maybe<Scalars['Boolean']['output']>;
  wasThereWarnings?: Maybe<Scalars['Boolean']['output']>;
};

export enum WorkCenterAdminsImportType {
  Existing = 'EXISTING',
  New = 'NEW',
  Previous = 'PREVIOUS'
}
